(function () {
  "use strict";

  const ATTR_GWP_MANAGED = "_gwp_managed";
  const ATTR_GWP_TIER = "_gwp_tier";
  const ATTR_GWP_SOURCE = "_gwp_source";

  const ATTR_FEE_MANAGED = "_qk_fee_managed";
  const ATTR_FEE_RULE = "_qk_fee_rule";
  const ATTR_FEE_SOURCE = "_qk_fee_source";
  const ATTR_FEE_SOURCE_VARIANT = "_qk_fee_source_variant";
  const ATTR_COD_FEE_MANAGED = "_qk_cod_fee_managed";
  const ATTR_COD_FEE_SOURCE = "_qk_cod_fee_source";

  const ATTR_GIFT_WRAP_SELECTED = "_qk_gift_wrap_selected";
  const ATTR_GIFT_WRAP_MANAGED = "_qk_gift_wrap_managed";
  const ATTR_GIFT_WRAP_SOURCE = "_qk_gift_wrap_source";
  const ATTR_PACKAGE_INSURANCE_SELECTED = "_qk_package_insurance_selected";
  const ATTR_PACKAGE_INSURANCE_MANAGED = "_qk_package_insurance_managed";
  const ATTR_PACKAGE_INSURANCE_SOURCE = "_qk_package_insurance_source";
  const ATTR_B2B_CHECKOUT = "_qk_b2b_checkout";

  const ATTR_LUBE_SELECTED = "_qk_lube_selected";
  const ATTR_LUBE_SCOPE = "_qk_lube_scope";
  const ATTR_LUBE_RULE = "_qk_lube_rule";
  const ATTR_LUBE_LAYOUT = "_qk_lube_layout";
  const ATTR_LUBE_MANAGED = "_qk_lube_managed";
  const ATTR_LUBE_SOURCE = "_qk_lube_source";
  const ATTR_LUBE_SOURCE_VARIANT = "_qk_lube_source_variant";
  const ATTR_LUBE_SELECTED_PUBLIC = "qk_lube_selected";
  const ATTR_LUBE_SCOPE_PUBLIC = "qk_lube_scope";
  const ATTR_LUBE_RULE_PUBLIC = "qk_lube_rule";
  const ATTR_LUBE_LAYOUT_PUBLIC = "qk_lube_layout";
  const ATTR_LUBE_MANAGED_PUBLIC = "qk_lube_managed";
  const ATTR_LUBE_SOURCE_PUBLIC = "qk_lube_source";
  const LUBE_PUBLIC_ATTR_KEYS = [
    ATTR_LUBE_SELECTED_PUBLIC,
    ATTR_LUBE_SCOPE_PUBLIC,
    ATTR_LUBE_RULE_PUBLIC,
    ATTR_LUBE_LAYOUT_PUBLIC,
    ATTR_LUBE_MANAGED_PUBLIC,
    ATTR_LUBE_SOURCE_PUBLIC,
  ];
  const ATTR_UPSELL_MANAGED_PUBLIC = "qk_upsell_managed";
  const ATTR_UPSELL_SOURCE_PUBLIC = "qk_upsell_source";
  const ATTR_UPSELL_PARENT_VARIANT_PUBLIC = "qk_upsell_parent_variant";
  const ATTR_UPSELL_DISCOUNT_PERCENT_PUBLIC = "qk_upsell_discount_percent";
  const UPSELL_PUBLIC_ATTR_KEYS = [
    ATTR_UPSELL_MANAGED_PUBLIC,
    ATTR_UPSELL_SOURCE_PUBLIC,
    ATTR_UPSELL_PARENT_VARIANT_PUBLIC,
    ATTR_UPSELL_DISCOUNT_PERCENT_PUBLIC,
  ];

  const ATTR_CFG_THRESHOLD_1 = "_gwp_threshold_1_ron";
  const ATTR_CFG_THRESHOLD_2 = "_gwp_threshold_2_ron";
  const ATTR_CFG_THRESHOLD_3 = "_gwp_threshold_3_ron";
  const ATTR_CFG_GIFT_1 = "_gwp_gift_product_1_id";
  const ATTR_CFG_GIFT_2 = "_gwp_gift_product_2_id";
  const ATTR_CFG_GIFT_3 = "_gwp_gift_product_3_id";
  const ATTR_CFG_TIER_1_ENABLED = "_gwp_tier_1_enabled";
  const ATTR_CFG_TIER_2_ENABLED = "_gwp_tier_2_enabled";
  const ATTR_CFG_TIER_3_ENABLED = "_gwp_tier_3_enabled";
  const ATTR_CFG_TIER_1_IN_STOCK = "_gwp_tier_1_in_stock";
  const ATTR_CFG_TIER_2_IN_STOCK = "_gwp_tier_2_in_stock";
  const ATTR_CFG_TIER_3_IN_STOCK = "_gwp_tier_3_in_stock";
  const ATTR_CFG_STACK_UNLOCKED = "_gwp_stack_unlocked_tiers";
  const ATTR_CFG_THRESHOLD_BASIS = "_gwp_subtotal_ex_gift_cents";
  const ATTR_CFG_HASH = "_gwp_config_hash";

  const SOURCE_STOREFRONT = "storefront_cart";
  const GIFT_WRAP_PRODUCT_LEGACY_ID = "8654529036622";
  const GIFT_WRAP_MODAL_ELEMENT_ID = "qk-gift-wrap-modal";
  const PACKAGE_INSURANCE_PRODUCT_LEGACY_ID = "9672531607886";
  const PACKAGE_INSURANCE_MODAL_ELEMENT_ID = "qk-package-insurance-modal";
  const COD_FEE_PRODUCT_LEGACY_ID = "7844391911639";
  const COD_FEE_VARIANT_LEGACY_ID = "43472430694615";
  const COD_FEE_FALLBACK_RULE_KEY = "cod_payment";
  const LUBE_SCOPE_KEYBOARD = "keyboard";
  const LUBE_SCOPE_SWITCH = "switch";
  const KNOWN_FEE_RULE_KEYS = [
    "heavy_keyboard",
    "casti_or_keyboards",
    "mouse_or_cable_not_mouse_cover",
  ];
  const PROGRESS_CACHE_PREFIX = "qk-progress-cache:v3:";
  const PROGRESS_TRUCK_ICON_SVG =
    '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"></rect><path d="M16 8h4l3 3v5h-7V8z"></path><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
  const GIFT_LOCK_ICON_SVG =
    '<svg class="qk-progress__lock-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z" stroke="currentColor" stroke-width="1.5"></path><path d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  const DEFAULT_FREE_SHIPPING_THRESHOLD_RON = 500;
  const LUBE_INTENT_STORAGE_KEY = "qk:lube-intent:v1";
  const LUBE_INTENT_TTL_MS = 3 * 60 * 1000;
  const LUBE_REMOVE_INTENT_TTL_MS = 2 * 60 * 1000;
  const LINE_MUTATION_DEBOUNCE_MS = 55;
  const LINE_MUTATION_SYNC_DEBOUNCE_MS = 120;
  const FAST_TOUCH_CLICK_SUPPRESSION_MS = 700;
  const FAST_TOUCH_PRESSED_RELEASE_MS = 130;
  const FAST_TOUCH_PRESSED_CLASS = "qk-cart-control--pressed";
  const CART_TRUST_COUNT_ANIMATION_MS = 640;
  const DISCOUNT_LINK_COOKIE_NAME = "discount_code";
  const DISCOUNT_LINK_TOAST_DURATION_MS = 5600;
  const DISCOUNT_LINK_TOAST_REMOVE_DELAY_MS = 650;
  const GIFT_STOCK_CACHE_TTL_MS = 60 * 1000;
  const GIFT_WRAP_CACHE_TTL_MS = 10 * 60 * 1000;
  const GIFT_WRAP_SESSION_CACHE_KEY = "qk:gift-wrap:v1";
  const MANAGED_LOOKUP_SESSION_CACHE_KEY = "qk:managed-lookups:v1";
  const MANAGED_LOOKUP_SESSION_TTL_MS = 10 * 60 * 1000;
  const PACKAGE_INSURANCE_SESSION_CACHE_KEY = "qk:package-insurance:v1";
  const MAX_SYNC_CONVERGENCE_ITERATIONS = 4;
  const CART_REQUEST_TIMEOUT_MS = 12000;
  const PRODUCT_LOOKUP_PAGE_LIMIT = 250;
  const PRODUCT_LOOKUP_MAX_PAGES = 80;
  const FALLBACK_GIFT_VARIANT_BY_PRODUCT_ID = {
    "9016970510670": "46906364985678",
  };

  const productLookupCacheByLegacyId = {};
  const productLookupFetchedAtByLegacyId = {};
  const productHandleByLegacyId = {};
  let productLookupSeedsHydrated = false;
  const fastProductFetchInFlightByLegacyId = {};
  const fastTouchHandledAtByElement = new WeakMap();
  let activeFastTouchCartControl = null;
  let activeFastTouchFeedbackControl = null;
  let activeDirectTouchCartControl = null;
  let productCatalogByLegacyId = {};
  let productCatalogNextPage = 1;
  let productCatalogExhausted = false;
  let productCatalogScanPromise = null;
  const LEI_CURRENCY_FORMATTER = new Intl.NumberFormat("ro-RO", {
    style: "currency",
    currency: "RON",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const CART_TRUST_COUNT_FORMATTER = new Intl.NumberFormat("ro-RO", {
    maximumFractionDigits: 0,
  });
  const CART_MONEY_ANIMATION_MS = 420;
  const cartMoneyAnimationStateByElement = new WeakMap();
  const cartMoneyLastCentsByKey = {};
  let cartTrustCountAnimationFrame = 0;

  const DEFAULT_RULES = {
    version: 1,
    currency: "RON",
    gift: {
      mode: "cumulative",
      tiers: [
        {
          index: 1,
          enabled: true,
          thresholdRon: 100,
          giftProductLegacyId: "9016970510670",
          giftVariantLegacyId: "",
        },
        {
          index: 2,
          enabled: true,
          thresholdRon: 500,
          giftProductLegacyId: "7832051810519",
          giftVariantLegacyId: "",
        },
        {
          index: 3,
          enabled: false,
          thresholdRon: 800,
          giftProductLegacyId: "0",
          giftVariantLegacyId: "",
        },
      ],
    },
    fees: {
      rules: [
        {
          key: "heavy_keyboard",
          feeProductLegacyId: "8745358426446",
          feeVariantLegacyId: "47677399138638",
          includeTags: ["heavy keyboard"],
          excludeTags: [],
          suppresses: ["casti_or_keyboards"],
        },
        {
          key: "casti_or_keyboards",
          feeProductLegacyId: "8745336570190",
          feeVariantLegacyId: "47677341532494",
          includeTags: ["casti", "keyboards"],
          excludeTags: ["casti-cover"],
          suppresses: [],
        },
        {
          key: "mouse_or_cable_not_mouse_cover",
          feeProductLegacyId: "8745361047886",
          feeVariantLegacyId: "47677405790542",
          includeTags: ["mouse", "cable"],
          excludeTags: ["mouse-cover"],
          suppresses: [],
        },
      ],
    },
    ui: {
      progressTitle: "Cadouri in cos",
      unlockedLabel: "Aplicat",
      eligibleLabel: "Eligibil",
      lockedLabel: "Blocat",
    },
    flags: {
      managedRulesEnabled: true,
      shadowMode: false,
      log: false,
      killSwitch: false,
    },
  };

  const DEFAULT_LUBRICATION_CONFIG = {
    version: 1,
    enabled: false,
    keyboard: {
      enabled: true,
      rules: [],
    },
    switch: {
      enabled: false,
      rules: [],
    },
    ui: {
      label_ro: "Lubrifiere premium pentru switch-uri",
      attachment_ro: "Lubrifiere switch-uri inclusa",
    },
  };

  const state = {
    inFlight: false,
    rerun: false,
    rerunNeedsCartFetch: false,
    mutationPhaseActive: false,
    syncPromise: null,
    cartRecoveryRequired: false,
    cartRecoveryVersion: 0,
    lineMutationContext: null,
    debounceTimer: null,
    lineMutationDrainTimer: null,
    lineMutationInFlight: false,
    lineMutationPromise: null,
    lineMutationQueue: [],
    latestIntendedLineQuantities: {},
    uiRefreshFrame: 0,
    domObserver: null,
    domObserverTargets: [],
    domObserverTargetSignature: "",
    domMutationRefreshQueued: false,
    queuedSeedCart: null,
    cartPageSeedCart: null,
    cartPageBootSyncScheduled: false,
    pendingManagedRemovalKeys: {},
    checkoutErrorMessageByFormKey: {},
    processingLineKeys: {},
    lineMutationNeedsRender: false,
    feeTagsByProductId: {},
    config: null,
    lubricationConfig: null,
    lastCart: null,
    lastPlanSignature: "",
    resolvedGiftVariantsByProductId: {},
    giftStockByProductId: {},
    giftStockFetchedAt: 0,
    giftMetaByProductId: {},
    giftMetaWarmPromise: null,
    giftImagePreloadCache: {},
    fastProductLookupMissByLegacyId: {},
    resolvedLubricationVariantsByProductId: {},
    lubricationStockByProductId: {},
    lubricationStockFetchedAt: 0,
    lubricationManagedProductIds: {},
    lubricationRemovalIntents: [],
    checkoutFallbackTimer: null,
    checkoutNavigationActive: false,
    giftWrapStockByProductId: {},
    giftWrapStockFetchedAt: 0,
    giftWrapVariantLegacyId: "",
    giftWrapInStock: false,
    giftWrapProduct: null,
    giftWrapUiBusy: false,
    giftWrapModalOpen: false,
    giftWrapModalLastActiveElement: null,
    giftWrapModalContext: "page",
    giftWrapPendingDeselection: false,
    giftWrapPendingSelection: false,
    giftWrapConfirmBusy: false,
    giftWrapAddPerfPending: false,
    giftWrapWarmPromise: null,
    packageInsuranceStockByProductId: {},
    packageInsuranceStockFetchedAt: 0,
    packageInsuranceVariantLegacyId: "",
    packageInsuranceInStock: false,
    packageInsuranceProduct: null,
    packageInsuranceUiBusy: false,
    packageInsuranceModalOpen: false,
    packageInsuranceModalLastActiveElement: null,
    packageInsuranceModalContext: "page",
    packageInsurancePendingDeselection: false,
    packageInsurancePendingSelection: false,
    packageInsuranceConfirmBusy: false,
    packageInsuranceAddPerfPending: false,
    packageInsuranceWarmPromise: null,
    discountMutationPromise: null,
    discountCodeRemoving: "",
    discountCodeErrorMessage: "",
    discountLinkToastTimer: null,
    discountLinkToastRemoveTimer: null,
    customerContext: null,
  };

  function init() {
    const cartPageContext = isCartPagePath();
    const cartDrawerSeed = readCartDrawerSeed();
    getConfig();
    getLubricationConfig();
    ensureKlarnaPlacementsLocale(document);
    hydrateProgressMountsFromCache();
    hydrateGiftWrapStateFromSessionCache({ allowStale: true });
    hydratePackageInsuranceStateFromSessionCache({ allowStale: true });
    hydrateManagedLookupSessionCache();
    hydrateProductLookupSeeds();
    bindCartDrawerLifecycleListeners();
    showDiscountLinkToastFromNavigation();

    if (cartPageContext) {
      const cartPageSeed = readCartPageSeed();
      if (cartPageSeed) {
        state.cartPageSeedCart = cartPageSeed;
        state.lastCart = cartPageSeed;
        if (!cartHasManagedCodFeeLine(cartPageSeed)) {
          scheduleUiRefresh("cart-page-seed");
        }
      }
    }

    prewarmManagedVariantCaches();

    if (hasGiftWrapUiMounts() && cartPageContext) {
      warmGiftWrapProductState({ immediate: true });
    }
    if (hasPackageInsuranceUiMounts() && cartPageContext) {
      warmPackageInsuranceProductState({ immediate: true });
    }

    window.updateQuantity = function updateQuantity(lineKey, delta) {
      void handleQuantityDelta(lineKey, delta);
    };

    // Pack predicted gift lines into the first add (set false earlier to opt out).
    if (window.__QK_PREDICTIVE_GIFT_PACK__ === undefined) {
      window.__QK_PREDICTIVE_GIFT_PACK__ = true;
    }

    window.QKCartRules = {
      syncNow: (reason) => syncNow(reason || "manual"),
      isSyncInFlight: () => isSyncInFlight(),
      predictGiftItems: (input) => predictGiftItems(input),
    };

    document.addEventListener("change", onQuantityInputChanged, true);
    document.addEventListener("pointerdown", onQuantityButtonPointerDown, true);
    document.addEventListener("pointerup", onQuantityButtonPointerUp, true);
    document.addEventListener("pointercancel", onFastTouchCartControlCancelled, true);
    document.addEventListener("touchstart", onQuantityButtonTouchStart, { capture: true, passive: false });
    document.addEventListener("touchend", onQuantityButtonTouchEnd, { capture: true, passive: false });
    document.addEventListener("touchcancel", onDirectTouchCartControlCancelled, { capture: true, passive: false });
    document.addEventListener("click", onQuantityButtonClick, true);
    document.addEventListener("pointerdown", onRemoveLinkPointerDown, true);
    document.addEventListener("pointerup", onRemoveLinkPointerUp, true);
    document.addEventListener("touchstart", onRemoveLinkTouchStart, { capture: true, passive: false });
    document.addEventListener("touchend", onRemoveLinkTouchEnd, { capture: true, passive: false });
    document.addEventListener("pointerdown", onCartAddonFeedbackPointerDown, true);
    document.addEventListener("pointerup", onCartAddonFeedbackPointerUp, true);
    document.addEventListener("touchstart", onCartAddonTouchStart, { capture: true, passive: false });
    document.addEventListener("touchend", onCartAddonTouchEnd, { capture: true, passive: false });
    document.addEventListener("pointerdown", onLubricationAttachmentRemoveClick, true);
    document.addEventListener("click", onLubricationAttachmentRemoveClick, true);
    document.addEventListener("click", onRemoveLinkClicked, true);
    document.addEventListener("click", onDiscountCodeRemoveClick, true);
    document.addEventListener("click", onProgressTruckClick, true);
    document.addEventListener("click", onGiftWrapUiClick, true);
    document.addEventListener("keydown", onGiftWrapModalKeyDown, true);
    document.addEventListener("click", onPackageInsuranceUiClick, true);
    document.addEventListener("keydown", onPackageInsuranceModalKeyDown, true);
    document.addEventListener("click", onCheckoutRetryClick, true);
    window.addEventListener("pointerdown", onPrimaryCheckoutPointerDown, true);
    window.addEventListener("pointerup", onPrimaryCheckoutPointerUp, true);
    window.addEventListener("touchstart", onPrimaryCheckoutTouchStart, { capture: true, passive: false });
    window.addEventListener("touchend", onPrimaryCheckoutTouchEnd, { capture: true, passive: false });
    window.addEventListener("touchcancel", onDirectTouchCartControlCancelled, { capture: true, passive: false });
    window.addEventListener("click", onPrimaryCheckoutClick, true);
    document.addEventListener("submit", onCheckoutSubmit, true);
    document.addEventListener("cart:change", onExternalCartChange);
    window.addEventListener("pageshow", onPageShow, true);
    window.addEventListener("load", onWindowLoad, { once: true });
    window.addEventListener("beforeunload", clearCheckoutFallbackTimer, { passive: true });

    // Reconcile buttons that may have been replaced by a Shopify section
    // render while cart work or checkout navigation is still active.
    setInterval(function () {
      refreshCheckoutButtonsBusy();
    }, 5000);

    if (cartPageContext) {
      queueCartPageBootSync("init-cart-page", getPreferredCartPageSeed(), 0);
    } else if (cartHasManagedCodFeeLine(cartDrawerSeed)) {
      state.lastCart = cartDrawerSeed;
      activateCartSync("storefront-cod-fee-cleanup", cartDrawerSeed, 0);
    }
  }

  function prewarmManagedVariantCaches() {
    const hasAtcForms = Boolean(document.querySelector('form[action*="/cart/add"]'));
    const cartContext = isCartPagePath() || hasGiftWrapUiMounts() || hasPackageInsuranceUiMounts();
    if (!hasAtcForms && !cartContext) {
      return;
    }

    const run = async () => {
      const seedCart = state.lastCart || { items: [] };
      try {
        await Promise.all([
          ensureGiftVariantIds(seedCart, getConfig()),
          ensureLubricationVariantIds(seedCart, getLubricationConfig()),
          ensureGiftWrapVariantId(seedCart),
          ensurePackageInsuranceVariantId(seedCart),
        ]);
      } catch (error) {
        debugLog("[qk-cart-rules] managed cache prewarm failed", error);
      }
    };

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(() => {
        void run();
      }, { timeout: 1200 });
      return;
    }

    window.setTimeout(() => {
      void run();
    }, 120);
  }

  function hasGiftWrapUiMounts() {
    return Boolean(document.querySelector("[data-qk-gift-wrap-mount]"));
  }

  function hasPackageInsuranceUiMounts() {
    return Boolean(document.querySelector("[data-qk-package-insurance-mount]"));
  }

  function canObserveCartUi() {
    return Boolean(isCartPagePath() || isCartDrawerOpen());
  }

  function isCartDrawerOpen() {
    const drawerElement = resolveCartDrawerElement();
    return Boolean(drawerElement && drawerElement.hasAttribute("open"));
  }

  function bindCartDrawerLifecycleListeners() {
    const drawerElement = resolveCartDrawerElement();
    if (!(drawerElement instanceof HTMLElement)) {
      return;
    }

    drawerElement.addEventListener("dialog:after-show", onCartDrawerAfterShow);
    drawerElement.addEventListener("dialog:after-hide", onCartDrawerAfterHide);
  }

  function onCartDrawerAfterShow() {
    animateCartTrustCount();
    // Shopify can drop an in-flight add when another cart write races it. The
    // add's own cart:change event starts the sync once it has committed.
    const drawerElement = resolveCartDrawerElement();
    if (drawerElement && drawerElement.hasAttribute("data-qk-atc-pending")) {
      startCartUiObserver();
      return;
    }
    activateCartSync("drawer-open", null, 0);
  }

  function onCartDrawerAfterHide() {
    cancelCartTrustCountAnimation();
    refreshCartUiObserverTargets();
    if (state.giftWrapModalOpen && state.giftWrapModalContext === "drawer") {
      closeGiftWrapModal({ restoreFocus: false });
    }
    if (state.packageInsuranceModalOpen && state.packageInsuranceModalContext === "drawer") {
      closePackageInsuranceModal({ restoreFocus: false });
    }
  }

  function activateCartSync(reason, seedCart, delayMs) {
    startCartUiObserver();
    warmGiftWrapProductState({ immediate: true });
    warmPackageInsuranceProductState({ immediate: true });
    scheduleSync(reason || "cart-ui-activate", seedCart || null, delayMs);
  }

  function queueCartPageBootSync(reason, seedCart, delayMs) {
    if (!isCartPagePath()) {
      return;
    }

    if (state.cartPageBootSyncScheduled) {
      return;
    }

    state.cartPageBootSyncScheduled = true;
    activateCartSync(reason || "cart-page-boot", seedCart || getPreferredCartPageSeed(), delayMs);
  }

  function getPreferredCartPageSeed() {
    return normalizeCartPayload(state.lastCart) || normalizeCartPayload(state.cartPageSeedCart) || readCartPageSeed();
  }

  function readCartPageSeed() {
    if (!isCartPagePath()) {
      return null;
    }

    const scriptElement = document.getElementById("qk-cart-page-seed");
    if (!(scriptElement instanceof HTMLScriptElement)) {
      return null;
    }

    const raw = String(scriptElement.textContent || "").trim();
    if (!raw || raw === "null") {
      return null;
    }

    try {
      return normalizeCartPayload(JSON.parse(raw));
    } catch (error) {
      debugLog("[qk-cart-rules] invalid cart page seed", error);
      return null;
    }
  }

  function readCartDrawerSeed() {
    const scriptElement = document.querySelector("cart-drawer script[data-qk-cart-seed]");
    if (!(scriptElement instanceof HTMLScriptElement)) {
      return null;
    }

    const raw = String(scriptElement.textContent || "").trim();
    if (!raw || raw === "null") {
      return null;
    }

    try {
      return normalizeCartPayload(JSON.parse(raw));
    } catch (error) {
      debugLog("[qk-cart-rules] invalid cart drawer seed", error);
      return null;
    }
  }

  function hydrateProgressMountsFromCache() {
    const mounts = Array.from(document.querySelectorAll(".qk-cart-progress-mount"));
    mounts.forEach((mount) => {
      const context = getProgressMountContext(mount);
      const cached = readProgressCache(context);
      if (!cached) {
        return;
      }

      mount.innerHTML = cached;
    });
  }

  function getProgressMountContext(mount) {
    if (!(mount instanceof Element)) {
      return "global";
    }

    return String(mount.getAttribute("data-qk-progress-context") || "global").trim().toLowerCase() || "global";
  }

  function getProgressCacheKey(context) {
    return `${PROGRESS_CACHE_PREFIX}${String(context || "global").trim().toLowerCase() || "global"}`;
  }

  function readProgressCache(context) {
    try {
      return String(window.sessionStorage.getItem(getProgressCacheKey(context)) || "").trim();
    } catch {
      return "";
    }
  }

  function writeProgressCache(context, html) {
    try {
      window.sessionStorage.setItem(getProgressCacheKey(context), String(html || ""));
    } catch {
      // ignore storage failures
    }
  }

  function clearProgressCache(context) {
    try {
      window.sessionStorage.removeItem(getProgressCacheKey(context));
    } catch {
      // ignore storage failures
    }
  }

  function startCartUiObserver() {
    if (!canObserveCartUi()) {
      stopCartUiObserver();
      return;
    }

    if (!state.domObserver) {
      state.domObserver = new MutationObserver((mutations) => {
        if (!state.lastCart) {
          return;
        }

        const hasRelevantChanges = mutations.some((mutation) => {
          if (mutation.type !== "childList") {
            return false;
          }

          // Money animation frames only replace text. They must not restart
          // the full cart render; element replacements still need hydration.
          if (
            mutation.target instanceof Element &&
            mutation.target.matches("[data-qk-cart-money-value], [data-qk-cart-trust-count]") &&
            [...mutation.addedNodes, ...mutation.removedNodes].every((node) => node.nodeType === Node.TEXT_NODE)
          ) {
            return false;
          }

          return Boolean(
            (mutation.addedNodes && mutation.addedNodes.length) ||
              (mutation.removedNodes && mutation.removedNodes.length),
          );
        });

        if (!hasRelevantChanges || state.domMutationRefreshQueued) {
          return;
        }

        state.domMutationRefreshQueued = true;
        Promise.resolve().then(() => {
          state.domMutationRefreshQueued = false;
          scheduleUiRefresh("dom-mutation");
        });
      });
    }

    refreshCartUiObserverTargets();
  }

  function stopCartUiObserver() {
    if (state.domObserver) {
      state.domObserver.disconnect();
    }
    state.domObserverTargets = [];
    state.domObserverTargetSignature = "";
    state.domMutationRefreshQueued = false;
  }

  function getCartUiObserverTargets() {
    const targets = [];
    const mainCartHost = document.querySelector("[data-main-cart-section-id]");
    const mainCartSection =
      (mainCartHost instanceof Element && mainCartHost.closest(".shopify-section")) ||
      (mainCartHost instanceof Element ? mainCartHost : null) ||
      document.querySelector(".shopify-section--main-cart");

    if (isCartPagePath() && mainCartSection instanceof Element) {
      targets.push(mainCartSection);
    }

    const drawerElement = resolveCartDrawerElement();
    if (drawerElement instanceof HTMLElement && drawerElement.hasAttribute("open")) {
      const drawerInner = drawerElement.querySelector(".cart-drawer__inner");
      targets.push(drawerInner instanceof Element ? drawerInner : drawerElement);
    }

    return Array.from(new Set(targets.filter((target) => target instanceof Element)));
  }

  function getObserverTargetSignature(target) {
    if (!(target instanceof Element)) {
      return "";
    }

    const id = String(target.id || "").trim();
    if (id) {
      return `id:${id}`;
    }

    const sectionId = String(target.getAttribute("data-section-id") || target.getAttribute("data-main-cart-section-id") || "").trim();
    if (sectionId) {
      return `section:${sectionId}`;
    }

    const className = String(target.className || "").trim();
    return `node:${target.tagName.toLowerCase()}:${className}`;
  }

  function refreshCartUiObserverTargets() {
    if (!state.domObserver) {
      return;
    }

    if (!canObserveCartUi()) {
      stopCartUiObserver();
      return;
    }

    const targets = getCartUiObserverTargets();
    const signature = targets.map((target) => getObserverTargetSignature(target)).join("|");
    const previousTargets = Array.isArray(state.domObserverTargets) ? state.domObserverTargets : [];
    const sameTargets =
      signature === state.domObserverTargetSignature &&
      previousTargets.length === targets.length &&
      previousTargets.every((target, index) => target === targets[index]);
    if (sameTargets) {
      return;
    }

    state.domObserver.disconnect();
    targets.forEach((target) => {
      state.domObserver.observe(target, {
        childList: true,
        subtree: true,
      });
    });
    state.domObserverTargets = targets;
    state.domObserverTargetSignature = signature;
  }

  function buildCartDomSnapshot() {
    const lineElements = Array.from(document.querySelectorAll("line-item[data-line-key]"));
    const lineElementsByKey = {};
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
      if (!lineKey) {
        return;
      }

      lineElementsByKey[lineKey] = lineElementsByKey[lineKey] || [];
      lineElementsByKey[lineKey].push(lineElement);
    });

    return {
      lineElements,
      lineElementsByKey,
    };
  }

  function refreshUiFromState() {
    if (!state.lastCart) {
      return;
    }

    ensureKlarnaPlacementsLocale(document);
    const domSnapshot = buildCartDomSnapshot();

    const config = getConfig();
    try {
      renderProgressUI(state.lastCart, config);
    } catch (error) {
      reportError(error, "Nu am putut actualiza progresul din cos.");
    }

    try {
      renderCartTotalValues(state.lastCart);
    } catch (error) {
      reportError(error, "Nu am putut actualiza totalul cosului.");
    }

    try {
      renderCartSummaryRows(state.lastCart, config, domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut actualiza sumarul cosului.");
    }

    try {
      renderCompactGiftLines(state.lastCart, domSnapshot);
      applyPendingManagedHiddenState(domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut compacta afisarea cadourilor din cos.");
    }

    try {
      renderFeeAttachments(state.lastCart, config, domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut actualiza afisarea taxelor din cos.");
    }

    try {
      renderLubricationAttachments(state.lastCart, getLubricationConfig(), domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut actualiza afisarea lubrifierii din cos.");
    }

    try {
      renderGiftWrapUi(state.lastCart);
    } catch (error) {
      reportError(error, "Nu am putut actualiza optiunea de impachetare cadou.");
    }

    try {
      renderPackageInsuranceUi(state.lastCart);
    } catch (error) {
      reportError(error, "Nu am putut actualiza optiunea de asigurare colet.");
    }

    applyProcessingLineState(domSnapshot);
    refreshCheckoutButtonsBusy();
  }

  function scheduleUiRefresh(reason) {
    if (!state.lastCart) {
      return;
    }

    if (state.uiRefreshFrame) {
      return;
    }

    const scheduleFrame = typeof window.requestAnimationFrame === "function"
      ? window.requestAnimationFrame.bind(window)
      : (callback) => window.setTimeout(callback, 16);
    state.uiRefreshFrame = scheduleFrame(() => {
      state.uiRefreshFrame = 0;
      debugLog("[qk-cart-rules] UI refresh", reason || "scheduled");
      refreshUiFromState();
    });
  }

  function onExternalCartChange(event) {
    const baseEvent = String(event && event.detail && event.detail.baseEvent ? event.detail.baseEvent : "");
    const incomingCartRaw = event && event.detail ? event.detail.cart : state.lastCart;
    const incomingCart = normalizeCartPayload(incomingCartRaw);

    if (incomingCart) {
      state.lastCart = incomingCart;
      scheduleUiRefresh("cart-change");
    }

    const isPackedVariantAdd = baseEvent === "qk:variant:add-packed";
    if (baseEvent.startsWith("qk:") && !isPackedVariantAdd) {
      return;
    }

    const isVariantAdd = baseEvent === "variant:add";
    const cartUiActive = canObserveCartUi();
    const isCartPage = isCartPagePath();
    if (!cartUiActive && !isCartPage) {
      if ((isVariantAdd || isPackedVariantAdd) && incomingCart) {
        state.queuedSeedCart = incomingCart;
      }
      return;
    }

    const shouldPrioritizeSync = isVariantAdd || isPackedVariantAdd;
    scheduleSync("external-cart-change", incomingCart, shouldPrioritizeSync ? 0 : undefined);
  }

  function onPageShow(event) {
    clearCheckoutFallbackTimer();
    state.checkoutNavigationActive = false;
    refreshCheckoutButtonsBusy();

    if (event && event.persisted) {
      void refreshCartAfterPageRestore();
      return;
    }

    if (!isCartPagePath()) {
      return;
    }

    queueCartPageBootSync("pageshow", getPreferredCartPageSeed(), 40);
  }

  async function refreshCartAfterPageRestore() {
    try {
      const cart = normalizeCartPayload(await fetchCartJson({ fresh: true }));
      if (!cart) {
        throw new Error("Cart restore returned an invalid payload.");
      }

      state.lastCart = cart;
      if (cartHasManagedCodFeeLine(cart) || isCartPagePath() || isCartDrawerOpen()) {
        activateCartSync("pageshow-persisted", cart, 0);
      }
    } catch (error) {
      reportError(error, "Nu am putut revalida cosul dupa revenirea in magazin.");
      if (isCartPagePath()) {
        activateCartSync("pageshow-persisted-fallback", null, 0);
      }
    }
  }

  function onWindowLoad() {
    if (!isCartPagePath()) {
      return;
    }

    queueCartPageBootSync("window-load", getPreferredCartPageSeed(), 80);
  }

  function isFastTouchPointerEvent(event) {
    if (!event || event.type !== "pointerdown") {
      return false;
    }

    if (event.isPrimary === false) {
      return false;
    }

    if (typeof event.button === "number" && event.button !== 0) {
      return false;
    }

    return event.pointerType === "touch" || event.pointerType === "pen";
  }

  function stopCartControlEvent(event) {
    if (!event) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
  }

  function markFastTouchHandled(element) {
    if (element instanceof Element) {
      fastTouchHandledAtByElement.set(element, Date.now());
    }
  }

  function wasFastTouchRecentlyHandled(element) {
    if (!(element instanceof Element)) {
      return false;
    }

    const handledAt = fastTouchHandledAtByElement.get(element);
    return Number.isFinite(handledAt) && Date.now() - handledAt <= FAST_TOUCH_CLICK_SUPPRESSION_MS;
  }

  function consumeFastTouchClick(event, element) {
    if (!event || event.type !== "click" || !(element instanceof Element)) {
      return false;
    }

    if (!wasFastTouchRecentlyHandled(element)) {
      return false;
    }

    stopCartControlEvent(event);
    return true;
  }

  function setCartControlPressed(element, pressed) {
    if (element instanceof HTMLElement) {
      element.classList.toggle(FAST_TOUCH_PRESSED_CLASS, Boolean(pressed));
    }
  }

  function releaseCartControlPressed(element) {
    if (!(element instanceof HTMLElement)) {
      return;
    }

    window.setTimeout(() => {
      setCartControlPressed(element, false);
    }, FAST_TOUCH_PRESSED_RELEASE_MS);
  }

  function resolveQuantityButtonFromEvent(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return null;
    }

    const button = target.closest("[data-qk-line-key][data-qk-quantity-delta]");
    if (!(button instanceof HTMLButtonElement) || !isInsideCartUI(button)) {
      return null;
    }

    return button;
  }

  function rememberFastTouchCartControl(event, intent) {
    const previousElement = activeFastTouchCartControl && activeFastTouchCartControl.intent
      ? activeFastTouchCartControl.intent.element
      : null;

    if (!event || !intent || !(intent.element instanceof Element)) {
      setCartControlPressed(previousElement, false);
      activeFastTouchCartControl = null;
      return;
    }

    if (previousElement && previousElement !== intent.element) {
      setCartControlPressed(previousElement, false);
    }

    activeFastTouchCartControl = {
      pointerId: event.pointerId,
      startedAt: Date.now(),
      startX: Number(event.clientX) || 0,
      startY: Number(event.clientY) || 0,
      intent,
    };
    setCartControlPressed(intent.element, true);
  }

  function resolveActiveFastTouchCartControl(event, type) {
    const active = activeFastTouchCartControl;
    if (!active || !event || active.pointerId !== event.pointerId) {
      return null;
    }

    if (type && active.intent && active.intent.type !== type) {
      return null;
    }

    const deltaX = Math.abs((Number(event.clientX) || 0) - active.startX);
    const deltaY = Math.abs((Number(event.clientY) || 0) - active.startY);
    activeFastTouchCartControl = null;
    const pressedElement = active.intent && active.intent.element;

    if (deltaX > 12 || deltaY > 12 || Date.now() - active.startedAt > 1200) {
      setCartControlPressed(pressedElement, false);
      return null;
    }

    releaseCartControlPressed(pressedElement);
    return active.intent || null;
  }

  function onFastTouchCartControlCancelled(event) {
    if (activeFastTouchCartControl && activeFastTouchCartControl.pointerId === event.pointerId) {
      const pressedElement = activeFastTouchCartControl.intent && activeFastTouchCartControl.intent.element;
      setCartControlPressed(pressedElement, false);
      activeFastTouchCartControl = null;
    }

    if (activeFastTouchFeedbackControl && activeFastTouchFeedbackControl.pointerId === event.pointerId) {
      setCartControlPressed(activeFastTouchFeedbackControl.element, false);
      activeFastTouchFeedbackControl = null;
    }
  }

  function resolveCartAddonFeedbackControlFromEvent(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return null;
    }

    const control = target.closest(
      [
        "[data-qk-gift-wrap-toggle]",
        "[data-qk-package-insurance-toggle]",
        "[data-qk-gift-wrap-modal-close]",
        "[data-qk-gift-wrap-modal-cancel]",
        "[data-qk-gift-wrap-modal-confirm]",
        "[data-qk-package-insurance-modal-close]",
        "[data-qk-package-insurance-modal-cancel]",
        "[data-qk-package-insurance-modal-confirm]",
      ].join(","),
    );
    if (!(control instanceof HTMLElement)) {
      return null;
    }

    const insideQkModal = Boolean(control.closest(`#${GIFT_WRAP_MODAL_ELEMENT_ID}, #${PACKAGE_INSURANCE_MODAL_ELEMENT_ID}`));
    if (!insideQkModal && !isInsideCartUI(control)) {
      return null;
    }

    if (
      (control instanceof HTMLButtonElement && control.disabled) ||
      control.getAttribute("aria-disabled") === "true"
    ) {
      return null;
    }

    return control;
  }

  function onCartAddonFeedbackPointerDown(event) {
    if (!isFastTouchPointerEvent(event)) {
      return;
    }

    const control = resolveCartAddonFeedbackControlFromEvent(event);
    if (!(control instanceof HTMLElement)) {
      return;
    }

    stopCartControlEvent(event);

    if (activeFastTouchFeedbackControl && activeFastTouchFeedbackControl.element !== control) {
      setCartControlPressed(activeFastTouchFeedbackControl.element, false);
    }

    activeFastTouchFeedbackControl = {
      pointerId: event.pointerId,
      element: control,
      startedAt: Date.now(),
      startX: Number(event.clientX) || 0,
      startY: Number(event.clientY) || 0,
    };
    setCartControlPressed(control, true);
  }

  function onCartAddonFeedbackPointerUp(event) {
    if (!activeFastTouchFeedbackControl || activeFastTouchFeedbackControl.pointerId !== event.pointerId) {
      return;
    }

    const active = activeFastTouchFeedbackControl;
    activeFastTouchFeedbackControl = null;

    const deltaX = Math.abs((Number(event.clientX) || 0) - active.startX);
    const deltaY = Math.abs((Number(event.clientY) || 0) - active.startY);
    if (deltaX > 12 || deltaY > 12 || Date.now() - active.startedAt > 1200) {
      setCartControlPressed(active.element, false);
      return;
    }

    stopCartControlEvent(event);
    markFastTouchHandled(active.element);
    releaseCartControlPressed(active.element);

    if (handleGiftWrapUiTarget(active.element) || handlePackageInsuranceUiTarget(active.element)) {
      return;
    }
  }

  function onCartAddonTouchStart(event) {
    const control = resolveCartAddonFeedbackControlFromEvent(event);
    if (!(control instanceof HTMLElement)) {
      return;
    }

    if (
      rememberDirectTouchCartControl(event, {
        type: "addon",
        element: control,
      })
    ) {
      stopCartControlEvent(event);
    }
  }

  function onCartAddonTouchEnd(event) {
    const intent = resolveDirectTouchCartControl(event, "addon");
    if (!intent || !(intent.element instanceof HTMLElement)) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    if (handleGiftWrapUiTarget(intent.element) || handlePackageInsuranceUiTarget(intent.element)) {
      return;
    }
  }

  function getChangedTouch(event, identifier) {
    if (!event || !event.changedTouches || !event.changedTouches.length) {
      return null;
    }

    if (identifier == null) {
      return event.changedTouches[0] || null;
    }

    for (let index = 0; index < event.changedTouches.length; index += 1) {
      const touch = event.changedTouches[index];
      if (touch && touch.identifier === identifier) {
        return touch;
      }
    }

    return null;
  }

  function isSingleDirectTouchStart(event) {
    return Boolean(
      event &&
        event.type === "touchstart" &&
        event.touches &&
        event.touches.length === 1 &&
        event.changedTouches &&
        event.changedTouches.length === 1,
    );
  }

  function rememberDirectTouchCartControl(event, intent) {
    if (!isSingleDirectTouchStart(event) || !intent || !(intent.element instanceof HTMLElement)) {
      return false;
    }

    const touch = getChangedTouch(event);
    if (!touch) {
      return false;
    }

    if (activeDirectTouchCartControl && activeDirectTouchCartControl.element !== intent.element) {
      setCartControlPressed(activeDirectTouchCartControl.element, false);
    }

    activeDirectTouchCartControl = {
      identifier: touch.identifier,
      startedAt: Date.now(),
      startX: Number(touch.clientX) || 0,
      startY: Number(touch.clientY) || 0,
      intent,
      element: intent.element,
    };
    setCartControlPressed(intent.element, true);
    return true;
  }

  function resolveDirectTouchCartControl(event, expectedType) {
    const active = activeDirectTouchCartControl;
    if (!active || !event || event.type !== "touchend") {
      return null;
    }

    if (expectedType && active.intent && active.intent.type !== expectedType) {
      return null;
    }

    const touch = getChangedTouch(event, active.identifier);
    if (!touch) {
      return null;
    }

    activeDirectTouchCartControl = null;

    const deltaX = Math.abs((Number(touch.clientX) || 0) - active.startX);
    const deltaY = Math.abs((Number(touch.clientY) || 0) - active.startY);
    if (deltaX > 12 || deltaY > 12 || Date.now() - active.startedAt > 1200) {
      setCartControlPressed(active.element, false);
      return null;
    }

    releaseCartControlPressed(active.element);
    return active.intent || null;
  }

  function onDirectTouchCartControlCancelled(event) {
    if (!activeDirectTouchCartControl) {
      return;
    }

    if (event && event.changedTouches && event.changedTouches.length) {
      const cancelledTouch = getChangedTouch(event, activeDirectTouchCartControl.identifier);
      if (!cancelledTouch) {
        return;
      }
    }

    setCartControlPressed(activeDirectTouchCartControl.element, false);
    activeDirectTouchCartControl = null;
  }

  function onQuantityButtonPointerDown(event) {
    if (!isFastTouchPointerEvent(event)) {
      return;
    }

    const button = resolveQuantityButtonFromEvent(event);
    if (!(button instanceof HTMLButtonElement) || button.disabled || button.getAttribute("aria-disabled") === "true") {
      return;
    }

    const lineKey = String(button.getAttribute("data-qk-line-key") || "").trim();
    const delta = Number(button.getAttribute("data-qk-quantity-delta"));
    if (!lineKey || !Number.isFinite(delta) || delta === 0) {
      return;
    }

    stopCartControlEvent(event);
    rememberFastTouchCartControl(event, {
      type: "quantity",
      element: button,
      lineKey,
      delta,
    });
  }

  function onQuantityButtonPointerUp(event) {
    const intent = resolveActiveFastTouchCartControl(event, "quantity");
    if (!intent) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    void handleQuantityDelta(intent.lineKey, intent.delta);
  }

  function onQuantityButtonTouchStart(event) {
    const button = resolveQuantityButtonFromEvent(event);
    if (!(button instanceof HTMLButtonElement) || button.disabled || button.getAttribute("aria-disabled") === "true") {
      return;
    }

    const lineKey = String(button.getAttribute("data-qk-line-key") || "").trim();
    const delta = Number(button.getAttribute("data-qk-quantity-delta"));
    if (!lineKey || !Number.isFinite(delta) || delta === 0) {
      return;
    }

    if (
      rememberDirectTouchCartControl(event, {
        type: "quantity",
        element: button,
        lineKey,
        delta,
      })
    ) {
      stopCartControlEvent(event);
    }
  }

  function onQuantityButtonTouchEnd(event) {
    const intent = resolveDirectTouchCartControl(event, "quantity");
    if (!intent) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    void handleQuantityDelta(intent.lineKey, intent.delta);
  }

  function onQuantityButtonClick(event) {
    const button = resolveQuantityButtonFromEvent(event);
    if (button) {
      consumeFastTouchClick(event, button);
    }
  }

  function resolveRemoveLinkFromEvent(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return null;
    }

    const link = target.closest('a[href*="/cart/change"]');
    if (!(link instanceof HTMLAnchorElement) || !isInsideCartUI(link)) {
      return null;
    }

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch {
      return null;
    }

    if (!url.pathname.includes("/cart/change")) {
      return null;
    }

    const lineKey = url.searchParams.get("id");
    if (!lineKey) {
      return null;
    }

    return {
      link,
      lineKey,
      quantity: Math.max(0, parseInteger(url.searchParams.get("quantity"))),
    };
  }

  function onRemoveLinkPointerDown(event) {
    if (!isFastTouchPointerEvent(event)) {
      return;
    }

    const removeIntent = resolveRemoveLinkFromEvent(event);
    if (!removeIntent) {
      return;
    }

    stopCartControlEvent(event);
    rememberFastTouchCartControl(event, {
      type: "remove",
      element: removeIntent.link,
      lineKey: removeIntent.lineKey,
      quantity: removeIntent.quantity,
    });
  }

  function onRemoveLinkPointerUp(event) {
    const intent = resolveActiveFastTouchCartControl(event, "remove");
    if (!intent) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    void changeLineQuantity(intent.lineKey, intent.quantity, "line-item:remove-link");
  }

  function onRemoveLinkTouchStart(event) {
    const removeIntent = resolveRemoveLinkFromEvent(event);
    if (!removeIntent) {
      return;
    }

    if (
      rememberDirectTouchCartControl(event, {
        type: "remove",
        element: removeIntent.link,
        lineKey: removeIntent.lineKey,
        quantity: removeIntent.quantity,
      })
    ) {
      stopCartControlEvent(event);
    }
  }

  function onRemoveLinkTouchEnd(event) {
    const intent = resolveDirectTouchCartControl(event, "remove");
    if (!intent) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    void changeLineQuantity(intent.lineKey, intent.quantity, "line-item:remove-link");
  }

  async function handleQuantityDelta(lineKey, delta) {
    const deltaValue = Number(delta);
    if (!lineKey || !Number.isFinite(deltaValue) || deltaValue === 0) {
      return;
    }

    const intendedQuantity = state.latestIntendedLineQuantities[String(lineKey || "").trim()];
    let currentQuantity = Number.isFinite(intendedQuantity) ? Math.max(0, parseInteger(intendedQuantity)) : 0;
    const lineFromCart = findLineByKey(state.lastCart, lineKey);
    if (lineFromCart && !Number.isFinite(intendedQuantity)) {
      currentQuantity = Math.max(0, parseInteger(lineFromCart.quantity));
    } else {
      const matchingInput = findQuantityInputByLineKey(lineKey);
      if (matchingInput && !Number.isFinite(intendedQuantity)) {
        currentQuantity = Math.max(0, parseInteger(matchingInput.value));
      }
    }

    const targetQuantity = Math.max(0, currentQuantity + Math.trunc(deltaValue));
    await changeLineQuantity(lineKey, targetQuantity, "line-item:button");
  }

  async function changeLineQuantity(lineKey, quantity, reason) {
    const normalizedLineKey = String(lineKey || "").trim();
    const targetQuantity = Math.max(0, parseInteger(quantity));
    const normalizedReason = reason || "line-item:change";

    if (targetQuantity === 0) {
      const line = findLineByKey(state.lastCart, normalizedLineKey);
      if (line && isManagedGiftWrapLine(line)) {
        try {
          await setGiftWrapSelection(false, {
            reason: "gift-wrap-line-remove-intent",
          });
        } catch (error) {
          debugLog("[qk-cart-rules] gift-wrap deselect before removal failed", error);
        }
      }
      if (line && isManagedPackageInsuranceLine(line)) {
        try {
          await setPackageInsuranceSelection(false, {
            reason: "package-insurance-line-remove-intent",
          });
        } catch (error) {
          debugLog("[qk-cart-rules] package insurance deselect before removal failed", error);
        }
      }
    }

    const impactedLineItems = applyOptimisticLineQuantity(normalizedLineKey, targetQuantity);

    try {
      await enqueueLineMutation({
        lineKey: normalizedLineKey,
        targetQuantity,
        reason: normalizedReason,
        impactedLineItems,
      });
    } catch (error) {
      reportError(error, "Nu am putut actualiza cantitatea in cos.");
      impactedLineItems.forEach((element) => {
        element.dispatchEvent(
          new CustomEvent("line-item:change", {
            bubbles: true,
            detail: {
              quantity: Math.max(1, parseInteger(findLineByKey(state.lastCart, normalizedLineKey)?.quantity || targetQuantity)),
              cart: state.lastCart || { items: [] },
            },
          }),
        );
      });
    }
  }

  function applyOptimisticLineQuantity(lineKey, targetQuantity) {
    const normalizedLineKey = String(lineKey || "").trim();
    const normalizedQuantity = Math.max(0, parseInteger(targetQuantity));
    if (!normalizedLineKey) {
      return [];
    }

    state.latestIntendedLineQuantities[normalizedLineKey] = normalizedQuantity;

    findQuantityInputsByLineKey(normalizedLineKey).forEach((input) => {
      input.value = String(normalizedQuantity);
      input.setAttribute("value", String(normalizedQuantity));
    });

    const impactedLineItems = findLineItemElementsByKey(normalizedLineKey);
    impactedLineItems.forEach((element) => {
      element.dispatchEvent(
        new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: { targetQuantity: normalizedQuantity },
        }),
      );
    });

    return impactedLineItems;
  }

  function onQuantityInputChanged(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) {
      return;
    }

    if (!target.matches("input[data-line-key]")) {
      return;
    }

    if (!event.isTrusted || target.readOnly || target.disabled) {
      return;
    }

    const lineKey = target.dataset.lineKey;
    if (!lineKey) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const quantity = Math.max(0, parseInteger(target.value));
    target.value = String(quantity);
    void changeLineQuantity(lineKey, quantity, "line-item:manual-input");
  }

  function onRemoveLinkClicked(event) {
    const removeIntent = resolveRemoveLinkFromEvent(event);
    if (!removeIntent) {
      return;
    }

    if (consumeFastTouchClick(event, removeIntent.link)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    void changeLineQuantity(removeIntent.lineKey, removeIntent.quantity, "line-item:remove-link");
  }

  function onLubricationAttachmentRemoveClick(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const removeTrigger = target.closest(
      "[data-qk-lube-remove], .qk-lube-attachment__remove, [data-qk-lube-attachment] a, [data-qk-lube-attachment] button",
    );
    if (!(removeTrigger instanceof HTMLElement)) {
      return;
    }

    const isKnownRemoveControl = removeTrigger.matches("[data-qk-lube-remove], .qk-lube-attachment__remove");
    if (!isKnownRemoveControl) {
      const triggerText = String(removeTrigger.textContent || "").trim().toLowerCase();
      if (!triggerText.includes("elimina")) {
        return;
      }
    }

    const isPointerDown = event.type === "pointerdown";
    if (isPointerDown && typeof event.button === "number" && event.button !== 0) {
      return;
    }

    if (removeTrigger.getAttribute("data-qk-lube-removing") === "1") {
      if (event.type === "click") {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      }
      return;
    }

    if (removeTrigger.getAttribute("aria-disabled") === "true") {
      return;
    }

    const attachment = removeTrigger.closest("[data-qk-lube-attachment]");
    if (!(attachment instanceof HTMLElement)) {
      return;
    }

    if (!isInsideCartUI(attachment)) {
      return;
    }

    const parentLineFromAttachment = String(attachment.getAttribute("data-qk-parent-line-key") || "").trim();
    const managedLineKey = String(attachment.getAttribute("data-qk-managed-line-key") || "").trim();
    const fallbackParentLineElement = attachment.closest('line-item[data-line-key]');
    const fallbackParentLineKey = fallbackParentLineElement instanceof HTMLElement
      ? String(fallbackParentLineElement.getAttribute("data-line-key") || "").trim()
      : "";
    const parentVariantLegacyId = fallbackParentLineElement instanceof HTMLElement
      ? normalizeLegacyId(String(fallbackParentLineElement.getAttribute("data-variant-legacy-id") || "").trim())
      : "";
    const parentLineKey = parentLineFromAttachment || fallbackParentLineKey;
    if (!parentLineKey && !managedLineKey) {
      return;
    }

    const managedRuleKey = String(attachment.getAttribute("data-qk-lube-rule") || "").trim();

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    queueLubricationRemovalIntent({
      parentLineKey,
      parentVariantLegacyId,
      managedLineKey,
      managedRuleKey,
    });

    removeTrigger.setAttribute("data-qk-lube-removing", "1");

    void removeLubricationFromParentLine({
      parentLineKey,
      parentVariantLegacyId,
      managedLineKey,
      managedRuleKey,
      trigger: removeTrigger,
      attachmentElement: attachment,
    });
  }

  function onGiftWrapUiClick(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const fastTouchControl = resolveCartAddonFeedbackControlFromEvent(event);
    if (fastTouchControl && consumeFastTouchClick(event, fastTouchControl)) {
      return;
    }

    if (handleGiftWrapUiTarget(target)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function handleGiftWrapUiTarget(target) {
    if (!(target instanceof Element)) {
      return false;
    }

    const toggleButton = target.closest("[data-qk-gift-wrap-toggle]");
    if (toggleButton instanceof HTMLButtonElement) {
      if (toggleButton.disabled || toggleButton.getAttribute("aria-disabled") === "true" || isGiftWrapControlBusy()) {
        return false;
      }

      const mount = toggleButton.closest("[data-qk-gift-wrap-mount]");
      const modalContext = mount ? mount.getAttribute("data-qk-gift-wrap-mount") : "";
      const isSelected = toggleButton.getAttribute("aria-pressed") === "true";

      if (isSelected) {
        closeGiftWrapModal({ restoreFocus: false });
        void setGiftWrapSelection(false, {
          reason: "gift-wrap-toggle-off",
          context: modalContext,
        });
        return true;
      }

      if (!state.lastCart) {
        activateCartSync("gift-wrap-toggle-open", null, 0);
      }
      openGiftWrapModal(modalContext);
      return true;
    }

    const closeTrigger = target.closest("[data-qk-gift-wrap-modal-close]");
    if (closeTrigger) {
      closeGiftWrapModal({ restoreFocus: true });
      return true;
    }

    const cancelTrigger = target.closest("[data-qk-gift-wrap-modal-cancel]");
    if (cancelTrigger) {
      closeGiftWrapModal({ restoreFocus: true });
      return true;
    }

    const confirmTrigger = target.closest("[data-qk-gift-wrap-modal-confirm]");
    if (confirmTrigger instanceof HTMLButtonElement) {
      if (confirmTrigger.disabled || isGiftWrapControlBusy()) {
        return false;
      }

      markPerf("gift-wrap-add-click");
      markPerf("gift-wrap-add-click-line");
      state.giftWrapAddPerfPending = true;
      state.giftWrapConfirmBusy = true;
      state.giftWrapPendingSelection = true;
      const modalContext = state.giftWrapModalContext;
      showOptimisticAddonSelection("gift-wrap", modalContext);
      closeGiftWrapModal({ restoreFocus: false });
      refreshCheckoutButtonsBusy();
      scheduleUiRefresh("gift-wrap-modal-confirm-start");
      void setGiftWrapSelection(true, {
        reason: "gift-wrap-modal-confirm",
        context: modalContext,
      });
      return true;
    }

    return false;
  }

  function onGiftWrapModalKeyDown(event) {
    if (!state.giftWrapModalOpen) {
      return;
    }

    const modal = document.getElementById(GIFT_WRAP_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement) || modal.hidden) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeGiftWrapModal({ restoreFocus: true });
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusable = getGiftWrapFocusableElements(modal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    const isShift = Boolean(event.shiftKey);

    if (isShift && active === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!isShift && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getGiftWrapFocusableElements(modal) {
    if (!(modal instanceof HTMLElement)) {
      return [];
    }

    return Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => element instanceof HTMLElement && !element.hidden && element.offsetParent !== null);
  }

  function onPackageInsuranceUiClick(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const fastTouchControl = resolveCartAddonFeedbackControlFromEvent(event);
    if (fastTouchControl && consumeFastTouchClick(event, fastTouchControl)) {
      return;
    }

    if (handlePackageInsuranceUiTarget(target)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function handlePackageInsuranceUiTarget(target) {
    if (!(target instanceof Element)) {
      return false;
    }

    const toggleButton = target.closest("[data-qk-package-insurance-toggle]");
    if (toggleButton instanceof HTMLButtonElement) {
      if (
        toggleButton.disabled ||
        toggleButton.getAttribute("aria-disabled") === "true" ||
        isPackageInsuranceControlBusy()
      ) {
        return false;
      }

      const mount = toggleButton.closest("[data-qk-package-insurance-mount]");
      const modalContext = mount ? mount.getAttribute("data-qk-package-insurance-mount") : "";
      const isSelected = toggleButton.getAttribute("aria-pressed") === "true";

      if (isSelected) {
        closePackageInsuranceModal({ restoreFocus: false });
        void setPackageInsuranceSelection(false, {
          reason: "package-insurance-toggle-off",
          context: modalContext,
        });
        return true;
      }

      if (!state.lastCart) {
        activateCartSync("package-insurance-toggle-open", null, 0);
      }
      openPackageInsuranceModal(modalContext);
      return true;
    }

    const closeTrigger = target.closest("[data-qk-package-insurance-modal-close]");
    if (closeTrigger) {
      closePackageInsuranceModal({ restoreFocus: true });
      return true;
    }

    const cancelTrigger = target.closest("[data-qk-package-insurance-modal-cancel]");
    if (cancelTrigger) {
      closePackageInsuranceModal({ restoreFocus: true });
      return true;
    }

    const confirmTrigger = target.closest("[data-qk-package-insurance-modal-confirm]");
    if (confirmTrigger instanceof HTMLButtonElement) {
      if (confirmTrigger.disabled || isPackageInsuranceControlBusy()) {
        return false;
      }

      markPerf("package-insurance-add-click");
      markPerf("package-insurance-add-click-line");
      state.packageInsuranceAddPerfPending = true;
      state.packageInsuranceConfirmBusy = true;
      state.packageInsurancePendingSelection = true;
      const modalContext = state.packageInsuranceModalContext;
      showOptimisticAddonSelection("package-insurance", modalContext);
      closePackageInsuranceModal({ restoreFocus: false });
      refreshCheckoutButtonsBusy();
      scheduleUiRefresh("package-insurance-modal-confirm-start");
      void setPackageInsuranceSelection(true, {
        reason: "package-insurance-modal-confirm",
        context: modalContext,
      });
      return true;
    }

    return false;
  }

  function onPackageInsuranceModalKeyDown(event) {
    if (!state.packageInsuranceModalOpen) {
      return;
    }

    const modal = document.getElementById(PACKAGE_INSURANCE_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement) || modal.hidden) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closePackageInsuranceModal({ restoreFocus: true });
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusable = getPackageInsuranceFocusableElements(modal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    const isShift = Boolean(event.shiftKey);

    if (isShift && active === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!isShift && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getPackageInsuranceFocusableElements(modal) {
    if (!(modal instanceof HTMLElement)) {
      return [];
    }

    return Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => element instanceof HTMLElement && !element.hidden && element.offsetParent !== null);
  }

  function openGiftWrapModal(context) {
    if (state.giftWrapModalOpen) {
      return;
    }
    if (state.packageInsuranceModalOpen) {
      closePackageInsuranceModal({ restoreFocus: false });
    }

    markPerf("gift-wrap-modal-open");
    warmGiftWrapProductState({ immediate: true });
    state.giftWrapModalContext = normalizeGiftWrapModalContext(context);
    const modal = ensureGiftWrapModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    state.giftWrapModalLastActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    state.giftWrapModalOpen = true;
    updateCartAddonModalBodyState();

    const focusable = getGiftWrapFocusableElements(modal);
    if (focusable.length) {
      focusable[0].focus();
    } else {
      const dialog = modal.querySelector(".qk-gift-wrap-modal__dialog");
      if (dialog instanceof HTMLElement) {
        dialog.focus();
      }
    }
  }

  function closeGiftWrapModal(options) {
    const normalizedOptions = options || {};
    const shouldRestoreFocus = normalizedOptions.restoreFocus !== false;
    const modal = document.getElementById(GIFT_WRAP_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement)) {
      state.giftWrapModalOpen = false;
      updateCartAddonModalBodyState();
      return;
    }

    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    state.giftWrapModalOpen = false;
    updateCartAddonModalBodyState();

    if (!shouldRestoreFocus) {
      return;
    }

    const lastActive = state.giftWrapModalLastActiveElement;
    if (lastActive instanceof HTMLElement && lastActive.isConnected) {
      lastActive.focus();
    }
  }

  function updateCartAddonModalBodyState() {
    const shouldLock = Boolean(state.giftWrapModalOpen || state.packageInsuranceModalOpen);
    document.body.classList.toggle("qk-gift-wrap-modal-open", shouldLock);
  }

  function ensureGiftWrapModalElement() {
    const modalHost = resolveGiftWrapModalHost();
    let modal = document.getElementById(GIFT_WRAP_MODAL_ELEMENT_ID);
    if (modal instanceof HTMLElement) {
      if (modalHost instanceof HTMLElement && modal.parentElement !== modalHost) {
        modalHost.appendChild(modal);
      }
      modal.classList.toggle("qk-gift-wrap-modal--drawer", state.giftWrapModalContext === "drawer");
      return modal;
    }

    modal = document.createElement("div");
    modal.id = GIFT_WRAP_MODAL_ELEMENT_ID;
    modal.className = "qk-gift-wrap-modal";
    modal.classList.toggle("qk-gift-wrap-modal--drawer", state.giftWrapModalContext === "drawer");
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="qk-gift-wrap-modal__backdrop" data-qk-gift-wrap-modal-close></div>
      <div class="qk-gift-wrap-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="qk-gift-wrap-modal-title" tabindex="-1">
        <button type="button" class="qk-gift-wrap-modal__close" aria-label="Inchide" data-qk-gift-wrap-modal-close>
          <span class="qk-gift-wrap-modal__close-icon" aria-hidden="true"></span>
        </button>
        <div class="qk-gift-wrap-modal__layout">
          <div class="qk-gift-wrap-modal__media">
            <img data-qk-gift-wrap-modal-image alt="" loading="lazy" decoding="async">
          </div>
          <div class="qk-gift-wrap-modal__content">
            <h3 class="qk-gift-wrap-modal__title" id="qk-gift-wrap-modal-title" data-qk-gift-wrap-modal-title></h3>
            <p class="qk-gift-wrap-modal__price" data-qk-gift-wrap-modal-price></p>
            <p class="qk-gift-wrap-modal__description" data-qk-gift-wrap-modal-description></p>
            <div class="qk-gift-wrap-modal__actions">
              <button type="button" class="button button--secondary" data-qk-gift-wrap-modal-cancel>Anuleaza</button>
              <button type="button" class="button" data-qk-gift-wrap-modal-confirm>
                <span class="qk-gift-wrap-modal__confirm-label">Adauga</span>
                <span class="qk-gift-wrap-modal__confirm-spinner" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    if (modalHost instanceof HTMLElement) {
      modalHost.appendChild(modal);
    } else {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function normalizeGiftWrapModalContext(value) {
    const normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "drawer" ? "drawer" : "page";
  }

  function resolveGiftWrapModalHost() {
    if (state.giftWrapModalContext === "drawer") {
      const drawerHost =
        document.querySelector("cart-drawer#cart-drawer[open]") ||
        document.querySelector("cart-drawer#cart-drawer") ||
        document.querySelector("cart-drawer[open]") ||
        document.querySelector("cart-drawer");

      if (drawerHost instanceof HTMLElement && drawerHost.isConnected) {
        return drawerHost;
      }
    }

    return document.body;
  }

  function openPackageInsuranceModal(context) {
    if (state.packageInsuranceModalOpen) {
      return;
    }
    if (state.giftWrapModalOpen) {
      closeGiftWrapModal({ restoreFocus: false });
    }

    markPerf("package-insurance-modal-open");
    warmPackageInsuranceProductState({ immediate: true });
    state.packageInsuranceModalContext = normalizePackageInsuranceModalContext(context);
    const modal = ensurePackageInsuranceModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    state.packageInsuranceModalLastActiveElement =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    state.packageInsuranceModalOpen = true;
    updateCartAddonModalBodyState();

    const focusable = getPackageInsuranceFocusableElements(modal);
    if (focusable.length) {
      focusable[0].focus();
    } else {
      const dialog = modal.querySelector(".qk-gift-wrap-modal__dialog");
      if (dialog instanceof HTMLElement) {
        dialog.focus();
      }
    }
  }

  function closePackageInsuranceModal(options) {
    const normalizedOptions = options || {};
    const shouldRestoreFocus = normalizedOptions.restoreFocus !== false;
    const modal = document.getElementById(PACKAGE_INSURANCE_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement)) {
      state.packageInsuranceModalOpen = false;
      updateCartAddonModalBodyState();
      return;
    }

    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    state.packageInsuranceModalOpen = false;
    updateCartAddonModalBodyState();

    if (!shouldRestoreFocus) {
      return;
    }

    const lastActive = state.packageInsuranceModalLastActiveElement;
    if (lastActive instanceof HTMLElement && lastActive.isConnected) {
      lastActive.focus();
    }
  }

  function ensurePackageInsuranceModalElement() {
    const modalHost = resolvePackageInsuranceModalHost();
    let modal = document.getElementById(PACKAGE_INSURANCE_MODAL_ELEMENT_ID);
    if (modal instanceof HTMLElement) {
      if (modalHost instanceof HTMLElement && modal.parentElement !== modalHost) {
        modalHost.appendChild(modal);
      }
      modal.classList.toggle("qk-gift-wrap-modal--drawer", state.packageInsuranceModalContext === "drawer");
      return modal;
    }

    modal = document.createElement("div");
    modal.id = PACKAGE_INSURANCE_MODAL_ELEMENT_ID;
    modal.className = "qk-gift-wrap-modal";
    modal.classList.toggle("qk-gift-wrap-modal--drawer", state.packageInsuranceModalContext === "drawer");
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="qk-gift-wrap-modal__backdrop" data-qk-package-insurance-modal-close></div>
      <div class="qk-gift-wrap-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="qk-package-insurance-modal-title" tabindex="-1">
        <button type="button" class="qk-gift-wrap-modal__close" aria-label="Inchide" data-qk-package-insurance-modal-close>
          <span class="qk-gift-wrap-modal__close-icon" aria-hidden="true"></span>
        </button>
        <div class="qk-gift-wrap-modal__layout">
          <div class="qk-gift-wrap-modal__media">
            <img data-qk-package-insurance-modal-image alt="" loading="lazy" decoding="async">
          </div>
          <div class="qk-gift-wrap-modal__content">
            <h3 class="qk-gift-wrap-modal__title" id="qk-package-insurance-modal-title" data-qk-package-insurance-modal-title></h3>
            <p class="qk-gift-wrap-modal__price" data-qk-package-insurance-modal-price></p>
            <p class="qk-gift-wrap-modal__description" data-qk-package-insurance-modal-description></p>
            <div class="qk-gift-wrap-modal__actions">
              <button type="button" class="button button--secondary" data-qk-package-insurance-modal-cancel>Anuleaza</button>
              <button type="button" class="button" data-qk-package-insurance-modal-confirm>
                <span class="qk-gift-wrap-modal__confirm-label">Adauga</span>
                <span class="qk-gift-wrap-modal__confirm-spinner" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    if (modalHost instanceof HTMLElement) {
      modalHost.appendChild(modal);
    } else {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function normalizePackageInsuranceModalContext(value) {
    const normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "drawer" ? "drawer" : "page";
  }

  function resolvePackageInsuranceModalHost() {
    if (state.packageInsuranceModalContext === "drawer") {
      const drawerHost =
        document.querySelector("cart-drawer#cart-drawer[open]") ||
        document.querySelector("cart-drawer#cart-drawer") ||
        document.querySelector("cart-drawer[open]") ||
        document.querySelector("cart-drawer");

      if (drawerHost instanceof HTMLElement && drawerHost.isConnected) {
        return drawerHost;
      }
    }

    return document.body;
  }

  function showOptimisticAddonSelection(type, context) {
    if (String(context || "").trim().toLowerCase() !== "drawer") {
      return null;
    }

    const drawerElement = resolveCartDrawerElement();
    const lineItemsElement = drawerElement && drawerElement.querySelector(".cart-drawer__line-items");
    if (!(drawerElement instanceof HTMLElement) || !(lineItemsElement instanceof HTMLElement)) {
      return null;
    }

    const normalizedType = type === "package-insurance" ? "package-insurance" : "gift-wrap";
    const existing = lineItemsElement.querySelector(
      `[data-qk-addon-optimistic-line="${normalizedType}"]`,
    );
    if (existing instanceof HTMLElement) {
      return existing;
    }

    const isPackageInsurance = normalizedType === "package-insurance";
    const product = isPackageInsurance ? state.packageInsuranceProduct : state.giftWrapProduct;
    const variantLegacyId = isPackageInsurance
      ? state.packageInsuranceVariantLegacyId
      : state.giftWrapVariantLegacyId;
    const fallbackTitle = isPackageInsurance ? "Asigurare Colet" : "Impachetare Cadou";
    const productTitle = String((product && product.title) || fallbackTitle).trim() || fallbackTitle;
    const priceCents = resolveGiftWrapPriceCents(product, variantLegacyId, null);
    const imageUrl = resolveGiftWrapProductImageUrl(product, null);
    const baseTotalCents = Math.max(0, parseInteger(state.lastCart && state.lastCart.total_price));
    const optimisticLine = document.createElement("div");
    optimisticLine.className = "line-item qk-addon-optimistic-line";
    optimisticLine.setAttribute("data-qk-addon-optimistic-line", normalizedType);
    optimisticLine.setAttribute("data-qk-addon-price-cents", String(priceCents));
    optimisticLine.setAttribute("data-qk-base-total-cents", String(baseTotalCents));
    optimisticLine.setAttribute("role", "status");
    optimisticLine.setAttribute("aria-live", "polite");
    optimisticLine.setAttribute("aria-busy", "true");
    optimisticLine.setAttribute("aria-label", `${productTitle} se adauga in cos`);

    const imageMarkup = imageUrl
      ? `<img class="line-item__media rounded-xs" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(productTitle)}" width="160" height="160" loading="eager" decoding="async">`
      : `<span class="qk-addon-optimistic-line__fallback" aria-hidden="true">${isPackageInsurance ? "🛡️" : "🎁"}</span>`;
    optimisticLine.innerHTML = `
      <div class="line-item__media-wrapper">
        ${imageMarkup}
        <span class="qk-addon-optimistic-line__media-spinner" aria-hidden="true"></span>
      </div>
      <div class="line-item__info">
        <div class="title-close">
          <div class="title-subtitle">
            <p class="bold">${escapeHtml(productTitle)}</p>
            <span class="qk-addon-optimistic-line__status">
              <span class="qk-addon-optimistic-line__status-dot" aria-hidden="true"></span>
              Se adauga...
            </span>
          </div>
        </div>
        <div class="price-quantity gap-1">
          <span class="bold">${escapeHtml(formatLei(priceCents))}</span>
        </div>
      </div>
    `;

    const progressMount = lineItemsElement.querySelector(".qk-cart-progress-mount");
    if (progressMount instanceof HTMLElement) {
      progressMount.insertAdjacentElement("afterend", optimisticLine);
    } else {
      lineItemsElement.prepend(optimisticLine);
    }

    document.querySelectorAll("cart-drawer [data-qk-cart-total-value]").forEach((element) => {
      updateCartMoneyElement(element, baseTotalCents + priceCents);
    });

    const scheduleFrame = typeof window.requestAnimationFrame === "function"
      ? window.requestAnimationFrame.bind(window)
      : (callback) => window.setTimeout(callback, 0);
    scheduleFrame(() => {
      if (optimisticLine.isConnected) {
        optimisticLine.classList.add("is-visible");
      }
    });

    return optimisticLine;
  }

  function clearOptimisticAddonSelection(type, options) {
    const normalizedOptions = options || {};
    const normalizedType = type === "package-insurance" ? "package-insurance" : "gift-wrap";
    document
      .querySelectorAll(`[data-qk-addon-optimistic-line="${normalizedType}"]`)
      .forEach((element) => {
        if (!(element instanceof HTMLElement)) {
          return;
        }
        element.classList.add("is-clearing");
        window.setTimeout(() => {
          if (element.isConnected) {
            element.remove();
          }
        }, normalizedOptions.immediate ? 0 : 140);
      });

    if (normalizedOptions.restoreTotal && state.lastCart) {
      renderCartTotalValues(state.lastCart);
    }
  }

  function hasOptimisticAddonSelection() {
    return Boolean(document.querySelector("[data-qk-addon-optimistic-line]"));
  }

  function resolveCartDrawerElement() {
    const drawerElement =
      document.querySelector("cart-drawer#cart-drawer") ||
      document.querySelector("cart-drawer");
    return drawerElement instanceof HTMLElement ? drawerElement : null;
  }

  function restoreCartDrawerOpenStateIfNeeded(drawerElement, wasOpen) {
    if (!(drawerElement instanceof HTMLElement) || !wasOpen || drawerElement.hasAttribute("open")) {
      return;
    }

    try {
      if (typeof drawerElement.show === "function") {
        drawerElement.show(false);
      } else {
        drawerElement.setAttribute("open", "");
      }
    } catch (error) {
      debugLog("[qk-cart-rules] failed to restore cart drawer open state", error);
    }
  }

  async function removeLubricationFromParentLine(input) {
    const payload = input && typeof input === "object" ? input : {};
    const parentLineKey = String(payload.parentLineKey || "").trim();
    const parentVariantLegacyId = normalizeLegacyId(payload.parentVariantLegacyId);
    const managedLineKey = String(payload.managedLineKey || "").trim();
    const managedRuleKey = String(payload.managedRuleKey || "").trim();
    const trigger = payload.trigger instanceof HTMLElement ? payload.trigger : null;
    const attachmentElement = payload.attachmentElement instanceof HTMLElement ? payload.attachmentElement : null;

    if (!parentLineKey && !managedLineKey) {
      return;
    }

    // Prevent stale PDP intent from re-selecting lubrication right after cart removal.
    clearPendingLubricationIntentSnapshot();

    if (trigger) {
      if (trigger instanceof HTMLButtonElement) {
        trigger.disabled = true;
      }
      trigger.setAttribute("aria-disabled", "true");
    }
    if (attachmentElement) {
      attachmentElement.setAttribute("aria-busy", "true");
    }

    const previousProcessingLookup = Object.assign({}, safeObject(state.processingLineKeys));
    const nextProcessingLookup = Object.assign({}, previousProcessingLookup);
    if (parentLineKey) {
      nextProcessingLookup[parentLineKey] = true;
    }
    state.processingLineKeys = nextProcessingLookup;
    applyProcessingLineState();

    try {
      await flushPendingLineMutations();

      let baseCart = normalizeCartPayload(state.lastCart) || null;
      if (!baseCart) {
        try {
          baseCart = normalizeCartPayload(await fetchCartJson()) || null;
          if (baseCart) {
            state.lastCart = baseCart;
          }
        } catch (initialRefreshError) {
          debugLog("[qk-cart-rules] initial lube remove cart fetch failed", initialRefreshError);
        }
      }

      if (!baseCart) {
        scheduleSync("lube-remove-no-cart", null);
        return;
      }

      let initialTargets = resolveLubricationRemovalTargets(baseCart, {
        parentLineKey,
        parentVariantLegacyId,
        managedLineKey,
        managedRuleKey,
      });

      if (!initialTargets.parentLine && !initialTargets.managedLineKey) {
        try {
          const refreshedCart = normalizeCartPayload(await fetchCartJson()) || null;
          if (refreshedCart) {
            baseCart = refreshedCart;
            state.lastCart = refreshedCart;
            initialTargets = resolveLubricationRemovalTargets(baseCart, {
              parentLineKey,
              parentVariantLegacyId,
              managedLineKey,
              managedRuleKey,
            });
          }
        } catch (refreshForTargetsError) {
          debugLog("[qk-cart-rules] lube remove target refresh failed", refreshForTargetsError);
        }
      }

      let resolvedParentLine = initialTargets.parentLine;
      let resolvedParentLineKey = String((resolvedParentLine && resolvedParentLine.key) || parentLineKey).trim();

      if (!resolvedParentLine || !resolvedParentLineKey) {
        if (initialTargets.managedLineKey) {
          try {
            const managedOnlyCart = await requestCartLineChangeWithFallback(baseCart, {
              lineKey: initialTargets.managedLineKey,
              quantity: 0,
            });
            const normalizedManagedOnlyCart = normalizeCartPayload(managedOnlyCart) || normalizeCartPayload(baseCart) || state.lastCart;
            if (normalizedManagedOnlyCart) {
              state.lastCart = normalizedManagedOnlyCart;
            }
            scheduleSync("lube-remove-managed-only", normalizedManagedOnlyCart || baseCart || null);
            return;
          } catch (managedOnlyRemovalError) {
            debugLog("[qk-cart-rules] managed-only lube removal failed", managedOnlyRemovalError);
          }
        }
        scheduleSync("lube-remove-parent-missing", baseCart || null);
        return;
      }

      if (!nextProcessingLookup[resolvedParentLineKey]) {
        const refreshedProcessingLookup = Object.assign({}, safeObject(state.processingLineKeys), {
          [resolvedParentLineKey]: true,
        });
        state.processingLineKeys = refreshedProcessingLookup;
        applyProcessingLineState();
      }

      const parentQuantity = Math.max(1, parseInteger(resolvedParentLine.quantity));
      const deselectedProperties = buildLubricationSelectionProperties({
        selected: false,
        scope: "",
        ruleKey: "",
        layoutAlias: "",
      });
      const mergedParentProperties = Object.assign(
        {},
        stripPublicLubricationProperties(resolvedParentLine && resolvedParentLine.properties),
        deselectedProperties,
      );

      let updatedCart = null;
      try {
        updatedCart = await requestCartLineChangeWithFallback(baseCart, {
          lineKey: resolvedParentLineKey,
          quantity: parentQuantity,
          properties: mergedParentProperties,
        });
      } catch (parentChangeError) {
        let retried = false;
        try {
          const refreshedCart = normalizeCartPayload(await fetchCartJson()) || null;
          if (refreshedCart) {
            baseCart = refreshedCart;
            state.lastCart = refreshedCart;
            const retryTargets = resolveLubricationRemovalTargets(baseCart, {
              parentLineKey,
              parentVariantLegacyId,
              managedLineKey,
              managedRuleKey,
            });
            const retryParentLine = retryTargets.parentLine;
            const retryParentLineKey = String((retryParentLine && retryParentLine.key) || "").trim();
            if (retryParentLine && retryParentLineKey) {
              resolvedParentLine = retryParentLine;
              resolvedParentLineKey = retryParentLineKey;
              const retryParentQuantity = Math.max(1, parseInteger(retryParentLine.quantity));
              const retryMergedParentProperties = Object.assign(
                {},
                stripPublicLubricationProperties(retryParentLine && retryParentLine.properties),
                deselectedProperties,
              );
              updatedCart = await requestCartLineChangeWithFallback(baseCart, {
                lineKey: retryParentLineKey,
                quantity: retryParentQuantity,
                properties: retryMergedParentProperties,
              });
              retried = true;
            }
          }
        } catch (retryParentChangeError) {
          debugLog("[qk-cart-rules] lube remove parent retry failed", retryParentChangeError);
        }

        if (!retried || !updatedCart) {
          throw parentChangeError;
        }
      }

      let normalizedCart = normalizeCartPayload(updatedCart) || normalizeCartPayload(baseCart) || state.lastCart;
      const postParentTargets = resolveLubricationRemovalTargets(normalizedCart, {
        parentLineKey: resolvedParentLineKey,
        parentVariantLegacyId,
        managedLineKey: String((initialTargets.managedLine && initialTargets.managedLine.key) || managedLineKey).trim(),
        managedRuleKey: initialTargets.managedRuleKey || managedRuleKey,
      });
      const managedLineKeyToRemove = postParentTargets.managedLineKey;

      if (managedLineKeyToRemove) {
        try {
          updatedCart = await requestCartLineChangeWithFallback(normalizedCart, {
            lineKey: managedLineKeyToRemove,
            quantity: 0,
          });
          normalizedCart = normalizeCartPayload(updatedCart) || normalizedCart;
        } catch (managedRemovalError) {
          try {
            const refreshedCart = normalizeCartPayload(await fetchCartJson()) || null;
            if (refreshedCart) {
              state.lastCart = refreshedCart;
              const refreshedTargets = resolveLubricationRemovalTargets(refreshedCart, {
                parentLineKey: resolvedParentLineKey,
                parentVariantLegacyId,
                managedLineKey,
                managedRuleKey,
              });
              if (refreshedTargets.managedLineKey) {
                updatedCart = await requestCartLineChangeWithFallback(refreshedCart, {
                  lineKey: refreshedTargets.managedLineKey,
                  quantity: 0,
                });
                normalizedCart = normalizeCartPayload(updatedCart) || normalizeCartPayload(refreshedCart) || normalizedCart;
              }
            }
          } catch (managedRetryError) {
            debugLog("[qk-cart-rules] managed lube retry removal failed; fallback sync will reconcile", managedRetryError);
          }
          if (!normalizedCart) {
            debugLog("[qk-cart-rules] managed lube direct removal failed; fallback sync will reconcile", managedRemovalError);
          }
        }
      }

      if (normalizedCart) {
        state.lastCart = normalizedCart;
      }

      // Immediate DOM feedback — remove the attachment visually
      if (attachmentElement && attachmentElement.parentElement) {
        attachmentElement.remove();
      }
      const domManagedLineKey = String(managedLineKeyToRemove || managedLineKey).trim();
      if (domManagedLineKey) {
        document.querySelectorAll(
          'line-item[data-line-key="' + CSS.escape(domManagedLineKey) + '"]'
        ).forEach(function (el) {
          var container = getLineContainer(el);
          if (container) container.classList.add("qk-lube-line--hidden");
        });
      }

      try {
        await syncNow("lube-attachment-remove", {
          seedCart: normalizedCart,
          forceEmit: true,
          hardTimeoutMs: 12000,
        });
      } catch (syncAfterRemoveError) {
        debugLog("[qk-cart-rules] lube remove immediate sync failed; scheduling fallback sync", syncAfterRemoveError);
        scheduleSync("lube-attachment-remove-reconcile-fallback", normalizedCart || null);
      }
    } catch (error) {
      reportError(error, "Nu am putut elimina lubrifierea din cos.");
      scheduleSync("lube-attachment-remove-fallback", null);
    } finally {
      state.processingLineKeys = previousProcessingLookup;
      applyProcessingLineState();

      if (trigger && trigger.isConnected) {
        if (trigger instanceof HTMLButtonElement) {
          trigger.disabled = false;
        }
        trigger.removeAttribute("aria-disabled");
        trigger.removeAttribute("data-qk-lube-removing");
      }
      if (attachmentElement && attachmentElement.isConnected) {
        attachmentElement.removeAttribute("aria-busy");
      }
    }
  }

  function resolveLubricationRemovalTargets(cart, input) {
    const payload = input && typeof input === "object" ? input : {};
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const requestedParentLineKey = String(payload.parentLineKey || "").trim();
    const requestedParentVariantLegacyId = normalizeLegacyId(payload.parentVariantLegacyId);
    const requestedManagedLineKey = String(payload.managedLineKey || "").trim();
    const requestedRuleKey = String(payload.managedRuleKey || "").trim();
    const ruleMaps = buildLubricationRuleMaps(getLubricationConfig());

    let parentLine = requestedParentLineKey ? findLineByKey(cart, requestedParentLineKey) : null;
    let managedLine = requestedManagedLineKey ? findLineByKey(cart, requestedManagedLineKey) : null;

    if (!managedLine && requestedParentLineKey) {
      const managedBySource = getManagedLubricationLinesBySourceLineKey(items, requestedParentLineKey);
      if (managedBySource.length === 1) {
        managedLine = managedBySource[0];
      } else if (managedBySource.length > 1 && requestedRuleKey) {
        managedLine = managedBySource.find((line) => lineMatchesLubricationRule(line, requestedRuleKey, ruleMaps)) || null;
      }
    }

    if (!parentLine && requestedParentVariantLegacyId) {
      parentLine =
        items.find((line) => {
          return (
            isEligibleLubricationParentLine(line) &&
            normalizeLegacyId(line && line.variant_id) === requestedParentVariantLegacyId
          );
        }) || null;
    }

    const resolvedRuleKey = requestedRuleKey || getLubricationRuleKeyForLine(managedLine, ruleMaps);

    if (managedLine) {
      const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(items, managedLine, ruleMaps, {
        preferredParentLineKey: requestedParentLineKey,
      });
      if (resolvedSourceLineKey) {
        parentLine = findLineByKey(cart, resolvedSourceLineKey) || parentLine;
      }
    }

    if (!parentLine && managedLine) {
      const sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_LUBE_SOURCE));
      const sourceVariantLegacyId =
        normalizeLegacyId(getLineProperty(managedLine, ATTR_LUBE_SOURCE_VARIANT)) ||
        extractVariantLegacyIdFromLineKey(sourceLineKey);
      if (sourceVariantLegacyId) {
        parentLine =
          items.find((line) => {
            return (
              isEligibleLubricationParentLine(line) &&
              normalizeLegacyId(line && line.variant_id) === sourceVariantLegacyId
            );
          }) || null;
      }
    }

    if (!parentLine && resolvedRuleKey) {
      parentLine = findBestLubricationParentLineByRule(items, resolvedRuleKey, ruleMaps, managedLine);
    }

    if (!managedLine && parentLine) {
      const managedBySource = getManagedLubricationLinesBySourceLineKey(items, String(parentLine.key || ""));
      if (managedBySource.length === 1) {
        managedLine = managedBySource[0];
      } else if (managedBySource.length > 1 && resolvedRuleKey) {
        managedLine = managedBySource.find((line) => lineMatchesLubricationRule(line, resolvedRuleKey, ruleMaps)) || null;
      }
    }

    if (!managedLine && resolvedRuleKey) {
      const managedByRule = items.filter((line) => {
        return isManagedLubricationLine(line) && lineMatchesLubricationRule(line, resolvedRuleKey, ruleMaps);
      });
      if (managedByRule.length === 1) {
        managedLine = managedByRule[0];
      }
    }

    return {
      parentLine,
      managedLine,
      parentLineKey: String((parentLine && parentLine.key) || "").trim(),
      managedLineKey: String((managedLine && managedLine.key) || "").trim(),
      managedRuleKey: resolvedRuleKey,
    };
  }

  function getManagedLubricationLinesBySourceLineKey(items, sourceLineKey) {
    const normalizedSourceLineKey = normalizeManagedSourceLineKey(sourceLineKey);
    if (!normalizedSourceLineKey) {
      return [];
    }

    return (Array.isArray(items) ? items : []).filter((line) => {
      return (
        isManagedLubricationLine(line) &&
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE)) === normalizedSourceLineKey
      );
    });
  }

  function getLubricationRuleKeyForLine(line, ruleMaps) {
    if (!line) {
      return "";
    }

    const explicitRuleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
    if (explicitRuleKey) {
      return explicitRuleKey;
    }

    const resolvedRule = isManagedLubricationLine(line)
      ? resolveLubricationRuleForManagedLine(line, ruleMaps)
      : resolveLubricationRuleForLine(line, ruleMaps);
    return String((resolvedRule && resolvedRule.key) || "").trim();
  }

  function lineMatchesLubricationRule(line, ruleKey, ruleMaps) {
    const normalizedRuleKey = String(ruleKey || "").trim();
    if (!normalizedRuleKey) {
      return false;
    }

    return getLubricationRuleKeyForLine(line, ruleMaps) === normalizedRuleKey;
  }

  function findBestLubricationParentLineByRule(items, ruleKey, ruleMaps, managedLine) {
    const preferredScope = normalizeLubricationScope(getLineProperty(managedLine, ATTR_LUBE_SCOPE));
    const candidates = (Array.isArray(items) ? items : []).filter((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return false;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return false;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (!scope) {
        return false;
      }

      if (preferredScope && scope !== preferredScope) {
        return false;
      }

      return lineMatchesLubricationRule(line, ruleKey, ruleMaps);
    });

    if (!candidates.length) {
      return null;
    }

    if (candidates.length === 1) {
      return candidates[0];
    }

    const managedQuantity = Math.max(1, parseInteger(managedLine && managedLine.quantity));
    const exactQuantityMatch = candidates.find((line) => {
      return Math.max(1, parseInteger(line && line.quantity)) === managedQuantity;
    });
    return exactQuantityMatch || candidates[0];
  }

  function isEligibleLubricationParentLine(line) {
    if (
      !line ||
      isManagedLubricationLine(line) ||
      isManagedFeeLine(line) ||
      isManagedGiftLine(line) ||
      isManagedGiftWrapLine(line) ||
      isManagedPackageInsuranceLine(line)
    ) {
      return false;
    }

    const lineKey = String(line && line.key ? line.key : "").trim();
    if (!lineKey) {
      return false;
    }

    return Math.max(0, parseInteger(line && line.quantity)) > 0;
  }

  function isEligibleGiftWrapBaseLine(line) {
    if (
      !line ||
      isManagedGiftWrapLine(line) ||
      isManagedPackageInsuranceLine(line) ||
      isManagedGiftLine(line) ||
      isManagedFeeLine(line) ||
      isManagedLubricationLine(line)
    ) {
      return false;
    }

    const lineKey = String(line && line.key ? line.key : "").trim();
    if (!lineKey) {
      return false;
    }

    return Math.max(0, parseInteger(line && line.quantity)) > 0;
  }

  function hasEligibleGiftWrapBaseLine(items) {
    return (Array.isArray(items) ? items : []).some((line) => isEligibleGiftWrapBaseLine(line));
  }

  function cartNeedsGiftWrapVariantResolution(cart) {
    const normalizedCart = normalizeCartPayload(cart) || safeObject(cart);
    const attributes = safeObject(normalizedCart && normalizedCart.attributes);
    const selectedValue = String(
      attributes[ATTR_GIFT_WRAP_SELECTED] == null ? "" : attributes[ATTR_GIFT_WRAP_SELECTED],
    ).trim().toLowerCase();
    if (selectedValue === "1" || selectedValue === "true") {
      return true;
    }

    return (Array.isArray(normalizedCart && normalizedCart.items) ? normalizedCart.items : []).some((line) => {
      return isManagedGiftWrapLine(line);
    });
  }

  async function onCheckoutSubmit(event) {
    try {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      if (!form.hasAttribute("data-qk-standard-checkout-form")) {
        return;
      }

      if (form.dataset.qkSyncBypass === "1") {
        delete form.dataset.qkSyncBypass;
        return;
      }

      const submitter = "submitter" in event ? event.submitter : null;
      if (submitter instanceof Element && submitter.closest(".shopify-payment-button, .shopify-cleanslate")) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      state.checkoutNavigationActive = true;
      refreshCheckoutButtonsBusy();

      clearCheckoutSyncError(form);

      if (hasPendingCheckoutWork() || state.cartRecoveryRequired || needsB2bCheckoutAttributeSync()) {
        try {
          await syncNow("checkout-submit", { forceEmit: false });
        } catch (error) {
          state.checkoutNavigationActive = false;
          const errorForm = resolveLiveCheckoutForm(form, submitter) || form;
          showCheckoutSyncError(errorForm, "Nu am putut actualiza cosul. Verifica conexiunea si incearca din nou.");
          refreshCheckoutButtonsBusy();
          reportError(error, "Checkout oprit pentru a evita trimiterea unui cos nesincronizat.");
          return;
        }
      }

      const liveForm = resolveLiveCheckoutForm(form, submitter);
      if (!(liveForm instanceof HTMLFormElement)) {
        armCheckoutFallback(getCheckoutFallbackDelayMs());
        window.location.href = `${getRootPath()}checkout`;
        return;
      }

      const liveSubmitter = liveForm.querySelector("button[name='checkout']");
      if (!(liveSubmitter instanceof HTMLButtonElement)) {
        armCheckoutFallback(getCheckoutFallbackDelayMs());
        window.location.href = `${getRootPath()}checkout`;
        return;
      }

      liveForm.dataset.qkSyncBypass = "1";
      armCheckoutFallback(getCheckoutFallbackDelayMs());
      if (typeof liveForm.requestSubmit === "function") {
        // Passing the live checkout button preserves name="checkout" in the
        // POST. Omitting it turns this into a plain /cart form submission.
        // Keep aria-busy latched for feedback, but let the submitter remain a
        // successful form control so Shopify receives its checkout value.
        liveSubmitter.removeAttribute("disabled");
        liveForm.requestSubmit(liveSubmitter);
      } else {
        window.location.href = `${getRootPath()}checkout`;
      }
    } catch (submitHandlerError) {
      reportError(submitHandlerError, "Checkout submit a esuat in script; redirectionez direct catre checkout.");
      window.location.href = `${getRootPath()}checkout`;
    }
  }

  function onPrimaryCheckoutPointerDown(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const checkoutButton = target.closest("button[name='checkout']");
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return;
    }

    if (checkoutButton.disabled || checkoutButton.getAttribute("aria-busy") === "true") {
      return;
    }

    if (isFastTouchPointerEvent(event)) {
      stopCartControlEvent(event);
      rememberFastTouchCartControl(event, {
        type: "checkout",
        element: checkoutButton,
      });
      return;
    }
  }

  function onPrimaryCheckoutPointerUp(event) {
    const intent = resolveActiveFastTouchCartControl(event, "checkout");
    if (!intent || !(intent.element instanceof HTMLButtonElement)) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    submitCheckoutFromButton(intent.element);
  }

  function resolveCheckoutButtonFromEvent(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return null;
    }

    const checkoutButton = target.closest("button[name='checkout']");
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return null;
    }

    if (checkoutButton.disabled || checkoutButton.getAttribute("aria-busy") === "true") {
      return null;
    }

    return checkoutButton;
  }

  function onPrimaryCheckoutTouchStart(event) {
    const checkoutButton = resolveCheckoutButtonFromEvent(event);
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return;
    }

    if (
      rememberDirectTouchCartControl(event, {
        type: "checkout",
        element: checkoutButton,
      })
    ) {
      stopCartControlEvent(event);
    }
  }

  function onPrimaryCheckoutTouchEnd(event) {
    const intent = resolveDirectTouchCartControl(event, "checkout");
    if (!intent || !(intent.element instanceof HTMLButtonElement)) {
      return;
    }

    stopCartControlEvent(event);
    if (wasFastTouchRecentlyHandled(intent.element)) {
      return;
    }

    markFastTouchHandled(intent.element);
    submitCheckoutFromButton(intent.element);
  }

  function onPrimaryCheckoutClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const checkoutButton = target.closest("button[name='checkout']");
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return;
    }

    if (consumeFastTouchClick(event, checkoutButton)) {
      return;
    }

    if (!checkoutButton.contains(target)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    submitCheckoutFromButton(checkoutButton);
  }

  function submitCheckoutFromButton(checkoutButton) {
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return;
    }

    const form = resolveCheckoutFormForButton(checkoutButton);
    if (!(form instanceof HTMLFormElement)) {
      if (isCartPagePath() || isInsideCartUI(checkoutButton)) {
        window.location.href = `${getRootPath()}checkout`;
      }
      return;
    }

    if (checkoutButton.disabled || checkoutButton.getAttribute("aria-busy") === "true") {
      return;
    }

    if (checkoutButton.dataset.qkManualCheckoutClick === "1") {
      return;
    }

    checkoutButton.dataset.qkManualCheckoutClick = "1";
    try {
      state.checkoutNavigationActive = true;
      requestCheckoutFormSubmit(form, checkoutButton);
    } catch (clickSubmitError) {
      reportError(clickSubmitError, "Checkout click a esuat in script; redirectionez direct catre checkout.");
      window.location.href = `${getRootPath()}checkout`;
    } finally {
      delete checkoutButton.dataset.qkManualCheckoutClick;
    }
  }

  function resolveCheckoutFormForButton(button) {
    if (!(button instanceof HTMLButtonElement)) {
      return null;
    }

    const closestForm = button.closest("form[data-qk-standard-checkout-form]");
    if (closestForm instanceof HTMLFormElement) {
      return closestForm;
    }

    if (button.form instanceof HTMLFormElement && button.form.hasAttribute("data-qk-standard-checkout-form")) {
      return button.form;
    }

    const explicitFormId = String(button.getAttribute("form") || "").trim();
    if (!explicitFormId) {
      return null;
    }

    const explicitForm = document.getElementById(explicitFormId);
    if (explicitForm instanceof HTMLFormElement && explicitForm.hasAttribute("data-qk-standard-checkout-form")) {
      return explicitForm;
    }

    return null;
  }

  function requestCheckoutFormSubmit(form, submitter) {
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(submitter instanceof HTMLButtonElement ? submitter : undefined);
      return;
    }

    // Legacy fallback still enters the synchronization handler. Calling
    // form.submit() here would bypass it and omit the checkout submitter.
    const submitEvent = typeof SubmitEvent === "function"
      ? new SubmitEvent("submit", {
          bubbles: true,
          cancelable: true,
          submitter: submitter instanceof HTMLButtonElement ? submitter : null,
        })
      : new Event("submit", { bubbles: true, cancelable: true });
    form.dispatchEvent(submitEvent);
  }

  function resolveLiveCheckoutForm(form, submitter) {
    if (form instanceof HTMLFormElement && form.isConnected) {
      return form;
    }

    const formId = String(form instanceof HTMLFormElement ? form.id || "" : "").trim();
    if (formId) {
      const formById = document.getElementById(formId);
      if (formById instanceof HTMLFormElement && formById.hasAttribute("data-qk-standard-checkout-form")) {
        return formById;
      }
    }

    const sourceElement = submitter instanceof Element ? submitter : form;
    const wasDrawerCheckout = sourceElement instanceof Element && Boolean(sourceElement.closest("cart-drawer"));
    const selector = wasDrawerCheckout
      ? "cart-drawer [data-qk-standard-checkout-form]"
      : ".shopify-section--main-cart [data-qk-standard-checkout-form]";
    const contextualForm = document.querySelector(selector);
    if (contextualForm instanceof HTMLFormElement) {
      return contextualForm;
    }

    const fallbackForm = document.querySelector("[data-qk-standard-checkout-form]");
    return fallbackForm instanceof HTMLFormElement ? fallbackForm : null;
  }

  function isCartPagePath() {
    const path = String(window.location.pathname || "").toLowerCase();
    return /\/cart(?:\/|$)/.test(path);
  }

  function clearCheckoutFallbackTimer() {
    if (state.checkoutFallbackTimer) {
      clearTimeout(state.checkoutFallbackTimer);
      state.checkoutFallbackTimer = null;
    }
  }

  function armCheckoutFallback(delayMs) {
    clearCheckoutFallbackTimer();
    const fallbackHref = `${getRootPath()}checkout`;
    const resolvedDelay = Number(delayMs);
    const timeoutMs = Number.isFinite(resolvedDelay) && resolvedDelay > 0 ? resolvedDelay : 900;
    state.checkoutFallbackTimer = window.setTimeout(() => {
      state.checkoutFallbackTimer = null;
      window.location.href = fallbackHref;
    }, timeoutMs);
  }

  function hasPendingCheckoutWork() {
    return Boolean(
      state.inFlight ||
        state.rerun ||
        state.debounceTimer ||
        state.lineMutationInFlight ||
        state.lineMutationDrainTimer ||
        state.lineMutationQueue.length ||
        Object.keys(safeObject(state.pendingManagedRemovalKeys)).length,
    );
  }

  function isMobileViewport() {
    return Boolean(window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
  }

  function getCheckoutFallbackDelayMs() {
    return isMobileViewport() ? 1800 : 2200;
  }

  function onCheckoutRetryClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const retryButton = target.closest("[data-qk-checkout-retry]");
    if (!(retryButton instanceof HTMLElement)) {
      return;
    }

    const form = retryButton.closest("form[data-qk-standard-checkout-form]");
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const recoverOnly = retryButton.hasAttribute("data-qk-cart-recovery-only");
    clearCheckoutSyncError(form);
    if (recoverOnly) {
      void syncNow("cart-recovery-retry").catch(() => {});
      return;
    }
    requestCheckoutFormSubmit(form, form.querySelector("button[name='checkout']"));
  }

  function getCheckoutFormKey(form) {
    const action = String(form && form.getAttribute ? form.getAttribute("action") || "" : "");
    const sectionHost = form && form.closest ? form.closest("[data-section-id], [data-main-cart-section-id], cart-drawer") : null;
    const sectionKey = sectionHost instanceof Element
      ? String(
          sectionHost.getAttribute("data-section-id") ||
            sectionHost.getAttribute("data-main-cart-section-id") ||
            sectionHost.id ||
            "",
        )
      : "";
    return `${action}::${sectionKey}`;
  }

  function showCheckoutSyncError(form, message, recoverOnly) {
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const normalizedMessage = String(message || "").trim() || "Sincronizarea cosului a esuat. Incearca din nou.";
    const formKey = getCheckoutFormKey(form);
    state.checkoutErrorMessageByFormKey[formKey] = normalizedMessage;

    let errorBox = form.querySelector(".qk-checkout-sync-error");
    if (!(errorBox instanceof HTMLElement)) {
      errorBox = document.createElement("div");
      errorBox.className = "qk-checkout-sync-error";
      errorBox.setAttribute("role", "alert");
      const submitButton = form.querySelector('[name="checkout"]');
      if (submitButton instanceof Element && submitButton.parentNode) {
        submitButton.parentNode.insertBefore(errorBox, submitButton);
      } else {
        form.appendChild(errorBox);
      }
    }

    errorBox.innerHTML = `<span>${escapeHtml(normalizedMessage)}</span><button type="button" data-qk-checkout-retry${recoverOnly ? ' data-qk-cart-recovery-only' : ''}>Reincearca</button>`;
  }

  function clearCheckoutSyncError(form) {
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const formKey = getCheckoutFormKey(form);
    if (formKey && Object.prototype.hasOwnProperty.call(state.checkoutErrorMessageByFormKey, formKey)) {
      delete state.checkoutErrorMessageByFormKey[formKey];
    }

    const errorBox = form.querySelector(".qk-checkout-sync-error");
    if (errorBox) {
      errorBox.remove();
    }
  }

  function refreshCheckoutButtonsBusy() {
    setCheckoutButtonsBusy(
      Boolean(state.checkoutNavigationActive) ||
        Boolean(state.giftWrapConfirmBusy) ||
        Boolean(state.packageInsuranceConfirmBusy) ||
        Boolean(state.discountCodeRemoving) ||
        Boolean(state.discountMutationPromise) ||
        hasPendingCheckoutWork(),
    );
  }

  function scheduleSync(reason, seedCart, delayMs) {
    // An uncertain mutation must be recovered by an explicit retry, not a
    // background stock probe replaying a plan built from the previous cart.
    if (state.cartRecoveryRequired) {
      return;
    }
    startCartUiObserver();
    state.queuedSeedCart = seedCart || state.queuedSeedCart;
    const requestedDelay = Number(delayMs);
    const resolvedDelayMs = Number.isFinite(requestedDelay) && requestedDelay >= 0
      ? requestedDelay
      : 120;

    if (state.debounceTimer) {
      clearTimeout(state.debounceTimer);
    }

    state.debounceTimer = window.setTimeout(() => {
      state.debounceTimer = null;
      void syncNow(reason || "debounced", { seedCart: state.queuedSeedCart, forceEmit: false }).catch(() => {});
      state.queuedSeedCart = null;
      refreshCheckoutButtonsBusy();
    }, resolvedDelayMs);
    refreshCheckoutButtonsBusy();
  }

  function isMetadataOnlySyncReason(reason) {
    return reason === "gift-stock-refresh" || reason === "lubrication-stock-refresh";
  }

  function isSyncInFlight() {
    return Boolean(
      state.inFlight ||
        state.debounceTimer ||
        state.lineMutationInFlight ||
        state.lineMutationDrainTimer ||
        state.lineMutationQueue.length ||
        state.discountMutationPromise,
    );
  }

  function mergeTouchedLineElements(currentElements, nextElements) {
    return Array.from(
      new Set([...(Array.isArray(currentElements) ? currentElements : []), ...(Array.isArray(nextElements) ? nextElements : [])]),
    ).filter((element) => element instanceof Element);
  }

  function hasQueuedLineMutation(lineKey) {
    const requested = String(lineKey || "").trim();
    if (!requested) {
      return false;
    }

    return state.lineMutationQueue.some((entry) => String((entry && entry.lineKey) || "").trim() === requested);
  }

  function clearResolvedLineQuantityIntent(lineKey, resolvedQuantity) {
    const requested = String(lineKey || "").trim();
    if (!requested || hasQueuedLineMutation(requested)) {
      return;
    }

    const latestQuantity = state.latestIntendedLineQuantities[requested];
    if (!Number.isFinite(latestQuantity) || parseInteger(latestQuantity) === Math.max(0, parseInteger(resolvedQuantity))) {
      delete state.latestIntendedLineQuantities[requested];
    }
  }

  function buildProjectedCartForLineMutations(cart, batch) {
    const normalizedCart = normalizeCartPayload(cart);
    if (!normalizedCart) {
      return null;
    }

    const targetQuantityByLineKey = {};
    (Array.isArray(batch) ? batch : []).forEach((entry) => {
      const lineKey = String(entry && entry.lineKey ? entry.lineKey : "").trim();
      if (lineKey) {
        targetQuantityByLineKey[lineKey] = Math.max(0, parseInteger(entry.targetQuantity));
      }
    });

    return Object.assign({}, normalizedCart, {
      items: normalizedCart.items.map((line) => {
        const lineKey = String(line && line.key ? line.key : "").trim();
        if (!Object.prototype.hasOwnProperty.call(targetQuantityByLineKey, lineKey)) {
          return line;
        }

        return Object.assign({}, line, {
          quantity: targetQuantityByLineKey[lineKey],
        });
      }),
    });
  }

  function appendDirectManagedLineUpdates(updates, cart, batch) {
    const projectedCart = buildProjectedCartForLineMutations(cart, batch);
    if (!projectedCart) {
      return;
    }

    const projectedItems = Array.isArray(projectedCart.items) ? projectedCart.items : [];
    const existingLineKeys = new Set(
      (Array.isArray(cart && cart.items) ? cart.items : [])
        .map((line) => String(line && line.key ? line.key : "").trim())
        .filter(Boolean),
    );

    try {
      const config = getConfig();
      const tagLookup = collectFeeTagLookupsFromDom();
      const feeResolution = computeDesiredFeeQuantities({
        items: projectedItems,
        feeRules: config.fees.rules,
        tagLookup,
      });

      if (feeResolution.tagsReady) {
        const feeOperations = buildFeeOperations({
          items: projectedItems,
          feeRules: config.fees.rules,
          desiredFeeQuantities: feeResolution.desiredQuantities,
          tagLookup,
        });
        feeOperations.forEach((operation) => {
          const lineKey = String(operation && operation.lineKey ? operation.lineKey : "").trim();
          if (operation && operation.type === "change" && lineKey && existingLineKeys.has(lineKey)) {
            updates[lineKey] = Math.max(0, parseInteger(operation.quantity));
          }
        });
      }
    } catch (error) {
      debugLog("[qk-cart-rules] direct fee update projection failed", error);
    }

    const targetQuantityByLineKey = {};
    (Array.isArray(batch) ? batch : []).forEach((entry) => {
      const lineKey = String(entry && entry.lineKey ? entry.lineKey : "").trim();
      if (lineKey) {
        targetQuantityByLineKey[lineKey] = Math.max(0, parseInteger(entry.targetQuantity));
      }
    });

    (Array.isArray(cart && cart.items) ? cart.items : []).forEach((line) => {
      if (!isManagedLubricationLine(line)) {
        return;
      }

      const sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      const managedLineKey = String(line && line.key ? line.key : "").trim();
      if (
        sourceLineKey &&
        managedLineKey &&
        Object.prototype.hasOwnProperty.call(targetQuantityByLineKey, sourceLineKey)
      ) {
        updates[managedLineKey] = targetQuantityByLineKey[sourceLineKey];
      }
    });

    try {
      return appendProjectedGiftRemovals(updates, cart);
    } catch (error) {
      debugLog("[qk-cart-rules] projected gift update failed", error);
      return null;
    }
  }

  // Projects the cart after a quantity batch so lost gift tiers ride along in the
  // same update.js, and returns the projected `_gwp_*` attributes (or null). It
  // only ever removes gifts; the regular sync that follows corrects any drift.
  function appendProjectedGiftRemovals(updates, cart) {
    if (isB2bCheckoutContext()) {
      return null;
    }

    const config = getConfig();
    if (!config.flags.managedRulesEnabled || config.flags.shadowMode || config.flags.killSwitch) {
      return null;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    let projectedTotalCents = Math.max(0, parseInteger(cart && cart.total_price));
    let hasIncrease = false;
    Object.keys(updates).forEach((lineKey) => {
      const line = items.find((candidate) => String(candidate && candidate.key) === lineKey);
      if (!line) {
        return;
      }

      const oldQuantity = Math.max(0, parseInteger(line.quantity));
      const newQuantity = Math.max(0, parseInteger(updates[lineKey]));
      if (newQuantity > oldQuantity) {
        hasIncrease = true;
      }
      if (oldQuantity > 0) {
        const unitFinalCents = parseInteger(line.final_line_price) / oldQuantity;
        projectedTotalCents -= Math.round(unitFinalCents * (oldQuantity - newQuantity));
      }
    });

    const projectedItems = items.map((line) => {
      const lineKey = String(line && line.key ? line.key : "");
      return Object.prototype.hasOwnProperty.call(updates, lineKey)
        ? Object.assign({}, line, { quantity: updates[lineKey], final_line_price: 0 })
        : line;
    });
    const projectedBasisCents = computeThresholdBasisCents(
      projectedItems,
      Math.max(0, projectedTotalCents),
      config.gift.tiers,
    );

    if (!hasIncrease) {
      const unlockedTierIndexes = getAvailableGiftTiers(config.gift.tiers)
        .filter((tier) => projectedBasisCents >= tier.thresholdCents)
        .map((tier) => tier.index);
      const targetTierIndexes = config.gift.mode === "cumulative"
        ? unlockedTierIndexes
        : unlockedTierIndexes.slice(-1);
      items.forEach((line) => {
        if (!isManagedGiftLine(line)) {
          return;
        }

        const tierIndex = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
        if (tierIndex && !targetTierIndexes.includes(tierIndex)) {
          updates[String(line.key)] = 0;
        }
      });
    }

    const desiredAttributes = Object.assign(
      {},
      buildDesiredConfigAttributes(config, projectedBasisCents),
      buildDesiredB2bCheckoutAttributes(cart),
    );
    const attributeUpdates = diffCartAttributes(cart, desiredAttributes);
    return Object.keys(attributeUpdates).length
      ? Object.assign({}, safeObject(cart && cart.attributes), attributeUpdates)
      : null;
  }

  function enqueueLineMutation(mutation) {
    const normalizedMutation = mutation || {};
    const lineKey = String(normalizedMutation.lineKey || "").trim();
    const targetQuantity = Math.max(0, parseInteger(normalizedMutation.targetQuantity));
    const reason = normalizedMutation.reason || "line-item:change";
    const impactedLineItems = Array.isArray(normalizedMutation.impactedLineItems)
      ? normalizedMutation.impactedLineItems.filter((element) => element instanceof Element)
      : [];

    if (!lineKey) {
      return Promise.resolve(state.lastCart);
    }

    state.latestIntendedLineQuantities[lineKey] = targetQuantity;

    return new Promise((resolve, reject) => {
      const existing = state.lineMutationQueue.find((entry) => entry.lineKey === lineKey);
      if (existing) {
        existing.targetQuantity = targetQuantity;
        existing.reason = reason;
        existing.impactedLineItems = mergeTouchedLineElements(existing.impactedLineItems, impactedLineItems);
        existing.resolvers.push({ resolve, reject });
      } else {
        state.lineMutationQueue.push({
          lineKey,
          targetQuantity,
          reason,
          impactedLineItems,
          resolvers: [{ resolve, reject }],
        });
      }

      scheduleLineMutationDrain();
    });
  }

  function scheduleLineMutationDrain() {
    if (state.lineMutationInFlight) {
      refreshCheckoutButtonsBusy();
      return;
    }

    if (state.lineMutationDrainTimer) {
      refreshCheckoutButtonsBusy();
      return;
    }

    state.lineMutationDrainTimer = window.setTimeout(() => {
      state.lineMutationDrainTimer = null;
      void runLineMutationQueue().catch(() => {});
      refreshCheckoutButtonsBusy();
    }, LINE_MUTATION_DEBOUNCE_MS);

    refreshCheckoutButtonsBusy();
  }

  async function flushPendingLineMutations() {
    if (state.lineMutationDrainTimer) {
      clearTimeout(state.lineMutationDrainTimer);
      state.lineMutationDrainTimer = null;
    }

    if (state.lineMutationQueue.length && !state.lineMutationInFlight) {
      void runLineMutationQueue().catch(() => {});
    }

    if (state.lineMutationPromise) {
      await state.lineMutationPromise;
    }

    refreshCheckoutButtonsBusy();
  }

  function getCartLineIdentity(line) {
    const properties = safeObject(line && line.properties);
    return JSON.stringify([
      normalizeLegacyId(line && line.variant_id),
      normalizeLegacyId(line && line.selling_plan_allocation && line.selling_plan_allocation.selling_plan?.id),
      Object.keys(properties).sort().map((key) => [key, String(properties[key])]),
    ]);
  }

  function reconcileQuantityLineKeys(previousCart, nextCart, pendingEntries) {
    const previousItems = Array.isArray(previousCart && previousCart.items) ? previousCart.items : [];
    const nextItems = Array.isArray(nextCart && nextCart.items) ? nextCart.items : [];
    const replacements = new Map();
    previousItems.forEach((previousLine) => {
      const oldKey = String(previousLine.key || "");
      if (!oldKey || findLineByKey(nextCart, oldKey)) return;
      const identity = getCartLineIdentity(previousLine);
      // Discounts can change keys. Only remap an unambiguous same-variant,
      // same-properties, same-selling-plan line; never guess between split lines.
      const beforeMatches = previousItems.filter((line) => getCartLineIdentity(line) === identity);
      const afterMatches = nextItems.filter((line) => getCartLineIdentity(line) === identity);
      if (beforeMatches.length === 1 && afterMatches.length === 1 && afterMatches[0].key) {
        replacements.set(oldKey, String(afterMatches[0].key));
      }
    });
    if (!replacements.size) return;

    [...state.lineMutationQueue, ...(pendingEntries || [])].forEach((entry) => {
      entry.lineKey = replacements.get(entry.lineKey) || entry.lineKey;
    });
    replacements.forEach((newKey, oldKey) => {
      if (Object.prototype.hasOwnProperty.call(state.latestIntendedLineQuantities, oldKey)) {
        state.latestIntendedLineQuantities[newKey] = state.latestIntendedLineQuantities[oldKey];
        delete state.latestIntendedLineQuantities[oldKey];
      }
    });

    // Keep the current row and its controls mounted until the final section
    // arrives. Retarget both drawer and cart-page controls without an HTML swap.
    const keyAttributes = ["data-line-key", "data-qk-line-key", "data-qk-parent-line-key", "data-qk-managed-line-key"];
    document.querySelectorAll(keyAttributes.map((name) => `[${name}]`).join(",")).forEach((element) => {
      keyAttributes.forEach((name) => {
        const replacement = replacements.get(element.getAttribute(name));
        if (replacement) element.setAttribute(name, replacement);
      });
    });
    document.querySelectorAll('button[onclick*="updateQuantity"]').forEach((button) => {
      const handler = button.getAttribute("onclick");
      const match = handler && handler.match(/updateQuantity\(['"]([^'"]+)['"]/);
      const replacement = match && replacements.get(match[1]);
      if (replacement) button.setAttribute("onclick", handler.replace(match[1], replacement));
    });
    document.querySelectorAll('a[href*="/cart/change"]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      const replacement = replacements.get(url.searchParams.get("id"));
      if (replacement) {
        url.searchParams.set("id", replacement);
        link.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
      }
    });
  }

  async function runLineMutationQueue() {
    if (state.lineMutationInFlight) {
      return state.lineMutationPromise || Promise.resolve(state.lastCart);
    }
    if (!state.lineMutationQueue.length) {
      return Promise.resolve(state.lastCart);
    }

    const context = createCartOperationContext();
    const unsettledEntries = [];
    state.lineMutationContext = context;
    state.lineMutationInFlight = true;
    refreshCheckoutButtonsBusy();

    const run = async () => {
      if (state.cartRecoveryRequired) {
        // Do not apply an absolute quantity to a cart whose last result is unknown.
        throw new Error("Revalideaza cosul inainte de a modifica din nou cantitatea.");
      }
      let latestCart = state.lastCart;
      // Server-confirmed cart (it carries a token), so a line missing from it is
      // already gone. When the cart empties, the theme keeps rows visible at 0
      // until the drawer re-renders, so a later tap can still target them.
      let confirmedCart = isCompleteCartPayload(state.lastCart) ? state.lastCart : null;
      let latestReason = "line-item:change";
      while (state.lineMutationQueue.length) {
        assertCartOperationActive(context);
        const batch = state.lineMutationQueue.splice(0, state.lineMutationQueue.length).filter(Boolean);
        unsettledEntries.push(...batch);
        const updates = {};
        batch.forEach((queued) => {
          const targetQuantity = Math.max(0, parseInteger(queued.targetQuantity));
          latestReason = queued.reason || latestReason;
          // A repeated remove tap can queue a line an earlier batch already
          // removed. Shopify rejects the whole update (422) for an unknown line
          // key, which locked the cart into recovery, so that removal is done.
          if (targetQuantity === 0 && confirmedCart && !findLineByKey(confirmedCart, queued.lineKey)) {
            return;
          }
          updates[queued.lineKey] = targetQuantity;
        });

        if (Object.keys(updates).length) {
          const projectedAttributes = appendDirectManagedLineUpdates(updates, latestCart || state.lastCart, batch);

          // Never replay a failed batch per line: Shopify may already have
          // committed it. Recovery reads the cart before another mutation.
          const previousCart = latestCart || state.lastCart;
          latestCart = await requestCartJson(
            "cart/update.js",
            projectedAttributes ? { updates, attributes: projectedAttributes } : { updates },
            context,
          );
          assertCartOperationActive(context);
          if (!isCompleteCartPayload(latestCart)) {
            throw new Error("Invalid cart response after quantity update");
          }
          reconcileQuantityLineKeys(previousCart, latestCart, unsettledEntries);
          state.lastCart = latestCart;
          confirmedCart = latestCart;
        }
        batch.forEach((queued) => {
          const lineAfterChange = findLineByKey(latestCart, queued.lineKey);
          // A missing old key does not prove removal. For ambiguous split lines,
          // preserve the row until Shopify's final HTML resolves its identity.
          const changedQuantity = lineAfterChange
            ? parseInteger(lineAfterChange.quantity)
            : Math.max(0, parseInteger(queued.targetQuantity));
          (queued.impactedLineItems || []).forEach((element) => {
            element.dispatchEvent(new CustomEvent("line-item:change", {
              bubbles: true,
              detail: { quantity: changedQuantity, cart: latestCart },
            }));
          });
          clearResolvedLineQuantityIntent(queued.lineKey, changedQuantity);
        });
      }

      assertCartOperationActive(context);
      const normalizedLatestCart = normalizeCartPayload(latestCart);
      state.lastCart = normalizedLatestCart;
      // Coalesce visual updates into the next frame; quantity events and
      // checkout locking still run immediately through their existing paths.
      scheduleUiRefresh("line-item:fast-update");
      unsettledEntries.forEach((entry) => {
        (entry.resolvers || []).forEach((resolver) => resolver.resolve(normalizedLatestCart));
      });
      if (unsettledEntries.length) {
        // Quantity updates skip section HTML to stay fast, so the follow-up
        // sync must re-render line prices, totals and the empty state.
        state.lineMutationNeedsRender = true;
        scheduleSync(latestReason, normalizedLatestCart, LINE_MUTATION_SYNC_DEBOUNCE_MS);
      }
      return normalizedLatestCart;
    };

    state.lineMutationPromise = run()
      .catch((error) => {
        const failedEntries = unsettledEntries.concat(state.lineMutationQueue.splice(0));
        failedEntries.forEach((entry) => {
          delete state.latestIntendedLineQuantities[entry.lineKey];
          (entry.resolvers || []).forEach((resolver) => resolver.reject(error));
        });
        markCartRecoveryRequired(error);
        reportError(error, "Nu am putut aplica modificarile rapide din cos.");
        throw error;
      })
      .finally(() => {
        state.lineMutationInFlight = false;
        state.lineMutationPromise = null;
        state.lineMutationContext = null;
        if (state.lineMutationQueue.length) {
          scheduleLineMutationDrain();
        }
        refreshCheckoutButtonsBusy();
      });
    return state.lineMutationPromise;
  }

  async function syncNow(reason, options) {
    const normalizedOptions = options || {};
    markPerf("sync-start");
    const syncStartedAt = window.performance && typeof window.performance.now === "function"
      ? window.performance.now()
      : Date.now();

    if (state.debounceTimer) {
      clearTimeout(state.debounceTimer);
      state.debounceTimer = null;
      refreshCheckoutButtonsBusy();
    }

    if (state.inFlight) {
      state.rerun = true;
      if (normalizedOptions.seedCart) {
        state.queuedSeedCart = normalizedOptions.seedCart;
        // A seed received while another sync is mutating can race that mutation.
        // Re-read once at the convergence boundary instead of trusting either
        // response ordering; this is rare and keeps checkout state authoritative.
        state.rerunNeedsCartFetch = true;
      } else if (reason !== "drawer-open" && !isMetadataOnlySyncReason(reason)) {
        state.rerunNeedsCartFetch = true;
      }
      // Opening the drawer does not mutate the cart. Keep the rule rerun on
      // the active sync's latest response, without forcing another cart read.
      // A new seed or another mutation reason still requires that fresh read.
      return state.syncPromise || Promise.resolve(state.lastCart);
    }

    const context = createCartOperationContext();
    let flushingMutations = false;
    const run = async () => {
      if (!normalizedOptions.skipMutationFlush) {
        flushingMutations = true;
        try {
          await flushPendingLineMutations();
        } finally {
          flushingMutations = false;
        }
        assertCartOperationActive(context);
      }
      const recoveringCart = state.cartRecoveryRequired;
      const config = getConfig();
      const lubricationConfig = getLubricationConfig();
      const sectionIds = collectBundledSectionIds();
      dispatchSyncEvent("qk:cart-sync:start", { reason: reason || "sync", startedAt: syncStartedAt });

      let cart = normalizedOptions.seedCart || state.queuedSeedCart || state.lastCart;
      if (!cart || recoveringCart) {
        cart = await fetchCartJson({ fresh: recoveringCart, context });
      }
      assertCartOperationActive(context);
      state.queuedSeedCart = null;

      let hadMutations = false;
      const initialCodFeeCleanupOperations = buildManagedCodFeeCleanupOperations(cart && cart.items);
      if (initialCodFeeCleanupOperations.length) {
        const updates = {};
        initialCodFeeCleanupOperations.forEach((operation) => {
          updates[operation.lineKey] = 0;
        });
        const cleanupPayload = { updates };
        if (sectionIds.length) {
          cleanupPayload.sections = sectionIds;
          cleanupPayload.sections_url = window.location.pathname;
        }
        debugLog("[qk-cart-rules] >> storefront COD fee cleanup", Object.keys(updates));
        cart = normalizeCartPayload(await requestCartJson("cart/update.js", cleanupPayload, context)) || cart;
        assertCartOperationActive(context);
        state.lastCart = cart;
        updateMainCartSection(cart);
        refreshUiFromState();
        if (Object.keys(safeObject(cart && cart.sections)).length) {
          dispatchCartChanged("qk:cod-fee-cleanup", cart);
        }
        hadMutations = true;
      }

      let reachedConvergenceLimit = false;
      for (let iteration = 0; iteration < MAX_SYNC_CONVERGENCE_ITERATIONS; iteration += 1) {
        state.rerun = false;
        state.rerunNeedsCartFetch = false;
        const isB2bCheckout = isB2bCheckoutContext();
        await Promise.all([
          isB2bCheckout ? Promise.resolve() : ensureGiftVariantIds(cart, config),
          ensureLubricationVariantIds(cart, lubricationConfig),
          isB2bCheckout || !cartNeedsGiftWrapVariantResolution(cart)
            ? Promise.resolve()
            : ensureGiftWrapVariantId(cart),
          ensureFeeTagsForCart(cart, config),
        ]);

        assertCartOperationActive(context);
        const plan = buildSyncPlan(cart, config, lubricationConfig);
        state.lastPlanSignature = plan.signature;
        const mutationOperations = resolveMutationOperations(plan, config);
        if (!state.mutationPhaseActive && mutationOperations.length) {
          state.mutationPhaseActive = true;
          refreshCheckoutButtonsBusy();
        }
        const processingLineKeys = deriveProcessingParentLineKeys(cart, mutationOperations);
        setProcessingLineKeys(processingLineKeys);

        if (mutationOperations.length) {
          markManagedLinesPendingRemoval(cart, mutationOperations);
        }

        let result;
        try {
          result = await applySyncPlan(plan, cart, config, sectionIds, context);
        } finally {
          if (!context.error) clearProcessingLineKeys();
        }
        assertCartOperationActive(context);
        cart = result.cart;
        // A `_gwp_*`-only write changes nothing visible; keep the no-op UI path.
        hadMutations = hadMutations || (result.hadMutations && !result.attributesOnly);

        if (!state.rerun) {
          break;
        }

        if (iteration === MAX_SYNC_CONVERGENCE_ITERATIONS - 1) {
          reachedConvergenceLimit = true;
          break;
        }

        const queuedCart = normalizeCartPayload(state.queuedSeedCart);
        if (state.rerunNeedsCartFetch) {
          cart = await fetchCartJson({ context });
          assertCartOperationActive(context);
          state.queuedSeedCart = null;
        } else if (queuedCart) {
          cart = queuedCart;
          state.queuedSeedCart = null;
        }
      }

      if (reachedConvergenceLimit) {
        scheduleSync("convergence-follow-up", cart);
      }

      // No-op fast path: nothing was mutated and no caller mutated the cart
      // beforehand (forceEmit), so the rendered UI is already accurate. Skip
      // section fetches, the main-cart re-render, and the cart:change dispatch
      // (the theme drawer's listener requires cart.sections to be present).
      const renderAfterLineMutation = state.lineMutationNeedsRender;
      state.lineMutationNeedsRender = false;
      const isNoOpSync = !hadMutations && !normalizedOptions.forceEmit && !recoveringCart && !renderAfterLineMutation;
      if (isNoOpSync) {
        debugLog("[qk-cart-rules] no-op sync fast path (no mutations)");
        cart = normalizeCartPayload(cart);
        state.lastCart = cart;

        scheduleUiRefresh("post-sync");
        clearPendingManagedRemovalKeys();
      } else {
        cart = normalizeCartPayload(await ensureCartSections(cart, sectionIds, context));
        assertCartOperationActive(context);
        state.lastCart = cart;

        const drawerUpdatedImmediately = updateCartDrawerSectionImmediately(cart);
        updateMainCartSection(cart);
        // Render after cart:change listeners replace the drawer HTML, sharing
        // the frame already requested by cart events and the DOM observer.
        scheduleUiRefresh("post-sync");
        clearPendingManagedRemovalKeys();

        dispatchCartChanged("qk:cart-sync", cart, {
          preserveDrawerInner: drawerUpdatedImmediately,
        });
      }

      assertCartOperationActive(context);
      if (state.cartRecoveryRequired) {
        if (context.verifiedRecoveryVersion !== state.cartRecoveryVersion) {
          throw new Error("Cosul s-a modificat in timpul recuperarii. Incearca din nou.");
        }
        state.cartRecoveryRequired = false;
      }
      document.querySelectorAll("[data-qk-standard-checkout-form]").forEach(clearCheckoutSyncError);
      dispatchSyncEvent("qk:cart-sync:success", {
        reason: reason || "sync",
        signature: state.lastPlanSignature,
        durationMs: Math.round(
          (window.performance && typeof window.performance.now === "function"
            ? window.performance.now()
            : Date.now()) - syncStartedAt,
        ),
      });

      return cart;
    };

    state.inFlight = true;
    refreshCheckoutButtonsBusy();

    const requestedHardTimeoutMs = Number(normalizedOptions.hardTimeoutMs);
    const resolvedHardTimeoutMs =
      Number.isFinite(requestedHardTimeoutMs) && requestedHardTimeoutMs > 0
        ? Math.max(1000, Math.round(requestedHardTimeoutMs))
        : 15000;
    state.syncPromise = runCartOperation(context, run, resolvedHardTimeoutMs, () => {
      if (flushingMutations && state.lineMutationContext) {
        cancelCartOperation(state.lineMutationContext, context.error);
      }
    })
      .catch((error) => {
        cancelCartOperation(context, error);
        markCartRecoveryRequired(error);
        clearProcessingLineKeys();
        clearPendingManagedRemovalKeys();
        dispatchSyncEvent("qk:cart-sync:error", {
          reason: reason || "sync",
          message: error instanceof Error ? error.message : String(error || "unknown"),
          durationMs: Math.round(
            (window.performance && typeof window.performance.now === "function"
              ? window.performance.now()
              : Date.now()) - syncStartedAt,
          ),
        });
        reportError(error, "Sincronizarea cosului a esuat.");
        throw error;
      })
      .finally(() => {
        clearProcessingLineKeys();
        state.inFlight = false;
        state.mutationPhaseActive = false;
        state.syncPromise = null;
        markPerf("sync-end");
        measurePerf("sync-duration", "sync-start", "sync-end");
        refreshCheckoutButtonsBusy();
      });

    return state.syncPromise;
  }

  function buildSyncPlan(cart, config, lubricationConfig) {
    const cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    const storefrontCleanupOperations = buildManagedCodFeeCleanupOperations(cartItems);
    const thresholdBasisCents =
      computeThresholdBasisCents(
        cartItems,
        parseInteger(cart && cart.total_price),
        config.gift.tiers,
      ) + resolvePendingAddonThresholdDeltaCents(cartItems);
    const isB2bCheckout = isB2bCheckoutContext();

    if (isB2bCheckout) {
      const cleanupOperations = buildB2bManagedRuleCleanupOperations({
        items: cartItems,
        config,
      });
      const upsellCleanupOperations = buildUpsellCleanupOperations({
        items: cartItems,
      });
      const operations = [
        ...cleanupOperations,
        ...storefrontCleanupOperations,
        ...upsellCleanupOperations,
      ];
      const desiredAttributes = Object.assign({}, buildDesiredB2bCheckoutAttributes(cart), {
        [ATTR_GIFT_WRAP_SELECTED]: "0",
        [ATTR_PACKAGE_INSURANCE_SELECTED]: "0",
      });
      const attributeUpdates = diffCartAttributes(cart, desiredAttributes);
      const desiredFeeQuantities = buildEmptyFeeQuantityMap(config.fees.rules);
      const signature = [
        "b2b:1",
        `cleanup:${cleanupOperations.map(serializeOperation).join("|")}`,
        `upsell:${upsellCleanupOperations.map(serializeOperation).join("|")}`,
        `attr:${Object.keys(attributeUpdates).sort().join(",")}`,
      ].join(";");

      debugLog("[qk-cart-rules] B2B sync plan", {
        cleanup: cleanupOperations.length,
        upsell: upsellCleanupOperations.length,
        attrKeys: Object.keys(attributeUpdates).length,
      });

      return {
        signature,
        operations: dedupeOperations(operations),
        storefrontCleanupOperations,
        lubricationOperations: [],
        attributeUpdates,
        desiredAttributes,
        thresholdBasisCents,
        targetTierIndexes: [],
        desiredFeeQuantities,
        feeTagsReady: true,
        giftWrapSelected: false,
        giftWrapVariantLegacyId: "",
        packageInsuranceSelected: false,
        packageInsuranceVariantLegacyId: "",
      };
    }

    const availableGiftTiers = getAvailableGiftTiers(config.gift.tiers);
    const unlockedTierIndexes = availableGiftTiers
      .filter((tier) => thresholdBasisCents >= tier.thresholdCents)
      .map((tier) => tier.index);

    const targetTierIndexes =
      config.gift.mode === "cumulative"
        ? unlockedTierIndexes
        : unlockedTierIndexes.length
          ? [unlockedTierIndexes[unlockedTierIndexes.length - 1]]
          : [];

    const tagLookup = collectFeeTagLookupsFromDom();
    const feeResolution = computeDesiredFeeQuantities({
      items: cartItems,
      feeRules: config.fees.rules,
      tagLookup,
    });
    const desiredFeeQuantities = feeResolution.desiredQuantities;

    const giftOperations = buildGiftOperations({
      items: cartItems,
      giftTiers: config.gift.tiers,
      targetTierIndexes,
    });

    const feeOperations = feeResolution.tagsReady
      ? buildFeeOperations({
          items: cartItems,
          feeRules: config.fees.rules,
          desiredFeeQuantities,
          tagLookup,
        })
      : [];

    const requestedGiftWrapSelection = readGiftWrapSelected(cart, cartItems);
    const giftWrapHasBaseLine = hasEligibleGiftWrapBaseLine(cartItems);
    const giftWrapVariantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const giftWrapCanBeSelected = Boolean(state.giftWrapInStock && giftWrapVariantLegacyId && giftWrapHasBaseLine);
    const targetGiftWrapSelection = requestedGiftWrapSelection && giftWrapCanBeSelected;
    const giftWrapOperations = buildGiftWrapOperations({
      items: cartItems,
      selected: targetGiftWrapSelection,
      variantLegacyId: giftWrapVariantLegacyId,
    });
    const requestedPackageInsuranceSelection = readPackageInsuranceSelected(cart, cartItems);
    const packageInsuranceVariantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const packageInsuranceCanBeSelected = Boolean(
      state.packageInsuranceInStock &&
        packageInsuranceVariantLegacyId &&
        giftWrapHasBaseLine,
    );
    const targetPackageInsuranceSelection = requestedPackageInsuranceSelection && packageInsuranceCanBeSelected;
    const packageInsuranceOperations = buildPackageInsuranceOperations({
      items: cartItems,
      selected: targetPackageInsuranceSelection,
      variantLegacyId: packageInsuranceVariantLegacyId,
    });

    const lubricationOperations = buildLubricationOperations({
      items: cartItems,
      lubricationConfig,
    });
    const upsellCleanupOperations = buildUpsellCleanupOperations({
      items: cartItems,
    });

    const desiredAttributes = Object.assign(
      {},
      buildDesiredConfigAttributes(config, thresholdBasisCents),
      buildDesiredB2bCheckoutAttributes(cart),
      {
        [ATTR_GIFT_WRAP_SELECTED]: targetGiftWrapSelection ? "1" : "0",
        [ATTR_PACKAGE_INSURANCE_SELECTED]: targetPackageInsuranceSelection ? "1" : "0",
      },
    );
    const attributeUpdates = diffCartAttributes(cart, desiredAttributes);

    const operations = [
      ...storefrontCleanupOperations,
      ...giftOperations,
      ...feeOperations,
      ...giftWrapOperations,
      ...packageInsuranceOperations,
      ...lubricationOperations,
      ...upsellCleanupOperations,
    ];
    const signature = [
      `tiers:${targetTierIndexes.join(",")}`,
      `fees:${feeResolution.tagsReady ? KNOWN_FEE_RULE_KEYS.map((key) => `${key}:${desiredFeeQuantities[key] || 0}`).join(",") : "tags-pending"}`,
      `giftWrap:${targetGiftWrapSelection ? "1" : "0"}:${giftWrapVariantLegacyId || "none"}:base:${giftWrapHasBaseLine ? "1" : "0"}`,
      `packageInsurance:${targetPackageInsuranceSelection ? "1" : "0"}:${packageInsuranceVariantLegacyId || "none"}:base:${giftWrapHasBaseLine ? "1" : "0"}`,
      `ops:${dedupeOperations(operations).map(serializeOperation).join("|")}`,
      `attr:${Object.keys(attributeUpdates).sort().join(",")}`,
    ].join(";");

    debugLog("[qk-cart-rules] sync plan", {
      ops: operations.length,
      codCleanup: storefrontCleanupOperations.length,
      gift: giftOperations.length,
      fee: feeOperations.length,
      lube: lubricationOperations.length,
      wrap: giftWrapOperations.length,
      insurance: packageInsuranceOperations.length,
      upsell: upsellCleanupOperations.length,
      attrKeys: Object.keys(attributeUpdates).length,
      basis: thresholdBasisCents,
      tiers: targetTierIndexes,
    });

    return {
      signature,
      operations: dedupeOperations(operations),
      storefrontCleanupOperations,
      lubricationOperations,
      attributeUpdates,
      desiredAttributes,
      thresholdBasisCents,
      targetTierIndexes,
      desiredFeeQuantities,
      feeTagsReady: feeResolution.tagsReady,
      giftWrapSelected: targetGiftWrapSelection,
      giftWrapVariantLegacyId,
      packageInsuranceSelected: targetPackageInsuranceSelection,
      packageInsuranceVariantLegacyId,
    };
  }

  function resolvePendingAddonThresholdDeltaCents(cartItems) {
    const items = Array.isArray(cartItems) ? cartItems : [];
    let pendingDeltaCents = 0;

    const hasGiftWrapLine = items.some(
      (line) => normalizeLegacyId(line && line.product_id) === normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID),
    );
    if (state.giftWrapPendingSelection && !hasGiftWrapLine) {
      pendingDeltaCents += resolveGiftWrapPriceCents(
        state.giftWrapProduct,
        state.giftWrapVariantLegacyId,
        null,
      );
    }

    const hasPackageInsuranceLine = items.some(
      (line) =>
        normalizeLegacyId(line && line.product_id) === normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID),
    );
    if (state.packageInsurancePendingSelection && !hasPackageInsuranceLine) {
      pendingDeltaCents += resolveGiftWrapPriceCents(
        state.packageInsuranceProduct,
        state.packageInsuranceVariantLegacyId,
        null,
      );
    }

    return Math.max(0, pendingDeltaCents);
  }

  function resolveMutationOperations(plan, config) {
    const allOperations = Array.isArray(plan && plan.operations) ? plan.operations : [];
    const storefrontCleanupOperations = Array.isArray(plan && plan.storefrontCleanupOperations)
      ? plan.storefrontCleanupOperations
      : [];
    const lubricationOperations = Array.isArray(plan && plan.lubricationOperations) ? plan.lubricationOperations : [];
    const canMutateManagedRules =
      Boolean(config && config.flags && config.flags.managedRulesEnabled) &&
      !Boolean(config && config.flags && config.flags.shadowMode) &&
      !Boolean(config && config.flags && config.flags.killSwitch);

    if (canMutateManagedRules) {
      return allOperations;
    }

    return dedupeOperations([
      ...storefrontCleanupOperations,
      ...lubricationOperations,
    ]);
  }

  async function applySyncPlan(plan, cart, config, sectionIds, context) {
    assertCartOperationActive(context);
    const canMutateManagedRules =
      Boolean(config.flags.managedRulesEnabled) &&
      !Boolean(config.flags.shadowMode) &&
      !Boolean(config.flags.killSwitch);
    const operations = resolveMutationOperations(plan, config);
    const canMutateRules = operations.length > 0;

    const canMutateAttributes = canMutateManagedRules;

    let hadMutations = false;
    let nextCart = cart;
    const hasAttributeUpdates = Object.keys(plan.attributeUpdates).length > 0;
    const includeBundledSections = Array.isArray(sectionIds) && sectionIds.length > 0;

    const batches = buildOperationBatches(operations);
    const hasUpdates = Object.keys(batches.updates).length > 0;
    const hasPropertyChanges = batches.propertyChanges.length > 0;
    const hasAdds = batches.adds.length > 0;
    const hasLineMutations = canMutateRules && (hasUpdates || hasPropertyChanges || hasAdds);

    const canFoldAttributesIntoUpdate =
      hasAttributeUpdates &&
      canMutateAttributes &&
      !hasLineMutations;
    const needsTrailingAttributeCheck = canMutateAttributes && hasLineMutations;
    // `_gwp_*` mirrors are not rendered by the cart sections, so writing only
    // them needs no section HTML and no drawer re-render.
    const attributesOnlyWrite =
      canFoldAttributesIntoUpdate &&
      Object.keys(plan.attributeUpdates).every((key) => key.startsWith("_gwp_"));

    let pendingMutationSteps = 0;
    if ((canMutateRules && hasUpdates) || canFoldAttributesIntoUpdate) {
      pendingMutationSteps += 1;
    }
    if (canMutateRules && hasPropertyChanges) {
      pendingMutationSteps += batches.propertyChanges.length;
    }
    if (canMutateRules && hasAdds) {
      pendingMutationSteps += 1;
    }
    if (needsTrailingAttributeCheck) {
      pendingMutationSteps += 1;
    }

    const attachSectionsIfFinalStep = (payload) => {
      if (!includeBundledSections || pendingMutationSteps !== 1) {
        return;
      }

      payload.sections = sectionIds;
      payload.sections_url = window.location.pathname;
    };

    if (operations.length && !canMutateRules && config.flags.log) {
      debugLog("[qk-cart-rules] shadow operation plan", operations);
    }

    if ((canMutateRules && hasUpdates) || canFoldAttributesIntoUpdate) {
      const payload = {};
      if (hasUpdates) {
        payload.updates = batches.updates;
      }
      // Line updates can carry the planned attributes too; the trailing
      // attribute check below still verifies them against the final cart.
      if (canFoldAttributesIntoUpdate || (hasAttributeUpdates && canMutateAttributes)) {
        payload.attributes = Object.assign({}, safeObject(nextCart && nextCart.attributes), plan.attributeUpdates);
      }
      if (!attributesOnlyWrite) {
        attachSectionsIfFinalStep(payload);
      }
      debugLog("[qk-cart-rules] >> update.js", {
        updates: hasUpdates,
        attrs: canFoldAttributesIntoUpdate,
      });

      const updatedCart = await requestCartJson("cart/update.js", payload, context);
      if (updatedCart && typeof updatedCart === "object") {
        nextCart = updatedCart;
      }
      pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
      hadMutations = true;
    }

    if (canMutateRules) {
      for (const operation of batches.propertyChanges) {
        debugLog("[qk-cart-rules] >> change.js", operation.lineKey);
        const operationCart = await applyOperation(operation, sectionIds, pendingMutationSteps === 1, context);
        if (operationCart && typeof operationCart === "object") {
          nextCart = operationCart;
        }
        pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
        hadMutations = true;
      }
    }

    if (canMutateRules && hasAdds) {
      debugLog("[qk-cart-rules] >> add.js", batches.adds.length, "items");
      const requireCompleteCartAfterAdd = true;
      const canBundleAddSectionsForTrailingAttributes = Boolean(
        includeBundledSections && needsTrailingAttributeCheck && pendingMutationSteps === 2,
      );
      const addResult = await applyAddOperationBatch(
        batches.adds,
        config,
        sectionIds,
        (includeBundledSections && pendingMutationSteps === 1) || canBundleAddSectionsForTrailingAttributes,
        requireCompleteCartAfterAdd,
        context,
      );
      if (addResult.cart && typeof addResult.cart === "object") {
        nextCart = addResult.cart;
      }
      if (addResult.shouldRerun) {
        state.rerun = true;
      }
      pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
      hadMutations = hadMutations || Boolean(addResult.hadMutations);

      // Shopify's multi-item cart/add.js response normally contains only the
      // added lines. Never derive checkout attributes from that partial shape.
      if (needsTrailingAttributeCheck && !isCompleteCartPayload(nextCart)) {
        nextCart = await resolveCompleteCartAfterAdd(nextCart, true, context);
      }
    }

    if (needsTrailingAttributeCheck) {
      assertCartOperationActive(context);
      const desiredAttributes = buildDesiredAttributesForCart(nextCart, config, plan);
      const freshAttributeUpdates = diffCartAttributes(nextCart, desiredAttributes);
      if (Object.keys(freshAttributeUpdates).length) {
        const mergedAttributes = Object.assign(
          {},
          safeObject(nextCart && nextCart.attributes),
          freshAttributeUpdates,
        );
        const payload = { attributes: mergedAttributes };
        const reusableSections = safeObject(nextCart && nextCart.sections);
        const canReuseBundledSections = Boolean(
          includeBundledSections &&
            sectionIds.every((sectionId) => typeof reusableSections[sectionId] === "string"),
        );
        if (!canReuseBundledSections) {
          attachSectionsIfFinalStep(payload);
        }
        debugLog("[qk-cart-rules] >> trailing attrs", Object.keys(freshAttributeUpdates));
        const cartAfterAttributeUpdate = await requestCartJson("cart/update.js", payload, context);
        nextCart = canReuseBundledSections
          ? Object.assign({}, cartAfterAttributeUpdate || {}, { sections: reusableSections })
          : cartAfterAttributeUpdate;
        hadMutations = true;
      }
      pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
    } else if (hasAttributeUpdates && !canMutateAttributes && config.flags.log) {
      debugLog("[qk-cart-rules] shadow attribute updates", plan.attributeUpdates);
    }

    if (hadMutations && !isCompleteCartPayload(nextCart)) {
      nextCart = await fetchCartJson({ context });
    }

    return {
      cart: nextCart,
      hadMutations,
      attributesOnly: attributesOnlyWrite,
    };
  }

  async function applyOperation(operation, sectionIds, includeSections, context) {
    assertCartOperationActive(context);
    if (operation.type === "change") {
      const payload = {
        id: operation.lineKey,
        quantity: operation.quantity,
      };

      if (operation.properties) {
        payload.properties = operation.properties;
      }

      if (includeSections && Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      return requestCartJson("cart/change.js", payload, context);
    }

    if (operation.type === "add") {
      const variantLegacyId = normalizeLegacyId(operation.variantLegacyId);
      if (!variantLegacyId) {
        return null;
      }

      const payload = {
        items: [
          {
            id: Number(variantLegacyId),
            quantity: Math.max(1, parseInteger(operation.quantity)),
            properties: operation.properties || {},
          },
        ],
      };

      if (includeSections && Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      return requestCartJson("cart/add.js", payload, context);
    }

    return null;
  }

  async function applyAddOperationBatch(adds, config, sectionIds, includeSections, requireCompleteCart, context) {
    assertCartOperationActive(context);
    const operations = Array.isArray(adds) ? adds : [];
    const payload = buildCartAddPayload(operations);
    if (!payload.items.length) {
      return { cart: null, hadMutations: false, shouldRerun: false };
    }
    if (includeSections && Array.isArray(sectionIds) && sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = window.location.pathname;
    }

    let addResponse;
    try {
      addResponse = await requestCartJson("cart/add.js", payload, context);
    } catch (error) {
      assertCartOperationActive(context);
      // Even a 422 can partially add stock. Never replay the original batch.
      // Network, timeout and parse failures remain uncertain until explicit recovery.
      const giftAdds = operations.filter(isGiftAddOperation);
      if (error.status !== 422 || !giftAdds.length) {
        throw error;
      }
      const refreshedCart = await fetchCartJson({ fresh: true, context });
      assertCartOperationActive(context);
      const missingGiftAdds = giftAdds.filter((operation) => !refreshedCart.items.some((line) =>
        normalizeLegacyId(line.variant_id) === normalizeLegacyId(operation.variantLegacyId) &&
        lineHasProperties(line, operation.properties || {}) && parseInteger(line.quantity) > 0,
      ));
      if (!missingGiftAdds.length) {
        throw error;
      }
      markGiftAddOperationsUnavailable(missingGiftAdds, config);
      // The next convergence pass calculates only what is still missing, using
      // the cart returned by Shopify, including any paid lines already committed.
      return { cart: refreshedCart, hadMutations: true, shouldRerun: true };
    }

    // A failure to hydrate a successful add must not enter the inventory fallback.
    const completeCart = await resolveCompleteCartAfterAdd(addResponse, requireCompleteCart, context);
    assertCartOperationActive(context);
    return { cart: completeCart, hadMutations: true, shouldRerun: false };
  }

  function buildCartAddPayload(adds) {
    return {
      items: (Array.isArray(adds) ? adds : [])
        .map((operation) => {
          const variantLegacyId = normalizeLegacyId(operation && operation.variantLegacyId);
          if (!variantLegacyId) {
            return null;
          }

          return {
            id: Number(variantLegacyId),
            quantity: Math.max(1, parseInteger(operation.quantity)),
            properties: operation.properties || {},
          };
        })
        .filter(Boolean),
    };
  }

  async function resolveCompleteCartAfterAdd(addResponse, requireCompleteCart, context) {
    assertCartOperationActive(context);
    if (isCompleteCartPayload(addResponse)) {
      debugLog("[qk-cart-rules] complete cart returned after add");
      return addResponse;
    }

    const bundledCart = extractBundledCartSeed(addResponse);
    if (bundledCart) {
      debugLog("[qk-cart-rules] complete cart restored from bundled section seed");
      return bundledCart;
    }

    if (requireCompleteCart) {
      debugLog("[qk-cart-rules] complete cart fallback after partial add response");
      return fetchCartJson({ context });
    }

    return addResponse;
  }

  function isGiftAddOperation(operation) {
    const properties = safeObject(operation && operation.properties);
    return properties[ATTR_GWP_MANAGED] === "1" || properties[ATTR_GWP_TIER] != null;
  }

  function markGiftAddOperationsUnavailable(adds, config) {
    const tiers = Array.isArray(config && config.gift && config.gift.tiers) ? config.gift.tiers : [];
    const tierIndexes = new Set(
      (Array.isArray(adds) ? adds : [])
        .map((operation) => parseInteger(safeObject(operation && operation.properties)[ATTR_GWP_TIER]))
        .filter((tierIndex) => tierIndex >= 1 && tierIndex <= 3),
    );

    tiers.forEach((tier) => {
      if (!tierIndexes.has(parseInteger(tier && tier.index))) {
        return;
      }

      const productLegacyId = normalizeLegacyId(tier && tier.giftProductLegacyId);
      tier.giftVariantLegacyId = "";
      tier.inStock = false;
      tier.hasSellableVariant = false;
      if (productLegacyId) {
        delete state.resolvedGiftVariantsByProductId[productLegacyId];
      }
    });
  }

  function buildOperationBatches(operations) {
    const updates = {};
    const propertyChanges = [];
    const addBuckets = {};

    (Array.isArray(operations) ? operations : []).forEach((operation) => {
      if (!operation || typeof operation !== "object") {
        return;
      }

      if (operation.type === "change") {
        const lineKey = String(operation.lineKey || "").trim();
        if (!lineKey) {
          return;
        }

        if (operation.properties && typeof operation.properties === "object") {
          propertyChanges.push(operation);
          return;
        }

        updates[lineKey] = Math.max(0, parseInteger(operation.quantity));
        return;
      }

      if (operation.type !== "add") {
        return;
      }

      const variantLegacyId = normalizeLegacyId(operation.variantLegacyId);
      if (!variantLegacyId) {
        return;
      }

      const quantity = Math.max(1, parseInteger(operation.quantity));
      const properties = operation.properties && typeof operation.properties === "object" ? operation.properties : {};
      const bucketKey = `${variantLegacyId}::${serializeProperties(properties)}`;

      if (!addBuckets[bucketKey]) {
        addBuckets[bucketKey] = {
          type: "add",
          variantLegacyId,
          quantity: 0,
          properties,
        };
      }

      addBuckets[bucketKey].quantity += quantity;
    });

    return {
      updates,
      propertyChanges,
      adds: Object.values(addBuckets),
    };
  }

  function isCartPayload(payload) {
    return Boolean(payload && typeof payload === "object" && Array.isArray(payload.items));
  }

  function isCompleteCartPayload(payload) {
    if (!isCartPayload(payload)) {
      return false;
    }

    const itemCount = Number(payload.item_count);
    const totalPrice = Number(payload.total_price);
    const subtotalPrice = Number(payload.items_subtotal_price);
    const hasToken = Boolean(String(payload.token || "").trim());
    const hasAttributes = payload.attributes && typeof payload.attributes === "object";

    return (
      Number.isFinite(itemCount) &&
      itemCount >= 0 &&
      Number.isFinite(totalPrice) &&
      totalPrice >= 0 &&
      Number.isFinite(subtotalPrice) &&
      subtotalPrice >= 0 &&
      hasToken &&
      hasAttributes
    );
  }

  function normalizeCartPayload(payload) {
    if (!payload || typeof payload !== "object") {
      return null;
    }

    if (!Array.isArray(payload.items)) {
      return null;
    }

    const nextPayload = Object.assign({}, payload);
    const itemCount = Number(nextPayload.item_count);
    if (!Number.isFinite(itemCount) || itemCount < 0) {
      nextPayload.item_count = payload.items.reduce((total, line) => {
        return total + Math.max(0, parseInteger(line && line.quantity));
      }, 0);
    }

    return nextPayload;
  }

  function extractBundledCartSeed(payload) {
    const sections = safeObject(payload && payload.sections);
    if (typeof DOMParser !== "function") {
      return null;
    }

    const parser = new DOMParser();
    for (const sectionId of Object.keys(sections)) {
      const sectionHtml = sections[sectionId];
      if (typeof sectionHtml !== "string" || !sectionHtml.includes("data-qk-cart-seed")) {
        continue;
      }

      try {
        const sectionDocument = parser.parseFromString(sectionHtml, "text/html");
        const seedElement = sectionDocument.querySelector("script[data-qk-cart-seed]");
        const seed = seedElement ? JSON.parse(String(seedElement.textContent || "null")) : null;
        const bundledCartToken = String(
          (seed && seed.token) ||
            (state.lastCart && state.lastCart.token) ||
            (state.cartPageSeedCart && state.cartPageSeedCart.token) ||
            readCartTokenCookie() ||
            "",
        ).trim();
        const hydratedSeed = seed && typeof seed === "object"
          ? Object.assign({}, seed, { token: bundledCartToken })
          : null;
        if (isCompleteCartPayload(hydratedSeed)) {
          return Object.assign({}, hydratedSeed, { sections });
        }
      } catch {
        // Keep the authoritative cart.js fallback below available.
      }
    }

    return null;
  }

  // Liquid's `cart | json` has no token; the storefront `cart` cookie holds the
  // same value, so bundled section seeds can skip a follow-up cart.js read.
  function readCartTokenCookie() {
    const match = String(document.cookie || "").match(/(?:^|; )cart=([^;]*)/);
    if (!match) {
      return "";
    }

    try {
      return decodeURIComponent(match[1]);
    } catch {
      return "";
    }
  }

  function buildGiftOperations(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const giftTiers = Array.isArray(input.giftTiers) ? input.giftTiers : [];
    const availableTierIndexes = new Set(getAvailableGiftTiers(giftTiers).map((tier) => tier.index));
    const targetTierIndexes = new Set(
      (Array.isArray(input.targetTierIndexes) ? input.targetTierIndexes : []).filter((tierIndex) =>
        availableTierIndexes.has(tierIndex),
      ),
    );

    const managedGiftLines = items.filter((item) => isManagedGiftLine(item));
    const tierByIndex = {};
    giftTiers.forEach((tier) => {
      tierByIndex[tier.index] = tier;
    });

    const targetGiftProductIds = new Set(
      Array.from(targetTierIndexes)
        .map((tierIndex) => tierByIndex[tierIndex])
        .filter(Boolean)
        .map((tier) => tier.giftProductLegacyId),
    );

    const operations = [];

    for (const line of managedGiftLines) {
      const lineTier = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
      const keepByTier = targetTierIndexes.has(lineTier);
      const keepByProduct = targetGiftProductIds.has(normalizeLegacyId(line.product_id));
      if (!keepByTier && !keepByProduct) {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      }
    }

    for (const targetTierIndex of targetTierIndexes) {
      const tier = tierByIndex[targetTierIndex];
      if (!isGiftTierAvailable(tier)) {
        continue;
      }

      const variantLegacyId = normalizeLegacyId(tier.giftVariantLegacyId);
      if (!variantLegacyId) {
        continue;
      }

      const exactMatches = managedGiftLines.filter(
        (line) => parseInteger(getLineProperty(line, ATTR_GWP_TIER)) === targetTierIndex,
      );
      const productMatches = managedGiftLines.filter(
        (line) => normalizeLegacyId(line.product_id) === tier.giftProductLegacyId,
      );
      const existingLines = exactMatches.length ? exactMatches : productMatches;

      const desiredManagedProperties = {
        [ATTR_GWP_MANAGED]: "1",
        [ATTR_GWP_TIER]: String(targetTierIndex),
      };
      const addProperties = {
        ...desiredManagedProperties,
        [ATTR_GWP_SOURCE]: SOURCE_STOREFRONT,
      };

      if (!existingLines.length) {
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: 1,
          properties: addProperties,
        });
        continue;
      }

      const primary =
        existingLines.find((line) => normalizeLegacyId(line.variant_id) === variantLegacyId) || existingLines[0];

      const extras = existingLines.filter((line) => line.key !== primary.key);
      extras.forEach((extra) => {
        const extraMatchesTargetProduct = normalizeLegacyId(extra.product_id) === tier.giftProductLegacyId;
        const extraMatchesTargetVariant = normalizeLegacyId(extra.variant_id) === variantLegacyId;
        if (extraMatchesTargetProduct && extraMatchesTargetVariant) {
          return;
        }

        operations.push({
          type: "change",
          lineKey: extra.key,
          quantity: 0,
        });
      });

      const desiredQuantity = Math.max(1, parseInteger(primary.quantity));
      const primaryVariantMismatch = normalizeLegacyId(primary.variant_id) !== variantLegacyId;
      const needsPropertyUpdate = !lineHasProperties(primary, desiredManagedProperties);

      if (primaryVariantMismatch) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: 0,
        });
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: desiredQuantity,
          properties: addProperties,
        });
        continue;
      }

      if (needsPropertyUpdate) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: desiredQuantity,
          properties: desiredManagedProperties,
        });
      }
    }

    return dedupeOperations(operations);
  }

  function buildB2bManagedRuleCleanupOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const config = safeObject(input && input.config);
    const feeProductIds = new Set(
      (Array.isArray(config && config.fees && config.fees.rules) ? config.fees.rules : [])
        .map((rule) => normalizeLegacyId(rule && rule.feeProductLegacyId))
        .filter(Boolean),
    );
    const b2bExcludedProductIds = new Set([
      ...feeProductIds,
      normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID),
      normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID),
    ].filter(Boolean));
    const operations = [];

    items.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      const productLegacyId = normalizeLegacyId(line && line.product_id);
      const shouldRemove =
        isManagedGiftLine(line) ||
        isManagedFeeLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line) ||
        b2bExcludedProductIds.has(productLegacyId);

      if (!shouldRemove) {
        return;
      }

      operations.push({
        type: "change",
        lineKey,
        quantity: 0,
      });
    });

    return dedupeOperations(operations);
  }

  function buildManagedCodFeeCleanupOperations(items) {
    return dedupeOperations(
      (Array.isArray(items) ? items : [])
        .filter((line) => isManagedCodFeeLine(line))
        .map((line) => ({
          type: "change",
          lineKey: String(line && line.key ? line.key : "").trim(),
          quantity: 0,
        }))
        .filter((operation) => Boolean(operation.lineKey)),
    );
  }

  function buildGiftWrapOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const selected = Boolean(input && input.selected);
    const variantLegacyId = normalizeLegacyId(input && input.variantLegacyId);
    const giftWrapProductLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    const operations = [];

    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedGiftWrapLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === giftWrapProductLegacyId;
    });

    if (!selected || !variantLegacyId) {
      relatedLines.forEach((line) => {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      });

      return dedupeOperations(operations);
    }

    const desiredManagedProperties = {
      [ATTR_GIFT_WRAP_MANAGED]: "1",
      [ATTR_GIFT_WRAP_SOURCE]: SOURCE_STOREFRONT,
    };

    if (!relatedLines.length) {
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    const primary = relatedLines.find((line) => normalizeLegacyId(line && line.variant_id) === variantLegacyId) || relatedLines[0];
    const extras = relatedLines.filter((line) => String(line && line.key ? line.key : "").trim() !== String(primary && primary.key ? primary.key : "").trim());

    extras.forEach((line) => {
      operations.push({
        type: "change",
        lineKey: line.key,
        quantity: 0,
      });
    });

    const primaryVariantMismatch = normalizeLegacyId(primary && primary.variant_id) !== variantLegacyId;
    const primaryQuantity = Math.max(0, parseInteger(primary && primary.quantity));
    const needsQuantityUpdate = primaryQuantity !== 1;
    const needsPropertyUpdate = !lineHasProperties(primary, desiredManagedProperties);

    if (primaryVariantMismatch) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 0,
      });
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    if (needsQuantityUpdate || needsPropertyUpdate) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 1,
        properties: desiredManagedProperties,
      });
    }

    return dedupeOperations(operations);
  }

  function buildPackageInsuranceOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const selected = Boolean(input && input.selected);
    const variantLegacyId = normalizeLegacyId(input && input.variantLegacyId);
    const packageInsuranceProductLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    const operations = [];

    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedPackageInsuranceLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === packageInsuranceProductLegacyId;
    });

    if (!selected || !variantLegacyId) {
      relatedLines.forEach((line) => {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      });

      return dedupeOperations(operations);
    }

    const desiredManagedProperties = {
      [ATTR_PACKAGE_INSURANCE_MANAGED]: "1",
      [ATTR_PACKAGE_INSURANCE_SOURCE]: SOURCE_STOREFRONT,
    };

    if (!relatedLines.length) {
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    const primary =
      relatedLines.find((line) => normalizeLegacyId(line && line.variant_id) === variantLegacyId) || relatedLines[0];
    const extras = relatedLines.filter((line) => {
      return String(line && line.key ? line.key : "").trim() !== String(primary && primary.key ? primary.key : "").trim();
    });

    extras.forEach((line) => {
      operations.push({
        type: "change",
        lineKey: line.key,
        quantity: 0,
      });
    });

    const primaryVariantMismatch = normalizeLegacyId(primary && primary.variant_id) !== variantLegacyId;
    const primaryQuantity = Math.max(0, parseInteger(primary && primary.quantity));
    const needsQuantityUpdate = primaryQuantity !== 1;
    const needsPropertyUpdate = !lineHasProperties(primary, desiredManagedProperties);

    if (primaryVariantMismatch) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 0,
      });
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    if (needsQuantityUpdate || needsPropertyUpdate) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 1,
        properties: desiredManagedProperties,
      });
    }

    return dedupeOperations(operations);
  }

  function buildUpsellCleanupOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const operations = [];

    items.forEach((line) => {
      if (!lineHasPublicUpsellProperties(line)) {
        return;
      }

      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      const quantity = Math.max(0, parseInteger(line && line.quantity));
      if (!quantity) {
        return;
      }

      const currentProperties = safeObject(line && line.properties);
      const sanitizedProperties = stripPublicUpsellProperties(currentProperties);
      if (serializeProperties(sanitizedProperties) === serializeProperties(currentProperties)) {
        return;
      }

      operations.push({
        type: "change",
        lineKey,
        quantity,
        properties: sanitizedProperties,
      });
    });

    return dedupeOperations(operations);
  }

  function buildFeeOperations(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const feeRules = Array.isArray(input.feeRules) ? input.feeRules : [];
    const tagLookup = input.tagLookup || { byLineKey: {}, byProductId: {} };

    const managedFeeLines = items.filter((item) => isManagedFeeLine(item));
    const operations = [];
    const feeRuleByKey = {};
    (Array.isArray(feeRules) ? feeRules : []).forEach((rule) => {
      const key = String(rule && rule.key ? rule.key : "").trim();
      if (!key) {
        return;
      }
      feeRuleByKey[key] = rule;
    });

    const desiredTargetsBySourceAndRule = {};
    (Array.isArray(items) ? items : []).forEach((line) => {
      if (!isEligibleFeeParentLine(line)) {
        return;
      }

      const sourceLineKey = String(line && line.key ? line.key : "").trim();
      if (!sourceLineKey) {
        return;
      }

      const targetQuantity = Math.max(0, parseInteger(line && line.quantity));
      if (!targetQuantity) {
        return;
      }

      const tags = resolveFeeTagsForLine(line, tagLookup);
      if (!tags.length) {
        return;
      }

      const matchedRules = resolveMatchedFeeRules(tags, feeRules);
      matchedRules.forEach((ruleKey) => {
        const rule = feeRuleByKey[ruleKey];
        const variantLegacyId = normalizeLegacyId(rule && rule.feeVariantLegacyId);
        if (!variantLegacyId) {
          return;
        }

        const targetKey = `${sourceLineKey}::${ruleKey}`;
        desiredTargetsBySourceAndRule[targetKey] = {
          sourceLineKey,
          sourceVariantLegacyId: normalizeLegacyId(line && line.variant_id),
          ruleKey,
          variantLegacyId,
          quantity: targetQuantity,
        };
      });
    });

    const managedBySourceAndRule = {};
    managedFeeLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      const managedRuleKey = resolveFeeRuleKeyForManagedLine(line, feeRules);
      const sourceLineKey = resolveFeeManagedSourceLineKey(items, line, feeRules, tagLookup);
      if (!managedRuleKey || !sourceLineKey) {
        return;
      }

      const targetKey = `${sourceLineKey}::${managedRuleKey}`;
      managedBySourceAndRule[targetKey] = managedBySourceAndRule[targetKey] || [];
      managedBySourceAndRule[targetKey].push(line);
    });

    const usedManagedLineKeys = new Set();
    Object.values(desiredTargetsBySourceAndRule).forEach((target) => {
      const targetKey = `${target.sourceLineKey}::${target.ruleKey}`;
      const existingLines = Array.isArray(managedBySourceAndRule[targetKey]) ? managedBySourceAndRule[targetKey] : [];

      const desiredManagedProperties = {
        [ATTR_FEE_MANAGED]: "1",
        [ATTR_FEE_RULE]: target.ruleKey,
        [ATTR_FEE_SOURCE]: target.sourceLineKey,
        [ATTR_FEE_SOURCE_VARIANT]:
          normalizeLegacyId(target.sourceVariantLegacyId) || extractVariantLegacyIdFromLineKey(target.sourceLineKey),
      };
      const addProperties = {
        ...desiredManagedProperties,
      };

      if (!existingLines.length) {
        operations.push({
          type: "add",
          variantLegacyId: target.variantLegacyId,
          quantity: target.quantity,
          properties: addProperties,
        });
        return;
      }

      const primary =
        existingLines.find((line) => normalizeLegacyId(line && line.variant_id) === target.variantLegacyId) || existingLines[0];
      const extras = existingLines.filter((line) => String(line && line.key ? line.key : "").trim() !== String(primary && primary.key ? primary.key : "").trim());

      extras.forEach((extra) => {
        const extraLineKey = String(extra && extra.key ? extra.key : "").trim();
        if (!extraLineKey) {
          return;
        }
        usedManagedLineKeys.add(extraLineKey);
        operations.push({
          type: "change",
          lineKey: extraLineKey,
          quantity: 0,
        });
      });

      const primaryLineKey = String(primary && primary.key ? primary.key : "").trim();
      if (!primaryLineKey) {
        operations.push({
          type: "add",
          variantLegacyId: target.variantLegacyId,
          quantity: target.quantity,
          properties: addProperties,
        });
        return;
      }

      usedManagedLineKeys.add(primaryLineKey);

      const primaryVariantMismatch = normalizeLegacyId(primary && primary.variant_id) !== target.variantLegacyId;
      const primaryQuantity = Math.max(0, parseInteger(primary && primary.quantity));
      const needsQuantityUpdate = primaryQuantity !== target.quantity;
      const strictPropertyMatch = lineHasProperties(primary, desiredManagedProperties);
      const needsPropertyUpdate = !lineHasPropertiesExcludingKeys(primary, desiredManagedProperties, [ATTR_FEE_SOURCE]);

      if (primaryVariantMismatch) {
        operations.push({
          type: "change",
          lineKey: primaryLineKey,
          quantity: 0,
        });
        operations.push({
          type: "add",
          variantLegacyId: target.variantLegacyId,
          quantity: target.quantity,
          properties: addProperties,
        });
        return;
      }

      if (needsQuantityUpdate || needsPropertyUpdate) {
        operations.push({
          type: "change",
          lineKey: primaryLineKey,
          quantity: target.quantity,
          properties: desiredManagedProperties,
        });
      } else if (!strictPropertyMatch) {
        debugLog("[qk-cart-rules] fee source-only skip", primaryLineKey);
      }
    });

    managedFeeLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey || usedManagedLineKeys.has(lineKey)) {
        return;
      }

      operations.push({
        type: "change",
        lineKey,
        quantity: 0,
      });
    });

    return dedupeOperations(operations);
  }

  function buildFeeParentLineKeyMap(items, feeRules, tagLookup) {
    const byRule = {};
    const lineKeyLookup = safeObject(tagLookup && tagLookup.byLineKey);
    const productIdLookup = safeObject(tagLookup && tagLookup.byProductId);

    (Array.isArray(items) ? items : []).forEach((line) => {
      if (
        !line ||
        isManagedFeeLine(line) ||
        isManagedGiftLine(line) ||
        isManagedLubricationLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line)
      ) {
        return;
      }

      const lineKey = String(line.key || "").trim();
      if (!lineKey) {
        return;
      }

      const productId = normalizeLegacyId(line.product_id);
      const hasLineTags = Object.prototype.hasOwnProperty.call(lineKeyLookup, lineKey);
      const hasProductTags = productId && Object.prototype.hasOwnProperty.call(productIdLookup, productId);
      if (!hasLineTags && !hasProductTags) {
        return;
      }

      const tags = hasLineTags ? lineKeyLookup[lineKey] : productIdLookup[productId];
      const matchedRules = resolveMatchedFeeRules(tags, feeRules);
      matchedRules.forEach((ruleKey) => {
        if (!byRule[ruleKey]) {
          byRule[ruleKey] = lineKey;
        }
      });
    });

    return byRule;
  }

  function buildLubricationOperations(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const lubricationConfig = safeObject(input.lubricationConfig);
    const ruleMaps = buildLubricationRuleMaps(lubricationConfig);
    const hydratedIntent = hydrateLubricationIntentFromSession(items, ruleMaps);
    const hydratedItems = Array.isArray(hydratedIntent.items) ? hydratedIntent.items : items;
    const removalIntentResult = applyPendingLubricationRemovalIntents(hydratedItems, ruleMaps);
    const sourceItems = Array.isArray(removalIntentResult.items) ? removalIntentResult.items : hydratedItems;

    const managedLubricationLines = items.filter((item) => isManagedLubricationLine(item));
    const desiredBySourceLineKey = {};
    const parentSelectionOperations = Array.isArray(removalIntentResult.operations)
      ? removalIntentResult.operations.slice()
      : [];
    const removalIntentParentLineKeys = {};
    parentSelectionOperations.forEach((operation) => {
      const lineKey = String(operation && operation.lineKey ? operation.lineKey : "").trim();
      if (lineKey) {
        removalIntentParentLineKeys[lineKey] = true;
      }
    });

    sourceItems.forEach((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return;
      }

      const lineKey = String(line.key || "").trim();
      if (!lineKey) {
        return;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (!scope) {
        return;
      }

      const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
      if (!resolvedRule) {
        return;
      }

      const targetQuantity = Math.max(1, parseInteger(line.quantity));
      const layoutAlias = resolveDesiredLubricationLayoutAlias({
        scope,
        line,
        rule: resolvedRule,
      });
      const desiredParentProperties = buildLubricationSelectionProperties({
        selected: true,
        scope,
        ruleKey: String(resolvedRule.key || ""),
        layoutAlias,
      });
      if (!lineHasProperties(line, desiredParentProperties) || lineHasPublicLubricationProperties(line)) {
        parentSelectionOperations.push({
          type: "change",
          lineKey,
          quantity: targetQuantity,
          properties: Object.assign({}, stripPublicLubricationProperties(line && line.properties), desiredParentProperties),
        });
      }

      desiredBySourceLineKey[lineKey] = {
        quantity: targetQuantity,
        rule: resolvedRule,
        scope,
        sourceVariantLegacyId: normalizeLegacyId(line && line.variant_id),
      };
    });

    const parentCandidates = sourceItems
      .filter((line) => isEligibleLubricationParentLine(line))
      .map((line) => ({
        line,
        lineKey: String(line.key || "").trim(),
        quantity: Math.max(1, parseInteger(line.quantity)),
        scope: normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE)),
        selected: isTruthyLineProperty(line, ATTR_LUBE_SELECTED),
        resolvedRule: resolveLubricationRuleForLine(line, ruleMaps),
      }))
      .filter((candidate) => Boolean(candidate.lineKey));

    if (managedLubricationLines.length && parentCandidates.length) {
      const usedParentLineKeys = new Set(Object.keys(desiredBySourceLineKey));

      managedLubricationLines.forEach((managedLine) => {
        const explicitSourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_LUBE_SOURCE));
        const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(sourceItems, managedLine, ruleMaps);
        if (resolvedSourceLineKey && desiredBySourceLineKey[resolvedSourceLineKey]) {
          usedParentLineKeys.add(resolvedSourceLineKey);
          return;
        }

        const managedRule = resolveLubricationRuleForManagedLine(managedLine, ruleMaps);
        if (!managedRule) {
          return;
        }

        const managedScope = normalizeLubricationScope(getLineProperty(managedLine, ATTR_LUBE_SCOPE)) || LUBE_SCOPE_KEYBOARD;
        const managedQuantity = Math.max(1, parseInteger(managedLine && managedLine.quantity));
        let selectedCandidate = null;

        if (resolvedSourceLineKey) {
          const resolvedCandidate = parentCandidates.find((candidate) => candidate.lineKey === resolvedSourceLineKey) || null;
          if (resolvedCandidate && resolvedCandidate.selected) {
            selectedCandidate = resolvedCandidate;
          }
        }

        if (!selectedCandidate && explicitSourceLineKey) {
          const explicitCandidate = parentCandidates.find((candidate) => candidate.lineKey === explicitSourceLineKey) || null;
          if (explicitCandidate && explicitCandidate.selected) {
            selectedCandidate = explicitCandidate;
          }
        }

        if (!selectedCandidate) {
          const recoveryCandidate =
            (resolvedSourceLineKey
              ? parentCandidates.find((candidate) => candidate.lineKey === resolvedSourceLineKey)
              : null) ||
            (explicitSourceLineKey
              ? parentCandidates.find((candidate) => candidate.lineKey === explicitSourceLineKey)
              : null);

          if (
            recoveryCandidate &&
            !usedParentLineKeys.has(recoveryCandidate.lineKey) &&
            !removalIntentParentLineKeys[recoveryCandidate.lineKey]
          ) {
            selectedCandidate = recoveryCandidate;
          }
        }

        if (!selectedCandidate) {
          const availableSelectedCandidates = parentCandidates.filter((candidate) => {
            if (usedParentLineKeys.has(candidate.lineKey)) {
              return false;
            }
            return candidate.selected;
          });

          const sameRuleCandidates = availableSelectedCandidates.filter((candidate) => {

            if (managedScope && candidate.scope && candidate.scope !== managedScope) {
              return false;
            }

            if (candidate.resolvedRule && candidate.resolvedRule.key) {
              return candidate.resolvedRule.key === managedRule.key;
            }

            return true;
          });

          const sameScopeCandidates = availableSelectedCandidates.filter((candidate) => {
            if (!managedScope || !candidate.scope) {
              return true;
            }

            return candidate.scope === managedScope;
          });

          selectedCandidate =
            pickLubricationParentCandidate(sameRuleCandidates, managedQuantity) ||
            pickLubricationParentCandidate(sameScopeCandidates, managedQuantity) ||
            pickLubricationParentCandidate(availableSelectedCandidates, managedQuantity);
        }

        if (!selectedCandidate) {
          return;
        }

        const selectedLine = selectedCandidate.line;
        const selectedScope = selectedCandidate.scope || managedScope;
        usedParentLineKeys.add(selectedCandidate.lineKey);
        desiredBySourceLineKey[selectedCandidate.lineKey] = {
          quantity: selectedCandidate.quantity,
          rule: managedRule,
          scope: selectedScope,
          sourceVariantLegacyId: normalizeLegacyId(selectedLine && selectedLine.variant_id),
        };

        const layoutAlias = resolveDesiredLubricationLayoutAlias({
          scope: selectedScope,
          line: selectedLine,
          rule: managedRule,
        });
        const desiredParentProperties = buildLubricationSelectionProperties({
          selected: true,
          scope: selectedScope,
          ruleKey: String(managedRule.key || ""),
          layoutAlias,
        });

        if (!lineHasProperties(selectedLine, desiredParentProperties) || lineHasPublicLubricationProperties(selectedLine)) {
          parentSelectionOperations.push({
            type: "change",
            lineKey: selectedCandidate.lineKey,
            quantity: selectedCandidate.quantity,
            properties: Object.assign(
              {},
              stripPublicLubricationProperties(selectedLine && selectedLine.properties),
              desiredParentProperties,
            ),
          });
        }
      });
    }

    const operations = Array.isArray(hydratedIntent.propertyOperations)
      ? hydratedIntent.propertyOperations.concat(parentSelectionOperations)
      : parentSelectionOperations.slice();

    const managedLineSourceByLineKey = {};
    managedLubricationLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }
      const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(sourceItems, line, ruleMaps);
      if (!resolvedSourceLineKey) {
        managedLineSourceByLineKey[lineKey] = "";
        return;
      }

      const resolvedSourceCandidate = parentCandidates.find((candidate) => candidate.lineKey === resolvedSourceLineKey) || null;
      managedLineSourceByLineKey[lineKey] = resolvedSourceCandidate &&
        (resolvedSourceCandidate.selected || desiredBySourceLineKey[resolvedSourceLineKey])
        ? resolvedSourceLineKey
        : "";
    });

    // Gift convergence can briefly leave a managed lube line ahead of its parent marker.
    const recoverDesiredLubricationSource = (line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return "";
      }

      const resolvedSourceLineKey =
        String(managedLineSourceByLineKey[lineKey] || "").trim() ||
        resolveLubricationManagedSourceLineKey(sourceItems, line, ruleMaps);
      if (!resolvedSourceLineKey || desiredBySourceLineKey[resolvedSourceLineKey]) {
        return resolvedSourceLineKey;
      }

      const candidate = parentCandidates.find((parentCandidate) => parentCandidate.lineKey === resolvedSourceLineKey) || null;
      if (!candidate || removalIntentParentLineKeys[candidate.lineKey]) {
        return "";
      }

      const managedRule = resolveLubricationRuleForManagedLine(line, ruleMaps);
      if (!managedRule) {
        return "";
      }

      const selectedScope =
        normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE)) ||
        candidate.scope ||
        LUBE_SCOPE_KEYBOARD;
      desiredBySourceLineKey[candidate.lineKey] = {
        quantity: candidate.quantity,
        rule: managedRule,
        scope: selectedScope,
        sourceVariantLegacyId: normalizeLegacyId(candidate.line && candidate.line.variant_id),
      };
      managedLineSourceByLineKey[lineKey] = candidate.lineKey;

      const layoutAlias = resolveDesiredLubricationLayoutAlias({
        scope: selectedScope,
        line: candidate.line,
        rule: managedRule,
      });
      const desiredParentProperties = buildLubricationSelectionProperties({
        selected: true,
        scope: selectedScope,
        ruleKey: String(managedRule.key || ""),
        layoutAlias,
      });
      if (!lineHasProperties(candidate.line, desiredParentProperties) || lineHasPublicLubricationProperties(candidate.line)) {
        operations.push({
          type: "change",
          lineKey: candidate.lineKey,
          quantity: candidate.quantity,
          properties: Object.assign(
            {},
            stripPublicLubricationProperties(candidate.line && candidate.line.properties),
            desiredParentProperties,
          ),
        });
      }

      return candidate.lineKey;
    };

    const seenManagedBySourceAndVariant = {};
    managedLubricationLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      const sourceLineKey =
        String(managedLineSourceByLineKey[lineKey] || "").trim() ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      const variantLegacyId = normalizeLegacyId(line && line.variant_id);
      if (!sourceLineKey || !variantLegacyId || !lineKey) {
        return;
      }

      const dedupeKey = `${sourceLineKey}::${variantLegacyId}`;
      if (seenManagedBySourceAndVariant[dedupeKey]) {
        operations.push({
          type: "change",
          lineKey,
          quantity: 0,
        });
        return;
      }

      seenManagedBySourceAndVariant[dedupeKey] = lineKey;
    });

    managedLubricationLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      let sourceLineKey =
        String(managedLineSourceByLineKey[lineKey] || "").trim() ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      if (!sourceLineKey || !desiredBySourceLineKey[sourceLineKey]) {
        sourceLineKey = recoverDesiredLubricationSource(line) || sourceLineKey;
      }
      if (!sourceLineKey || !desiredBySourceLineKey[sourceLineKey]) {
        // A line whose rule can't be resolved (broken/disabled config) is left
        // untouched rather than deleted from the customer's cart.
        if (!resolveLubricationRuleForManagedLine(line, ruleMaps)) {
          return;
        }
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      }
    });

    Object.keys(desiredBySourceLineKey).forEach((sourceLineKey) => {
      const desired = desiredBySourceLineKey[sourceLineKey];
      const rule = desired.rule;
      const desiredScope = normalizeLubricationScope(desired.scope) || LUBE_SCOPE_KEYBOARD;
      const variantLegacyId = normalizeLegacyId(rule && rule.variantLegacyId);
      const sourceLineMatches = managedLubricationLines.filter(
        (line) => {
          const lineKey = String(line && line.key ? line.key : "").trim();
          const resolvedSourceLineKey =
            String(managedLineSourceByLineKey[lineKey] || "").trim() ||
            normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
          return resolvedSourceLineKey === sourceLineKey;
        },
      );

      if (!variantLegacyId) {
        // An unresolved lube variant (failed stock lookup, config hiccup) must never
        // delete lines the customer already paid for — it only blocks new adds.
        return;
      }

      const desiredManagedProperties = buildLubricationManagedProperties({
        sourceLineKey,
        sourceVariantLegacyId:
          normalizeLegacyId(desired && desired.sourceVariantLegacyId) || extractVariantLegacyIdFromLineKey(sourceLineKey),
        scope: desiredScope,
        ruleKey: String(rule.key || ""),
      });

      const addProperties = {
        ...desiredManagedProperties,
      };

      if (!sourceLineMatches.length) {
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: desired.quantity,
          properties: addProperties,
        });
        return;
      }

      const primary =
        sourceLineMatches.find((line) => normalizeLegacyId(line.variant_id) === variantLegacyId) || sourceLineMatches[0];
      const extras = sourceLineMatches.filter((line) => line.key !== primary.key);

      extras.forEach((line) => {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      });

      const primaryVariantMismatch = normalizeLegacyId(primary.variant_id) !== variantLegacyId;
      const primaryQuantity = Math.max(0, parseInteger(primary.quantity));
      const needsQuantityUpdate = primaryQuantity !== desired.quantity;
      // The drawer render depends on the managed lube line carrying the real parent line key after first sync.
      const needsPropertyUpdate =
        !lineHasProperties(primary, desiredManagedProperties) ||
        lineHasPublicLubricationProperties(primary);

      if (primaryVariantMismatch) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: 0,
        });
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: desired.quantity,
          properties: addProperties,
        });
        return;
      }

      if (needsQuantityUpdate || needsPropertyUpdate) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: desired.quantity,
          properties: desiredManagedProperties,
        });
      }
    });

    if (hydratedIntent.clearIntent) {
      clearPendingLubricationIntentSnapshot();
    }

    return dedupeOperations(operations);
  }

  function normalizeLubricationScope(value) {
    const normalized = String(value == null ? "" : value).trim().toLowerCase();
    if (normalized === LUBE_SCOPE_KEYBOARD || normalized === LUBE_SCOPE_SWITCH) {
      return normalized;
    }

    return "";
  }

  function resolveDesiredLubricationLayoutAlias(input) {
    const payload = input && typeof input === "object" ? input : {};
    const scope = normalizeLubricationScope(payload.scope);
    const line = payload.line;
    const rule = safeObject(payload.rule);
    if (scope !== LUBE_SCOPE_KEYBOARD) {
      return "";
    }

    const explicitLayoutAlias = normalizeLayoutAlias(getLineProperty(line, ATTR_LUBE_LAYOUT));
    const fallbackLayoutAlias = normalizeLayoutAlias(
      (Array.isArray(rule.aliases) && rule.aliases[0]) || rule.key || "",
    );
    return explicitLayoutAlias || fallbackLayoutAlias;
  }

  function buildLubricationSelectionProperties(input) {
    const payload = input && typeof input === "object" ? input : {};
    const selected = payload.selected ? "1" : "0";
    const scope = normalizeLubricationScope(payload.scope);
    const ruleKey = String(payload.ruleKey || "").trim();
    const layoutAlias = normalizeLayoutAlias(payload.layoutAlias);

    return {
      [ATTR_LUBE_SELECTED]: selected,
      [ATTR_LUBE_SCOPE]: scope,
      [ATTR_LUBE_RULE]: ruleKey,
      [ATTR_LUBE_LAYOUT]: layoutAlias,
    };
  }

  function buildLubricationManagedProperties(input) {
    const payload = input && typeof input === "object" ? input : {};
    const sourceLineKey = String(payload.sourceLineKey || "").trim();
    const sourceVariantLegacyId =
      normalizeLegacyId(payload.sourceVariantLegacyId) || extractVariantLegacyIdFromLineKey(sourceLineKey);
    const scope = normalizeLubricationScope(payload.scope);
    const ruleKey = String(payload.ruleKey || "").trim();

    return {
      [ATTR_LUBE_MANAGED]: "1",
      [ATTR_LUBE_SOURCE]: sourceLineKey,
      [ATTR_LUBE_SOURCE_VARIANT]: sourceVariantLegacyId,
      [ATTR_LUBE_SCOPE]: scope,
      [ATTR_LUBE_RULE]: ruleKey,
    };
  }

  function stripPublicLubricationProperties(properties) {
    const sanitized = Object.assign({}, safeObject(properties));
    LUBE_PUBLIC_ATTR_KEYS.forEach((propertyKey) => {
      if (Object.prototype.hasOwnProperty.call(sanitized, propertyKey)) {
        delete sanitized[propertyKey];
      }
    });
    return sanitized;
  }

  function lineHasPublicLubricationProperties(line) {
    const properties = safeObject(line && line.properties);
    return LUBE_PUBLIC_ATTR_KEYS.some((propertyKey) => {
      return Object.prototype.hasOwnProperty.call(properties, propertyKey);
    });
  }

  function stripPublicUpsellProperties(properties) {
    const sanitized = Object.assign({}, safeObject(properties));
    UPSELL_PUBLIC_ATTR_KEYS.forEach((propertyKey) => {
      if (Object.prototype.hasOwnProperty.call(sanitized, propertyKey)) {
        delete sanitized[propertyKey];
      }
    });
    return sanitized;
  }

  function lineHasPublicUpsellProperties(line) {
    const properties = safeObject(line && line.properties);
    return UPSELL_PUBLIC_ATTR_KEYS.some((propertyKey) => {
      return Object.prototype.hasOwnProperty.call(properties, propertyKey);
    });
  }

  function resolveLubricationRuleForManagedLine(line, ruleMaps) {
    const resolvedByProperties = resolveLubricationRuleForLine(line, ruleMaps);
    if (resolvedByProperties) {
      return resolvedByProperties;
    }

    const productLegacyId = normalizeLegacyId(line && line.product_id);
    if (!productLegacyId) {
      return null;
    }

    const rules = Array.isArray(ruleMaps && ruleMaps.rules) ? ruleMaps.rules : [];
    return rules.find((rule) => normalizeLegacyId(rule && rule.productLegacyId) === productLegacyId) || null;
  }

  function pickLubricationParentCandidate(candidates, managedQuantity) {
    const list = Array.isArray(candidates) ? candidates : [];
    if (!list.length) {
      return null;
    }

    const exactMatch = list.find((candidate) => Math.max(1, parseInteger(candidate && candidate.quantity)) === managedQuantity);
    return exactMatch || list[0];
  }

  function hydrateLubricationIntentFromSession(items, ruleMaps) {
    const intent = readPendingLubricationIntentSnapshot();
    if (!intent) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const intentScope = normalizeLubricationScope(intent.scope);
    if (!intentScope) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const byKey = safeObject(ruleMaps && ruleMaps.byKey);
    if (!byKey[intent.ruleKey]) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const candidateLines = (Array.isArray(items) ? items : []).filter((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return false;
      }

      if (normalizeLegacyId(line.product_id) !== intent.productLegacyId) {
        return false;
      }

      return Math.max(0, parseInteger(line.quantity)) > 0;
    });

    if (!candidateLines.length) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const hasMatchingSelectedLine = candidateLines.some((line) => {
      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return false;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (scope !== intentScope) {
        return false;
      }

      const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
      return Boolean(resolvedRule && resolvedRule.key === intent.ruleKey);
    });

    if (hasMatchingSelectedLine) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const preferredByVariant = intent.variantLegacyId
      ? candidateLines.filter((line) => normalizeLegacyId(line.variant_id) === intent.variantLegacyId)
      : [];
    let candidatePool = preferredByVariant.length ? preferredByVariant : candidateLines;

    const unselectedCandidates = candidatePool.filter((line) => !isTruthyLineProperty(line, ATTR_LUBE_SELECTED));
    if (unselectedCandidates.length) {
      candidatePool = unselectedCandidates;
    }

    const quantityMatchedCandidate = candidatePool.find(
      (line) => Math.max(1, parseInteger(line.quantity)) === intent.quantity,
    );
    const candidate = quantityMatchedCandidate || candidatePool[0];
    if (!candidate) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const rule = safeObject(byKey[intent.ruleKey]);
    const fallbackLayoutAlias = intentScope === LUBE_SCOPE_KEYBOARD
      ? normalizeLayoutAlias((Array.isArray(rule.aliases) && rule.aliases[0]) || intent.ruleKey || "")
      : "";
    const desiredLayoutAlias = intentScope === LUBE_SCOPE_KEYBOARD
      ? (
          normalizeLayoutAlias(intent.layoutKey) ||
          normalizeLayoutAlias(getLineProperty(candidate, ATTR_LUBE_LAYOUT)) ||
          fallbackLayoutAlias
        )
      : "";

    const desiredSelectionProperties = buildLubricationSelectionProperties({
      selected: true,
      scope: intentScope,
      ruleKey: intent.ruleKey,
      layoutAlias: desiredLayoutAlias,
    });

    if (lineHasProperties(candidate, desiredSelectionProperties) && !lineHasPublicLubricationProperties(candidate)) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const lineKey = String(candidate.key || "").trim();
    if (!lineKey) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const mergedProperties = Object.assign(
      {},
      stripPublicLubricationProperties(candidate && candidate.properties),
      desiredSelectionProperties,
    );
    const nextItems = items.map((line) => {
      if (String(line && line.key ? line.key : "").trim() !== lineKey) {
        return line;
      }

      return Object.assign({}, line, {
        properties: mergedProperties,
      });
    });

    return {
      items: nextItems,
      propertyOperations: [
        {
          type: "change",
          lineKey,
          quantity: Math.max(1, parseInteger(candidate.quantity)),
          properties: mergedProperties,
        },
      ],
      clearIntent: false,
    };
  }

  function readPendingLubricationIntentSnapshot() {
    let rawValue = "";
    try {
      rawValue = String(window.sessionStorage.getItem(LUBE_INTENT_STORAGE_KEY) || "").trim();
    } catch {
      return null;
    }

    if (!rawValue) {
      return null;
    }

    let parsed = null;
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      clearPendingLubricationIntentSnapshot();
      return null;
    }

    const source = safeObject(parsed);
    const selected = Boolean(source.selected);
    const createdAt = Number(source.createdAt || 0);
    const isExpired = !Number.isFinite(createdAt) || createdAt <= 0 || Date.now() - createdAt > LUBE_INTENT_TTL_MS;

    if (!selected || isExpired) {
      clearPendingLubricationIntentSnapshot();
      return null;
    }

    const scope = normalizeLubricationScope(source.scope);
    const productLegacyId = normalizeLegacyId(source.productLegacyId);
    const ruleKey = String(source.ruleKey || "").trim();

    if (!scope || !productLegacyId || !ruleKey) {
      clearPendingLubricationIntentSnapshot();
      return null;
    }

    return {
      scope,
      productLegacyId,
      variantLegacyId: normalizeLegacyId(source.variantLegacyId),
      quantity: Math.max(1, parseInteger(source.quantity)),
      ruleKey,
      layoutKey: scope === LUBE_SCOPE_KEYBOARD ? normalizeLayoutAlias(source.layoutKey) : "",
    };
  }

  function clearPendingLubricationIntentSnapshot() {
    try {
      window.sessionStorage.removeItem(LUBE_INTENT_STORAGE_KEY);
    } catch {
      // ignore storage failures
    }
  }

  function queueLubricationRemovalIntent(input) {
    const payload = input && typeof input === "object" ? input : {};
    const parentLineKey = String(payload.parentLineKey || "").trim();
    const parentVariantLegacyId = normalizeLegacyId(payload.parentVariantLegacyId);
    const managedLineKey = String(payload.managedLineKey || "").trim();
    const managedRuleKey = String(payload.managedRuleKey || "").trim();

    if (!parentLineKey && !parentVariantLegacyId && !managedLineKey) {
      return;
    }

    const intents = Array.isArray(state.lubricationRemovalIntents) ? state.lubricationRemovalIntents : [];
    const now = Date.now();
    const dedupeKey = [parentLineKey, parentVariantLegacyId, managedLineKey, managedRuleKey].join("::");
    const nextIntents = intents.filter((intent) => {
      const intentCreatedAt = Number(intent && intent.createdAt ? intent.createdAt : 0);
      if (!Number.isFinite(intentCreatedAt) || now - intentCreatedAt > LUBE_REMOVE_INTENT_TTL_MS) {
        return false;
      }
      const intentDedupeKey = [
        String(intent && intent.parentLineKey ? intent.parentLineKey : ""),
        String(intent && intent.parentVariantLegacyId ? intent.parentVariantLegacyId : ""),
        String(intent && intent.managedLineKey ? intent.managedLineKey : ""),
        String(intent && intent.managedRuleKey ? intent.managedRuleKey : ""),
      ].join("::");
      return intentDedupeKey !== dedupeKey;
    });

    nextIntents.push({
      createdAt: now,
      parentLineKey,
      parentVariantLegacyId,
      managedLineKey,
      managedRuleKey,
    });

    state.lubricationRemovalIntents = nextIntents;
  }

  function applyPendingLubricationRemovalIntents(items, ruleMaps) {
    const sourceItems = Array.isArray(items) ? items : [];
    const intents = Array.isArray(state.lubricationRemovalIntents) ? state.lubricationRemovalIntents : [];
    if (!sourceItems.length || !intents.length) {
      return {
        items: sourceItems,
        operations: [],
      };
    }

    const now = Date.now();
    const activeIntents = intents.filter((intent) => {
      const createdAt = Number(intent && intent.createdAt ? intent.createdAt : 0);
      return Number.isFinite(createdAt) && now - createdAt <= LUBE_REMOVE_INTENT_TTL_MS;
    });
    if (!activeIntents.length) {
      state.lubricationRemovalIntents = [];
      return {
        items: sourceItems,
        operations: [],
      };
    }

    const operationsByLineKey = {};
    const mutatedItemsByLineKey = {};
    sourceItems.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }
      mutatedItemsByLineKey[lineKey] = line;
    });

    const remainingIntents = [];
    activeIntents.forEach((intent) => {
      const parentLineKey = String(intent && intent.parentLineKey ? intent.parentLineKey : "").trim();
      const parentVariantLegacyId = normalizeLegacyId(intent && intent.parentVariantLegacyId);
      const managedLineKey = String(intent && intent.managedLineKey ? intent.managedLineKey : "").trim();
      const managedRuleKey = String(intent && intent.managedRuleKey ? intent.managedRuleKey : "").trim();

      let parentLine = null;
      if (parentLineKey) {
        parentLine = mutatedItemsByLineKey[parentLineKey] || null;
      }

      if (!parentLine && parentVariantLegacyId) {
        parentLine =
          sourceItems.find((line) => {
            return (
              isEligibleLubricationParentLine(line) &&
              normalizeLegacyId(line && line.variant_id) === parentVariantLegacyId
            );
          }) || null;
      }

      if (!parentLine && managedLineKey) {
        const managedLine = mutatedItemsByLineKey[managedLineKey] || null;
        if (managedLine) {
          const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(sourceItems, managedLine, ruleMaps);
          if (resolvedSourceLineKey) {
            parentLine = mutatedItemsByLineKey[resolvedSourceLineKey] || parentLine;
          }
        }
      }

      if (!parentLine && managedRuleKey) {
        parentLine =
          sourceItems.find((line) => {
            if (!isEligibleLubricationParentLine(line)) {
              return false;
            }
            if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
              return false;
            }
            const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
            return Boolean(resolvedRule && String(resolvedRule.key || "") === managedRuleKey);
          }) || null;
      }

      const resolvedParentLineKey = String(parentLine && parentLine.key ? parentLine.key : "").trim();
      if (!resolvedParentLineKey || !parentLine) {
        remainingIntents.push(intent);
        return;
      }

      const parentQuantity = Math.max(1, parseInteger(parentLine && parentLine.quantity));
      const deselectedProperties = buildLubricationSelectionProperties({
        selected: false,
        scope: "",
        ruleKey: "",
        layoutAlias: "",
      });
      const mergedParentProperties = Object.assign(
        {},
        stripPublicLubricationProperties(parentLine && parentLine.properties),
        deselectedProperties,
      );

      operationsByLineKey[resolvedParentLineKey] = {
        type: "change",
        lineKey: resolvedParentLineKey,
        quantity: parentQuantity,
        properties: mergedParentProperties,
      };

      mutatedItemsByLineKey[resolvedParentLineKey] = Object.assign({}, parentLine, {
        properties: mergedParentProperties,
      });
    });

    state.lubricationRemovalIntents = remainingIntents;

    const nextItems = sourceItems.map((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      return lineKey && mutatedItemsByLineKey[lineKey] ? mutatedItemsByLineKey[lineKey] : line;
    });

    return {
      items: nextItems,
      operations: Object.values(operationsByLineKey),
    };
  }

  function buildLubricationRuleMaps(config) {
    const rules = collectLubricationConfigRules(config);

    const byKey = {};
    const byAlias = {};

    rules.forEach((rawRule) => {
      const rule = safeObject(rawRule);
      const key = String(rule.key || "").trim();
      const productLegacyId = normalizeLegacyId(rule.productLegacyId);
      const variantLegacyId = normalizeLegacyId(rule.variantLegacyId);
      const aliases = Array.isArray(rule.aliases)
        ? rule.aliases.map((alias) => normalizeLayoutAlias(alias)).filter(Boolean)
        : [];

      if (!key || !productLegacyId) {
        return;
      }

      const normalizedRule = {
        key,
        productLegacyId,
        variantLegacyId,
        aliases,
        inStock: rule.inStock !== false,
      };

      byKey[key] = normalizedRule;
      aliases.forEach((alias) => {
        if (!byAlias[alias]) {
          byAlias[alias] = normalizedRule;
        }
      });
    });

    return {
      rules: Object.values(byKey),
      byKey,
      byAlias,
    };
  }

  function resolveLubricationRuleForLine(line, ruleMaps) {
    const maps = safeObject(ruleMaps);
    const byKey = safeObject(maps.byKey);
    const byAlias = safeObject(maps.byAlias);

    const explicitRuleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
    if (explicitRuleKey && byKey[explicitRuleKey]) {
      return byKey[explicitRuleKey];
    }

    const layoutAlias = normalizeLayoutAlias(getLineProperty(line, ATTR_LUBE_LAYOUT));
    if (layoutAlias && byAlias[layoutAlias]) {
      return byAlias[layoutAlias];
    }

    return null;
  }

  function isTruthyLineProperty(line, propertyName) {
    const raw = String(getLineProperty(line, propertyName) || "").trim().toLowerCase();
    return ["1", "true", "yes", "da", "on"].includes(raw);
  }

  function dedupeOperations(operations) {
    const seen = new Set();
    const deduped = [];

    for (const operation of operations) {
      const key = serializeOperation(operation);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      deduped.push(operation);
    }

    return deduped;
  }

  function serializeOperation(operation) {
    if (operation.type === "add") {
      return `add:${operation.variantLegacyId}:${operation.quantity}:${serializeProperties(operation.properties)}`;
    }

    return `change:${operation.lineKey}:${operation.quantity}:${serializeProperties(operation.properties)}`;
  }

  function serializeProperties(properties) {
    if (!properties || typeof properties !== "object") {
      return "";
    }

    return Object.keys(properties)
      .sort()
      .map((key) => `${key}=${properties[key]}`)
      .join("|");
  }

  function computeDesiredFeeQuantities(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const feeRules = Array.isArray(input.feeRules) ? input.feeRules : [];
    const tagLookup = input.tagLookup || { byLineKey: {}, byProductId: {} };

    const desired = buildEmptyFeeQuantityMap(feeRules);

    for (const line of items) {
      if (
        isManagedFeeLine(line) ||
        isManagedGiftLine(line) ||
        isManagedLubricationLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line)
      ) {
        continue;
      }

      const quantity = Math.max(0, parseInteger(line.quantity));
      if (!quantity) {
        continue;
      }

      const lineKey = String(line.key || "");
      const productId = normalizeLegacyId(line.product_id);
      const hasLineTags = lineKey ? Object.prototype.hasOwnProperty.call(tagLookup.byLineKey, lineKey) : false;
      const hasProductTags = productId ? Object.prototype.hasOwnProperty.call(tagLookup.byProductId, productId) : false;
      if (!hasLineTags && !hasProductTags) {
        return {
          desiredQuantities: buildEmptyFeeQuantityMap(feeRules),
          tagsReady: false,
        };
      }

      const tags = hasLineTags ? tagLookup.byLineKey[lineKey] : tagLookup.byProductId[productId];

      if (!tags.length) {
        continue;
      }

      const matchedRules = resolveMatchedFeeRules(tags, feeRules);
      matchedRules.forEach((ruleKey) => {
        desired[ruleKey] += quantity;
      });
    }

    return {
      desiredQuantities: desired,
      tagsReady: true,
    };
  }

  function buildEmptyFeeQuantityMap(feeRules) {
    const map = {
      heavy_keyboard: 0,
      casti_or_keyboards: 0,
      mouse_or_cable_not_mouse_cover: 0,
    };

    if (!Array.isArray(feeRules)) {
      return map;
    }

    feeRules.forEach((rule) => {
      const key = String(rule && rule.key ? rule.key : "");
      if (KNOWN_FEE_RULE_KEYS.includes(key)) {
        map[key] = 0;
      }
    });

    return map;
  }

  function resolveMatchedFeeRules(tags, feeRules) {
    const normalizedTags = normalizeTagList(tags);
    const tagSet = new Set(normalizedTags);

    const matchedRules = feeRules.filter((rule) => {
      const includesAny = (rule.includeTags || []).some((tag) => tagSet.has(tag));
      if (!includesAny) {
        return false;
      }

      const excluded = (rule.excludeTags || []).some((tag) => tagSet.has(tag));
      return !excluded;
    });

    if (!matchedRules.length) {
      return [];
    }

    const suppressed = new Set();
    matchedRules.forEach((rule) => {
      (rule.suppresses || []).forEach((suppressedRule) => {
        suppressed.add(suppressedRule);
      });
    });

    return matchedRules
      .map((rule) => rule.key)
      .filter((ruleKey) => !suppressed.has(ruleKey));
  }

  function buildDesiredConfigAttributes(config, thresholdBasisCents) {
    const tier1 = config.gift.tiers[0];
    const tier2 = config.gift.tiers[1];
    const tier3 = config.gift.tiers[2];

    const stockByTier = {
      1: isGiftTierVisible(tier1),
      2: isGiftTierVisible(tier2),
      3: isGiftTierVisible(tier3),
    };

    const raw = {
      threshold1: String(Math.round(tier1.thresholdCents / 100)),
      threshold2: String(Math.round(tier2.thresholdCents / 100)),
      threshold3: String(Math.round(tier3.thresholdCents / 100)),
      gift1: tier1.giftProductLegacyId,
      gift2: tier2.giftProductLegacyId,
      gift3: tier3.giftProductLegacyId,
      tier1Enabled: tier1.enabled ? "1" : "0",
      tier2Enabled: tier2.enabled ? "1" : "0",
      tier3Enabled: tier3.enabled ? "1" : "0",
      tier1InStock: stockByTier[1] ? "1" : "0",
      tier2InStock: stockByTier[2] ? "1" : "0",
      tier3InStock: stockByTier[3] ? "1" : "0",
      stackUnlocked: config.gift.mode === "cumulative" ? "1" : "0",
    };

    const hashInput = [
      raw.threshold1,
      raw.threshold2,
      raw.threshold3,
      raw.gift1,
      raw.gift2,
      raw.gift3,
      raw.tier1Enabled,
      raw.tier2Enabled,
      raw.tier3Enabled,
      raw.tier1InStock,
      raw.tier2InStock,
      raw.tier3InStock,
      raw.stackUnlocked,
    ].join("|");

    return {
      [ATTR_CFG_THRESHOLD_1]: raw.threshold1,
      [ATTR_CFG_THRESHOLD_2]: raw.threshold2,
      [ATTR_CFG_THRESHOLD_3]: raw.threshold3,
      [ATTR_CFG_GIFT_1]: raw.gift1,
      [ATTR_CFG_GIFT_2]: raw.gift2,
      [ATTR_CFG_GIFT_3]: raw.gift3,
      [ATTR_CFG_TIER_1_ENABLED]: raw.tier1Enabled,
      [ATTR_CFG_TIER_2_ENABLED]: raw.tier2Enabled,
      [ATTR_CFG_TIER_3_ENABLED]: raw.tier3Enabled,
      [ATTR_CFG_TIER_1_IN_STOCK]: raw.tier1InStock,
      [ATTR_CFG_TIER_2_IN_STOCK]: raw.tier2InStock,
      [ATTR_CFG_TIER_3_IN_STOCK]: raw.tier3InStock,
      [ATTR_CFG_STACK_UNLOCKED]: raw.stackUnlocked,
      [ATTR_CFG_THRESHOLD_BASIS]: String(Math.max(0, Math.round(thresholdBasisCents))),
      [ATTR_CFG_HASH]: hashInput,
    };
  }

  function buildDesiredAttributesForCart(cart, config, plan) {
    const normalizedPlan = safeObject(plan);
    if (isB2bCheckoutContext()) {
      return Object.assign({}, buildDesiredB2bCheckoutAttributes(cart), {
        [ATTR_GIFT_WRAP_SELECTED]: "0",
        [ATTR_PACKAGE_INSURANCE_SELECTED]: "0",
      });
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const thresholdBasisCents = computeThresholdBasisCents(
      items,
      parseInteger(cart && cart.total_price),
      config.gift.tiers,
    );

    return Object.assign(
      {},
      buildDesiredConfigAttributes(config, thresholdBasisCents),
      buildDesiredB2bCheckoutAttributes(cart),
      {
        [ATTR_GIFT_WRAP_SELECTED]: normalizedPlan.giftWrapSelected ? "1" : "0",
        [ATTR_PACKAGE_INSURANCE_SELECTED]: normalizedPlan.packageInsuranceSelected ? "1" : "0",
      },
    );
  }

  function buildDesiredB2bCheckoutAttributes(cart) {
    const currentAttributes = safeObject(cart && cart.attributes);
    const currentValue = String(currentAttributes[ATTR_B2B_CHECKOUT] == null ? "" : currentAttributes[ATTR_B2B_CHECKOUT]);

    if (isB2bCheckoutContext()) {
      return {
        [ATTR_B2B_CHECKOUT]: "1",
      };
    }

    if (currentValue) {
      return {
        [ATTR_B2B_CHECKOUT]: "0",
      };
    }

    return {};
  }

  function diffCartAttributes(cart, desiredAttributes) {
    const currentAttributes = safeObject(cart && cart.attributes);
    const updates = {};

    Object.keys(desiredAttributes).forEach((key) => {
      const desiredValue = String(desiredAttributes[key]);
      const currentValue = String(currentAttributes[key] == null ? "" : currentAttributes[key]);
      if (desiredValue !== currentValue) {
        updates[key] = desiredValue;
      }
    });

    return updates;
  }

  function needsB2bCheckoutAttributeSync() {
    const cart = normalizeCartPayload(state.lastCart) || getPreferredCartPageSeed();
    const isB2bCheckout = isB2bCheckoutContext();
    if (!cart) {
      return isB2bCheckout;
    }

    const currentAttributes = safeObject(cart && cart.attributes);
    const currentValue = String(currentAttributes[ATTR_B2B_CHECKOUT] == null ? "" : currentAttributes[ATTR_B2B_CHECKOUT]);
    return isB2bCheckout ? currentValue !== "1" : currentValue === "1";
  }

  function isB2bCheckoutContext() {
    return Boolean(getCustomerContext().b2b);
  }

  function getCustomerContext() {
    if (state.customerContext) {
      return state.customerContext;
    }

    const rawContext = safeObject(parseJsonScript("qk-customer-context"));
    state.customerContext = {
      b2b: readBoolean(rawContext.b2b, false),
      companyId: String(rawContext.companyId || "").trim(),
      companyName: String(rawContext.companyName || "").trim(),
    };
    return state.customerContext;
  }

  function collectFeeTagLookupsFromDom() {
    const byLineKey = {};
    const byProductId = {};
    const roots = [];
    const mainCartHost = document.querySelector("[data-main-cart-section-id]");
    const mainCartSection =
      (mainCartHost instanceof Element && mainCartHost.closest(".shopify-section")) ||
      (mainCartHost instanceof Element ? mainCartHost : null);
    if (isCartPagePath() && mainCartSection instanceof Element) {
      roots.push(mainCartSection);
    }

    const drawerElement = resolveCartDrawerElement();
    if (drawerElement instanceof HTMLElement && drawerElement.hasAttribute("open")) {
      const drawerInner = drawerElement.querySelector(".cart-drawer__inner");
      roots.push(drawerInner instanceof Element ? drawerInner : drawerElement);
    }

    if (!roots.length) {
      roots.push(document);
    }

    const seenLineKeys = new Set();
    roots.forEach((root) => {
      const lineItemElements = root && root.querySelectorAll ? root.querySelectorAll("line-item[data-line-key]") : [];
      lineItemElements.forEach((lineItemElement) => {
        const lineKey = String(lineItemElement.getAttribute("data-line-key") || "");
        if (!lineKey || seenLineKeys.has(lineKey)) {
          return;
        }
        seenLineKeys.add(lineKey);

        const productId = normalizeLegacyId(lineItemElement.getAttribute("data-product-legacy-id"));
        const rawTags = lineItemElement.getAttribute("data-product-tags") || "";
        const tags = normalizeTagList(rawTags.split("||"));

        byLineKey[lineKey] = tags;

        if (productId) {
          const existing = byProductId[productId];
          if (!existing || !existing.length || tags.length) {
            byProductId[productId] = tags;
          }

          const cached = state.feeTagsByProductId[productId];
          if (!cached || (!cached.length && tags.length)) {
            state.feeTagsByProductId[productId] = tags;
          }
        }
      });
    });

    Object.keys(state.feeTagsByProductId).forEach((productId) => {
      if (!Object.prototype.hasOwnProperty.call(byProductId, productId)) {
        byProductId[productId] = state.feeTagsByProductId[productId];
      }
    });

    return {
      byLineKey,
      byProductId,
    };
  }

  async function ensureFeeTagsForCart(cart, config) {
    const feeRules = Array.isArray(config && config.fees && config.fees.rules) ? config.fees.rules : [];
    if (!feeRules.length) {
      return;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const missingProductIds = [];
    for (const line of items) {
      if (
        isManagedFeeLine(line) ||
        isManagedGiftLine(line) ||
        isManagedLubricationLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line)
      ) {
        continue;
      }

      const productId = normalizeLegacyId(line && line.product_id);
      if (productId && line.handle) {
        productHandleByLegacyId[productId] = String(line.handle);
      }
      if (!productId || Object.prototype.hasOwnProperty.call(state.feeTagsByProductId, productId)) {
        continue;
      }
      missingProductIds.push(productId);
    }

    if (!missingProductIds.length) {
      return;
    }

    // Rendered line items may already carry the tags — scrape before fetching.
    collectFeeTagLookupsFromDom();
    const stillMissing = uniqueStrings(missingProductIds).filter(
      (productId) => !Object.prototype.hasOwnProperty.call(state.feeTagsByProductId, productId),
    );
    if (!stillMissing.length) {
      return;
    }

    try {
      const productsById = await fetchProductsByLegacyIds(stillMissing);
      let storedAnyTags = false;
      stillMissing.forEach((productId) => {
        const product = productsById[productId];
        if (!product) {
          return;
        }
        const rawTags = Array.isArray(product.tags)
          ? product.tags
          : String(product.tags || "").split(",");
        state.feeTagsByProductId[productId] = normalizeTagList(rawTags);
        storedAnyTags = true;
      });
      if (storedAnyTags) {
        persistManagedLookupSessionCache();
      }
    } catch (error) {
      debugLog("[qk-cart-rules] fee tag lookup failed", error);
    }
  }

  function computeThresholdBasisCents(items, cartTotalPriceCents, giftTiers) {
    let thresholdBasisCents = Math.max(0, parseInteger(cartTotalPriceCents));
    const tierList = Array.isArray(giftTiers) ? giftTiers : [];
    const giftProductIds = new Set(
      tierList
        .map((tier) => normalizeLegacyId(tier && tier.giftProductLegacyId))
        .filter(Boolean),
    );

    for (const line of items) {
      const productLegacyId = normalizeLegacyId(line && line.product_id);
      const shouldExclude =
        isManagedGiftLine(line) ||
        giftProductIds.has(productLegacyId) ||
        isManagedCodFeeLine(line);
      if (!shouldExclude) {
        continue;
      }

      thresholdBasisCents -= Math.max(0, parseInteger(line.final_line_price));
    }

    return Math.max(0, thresholdBasisCents);
  }

  function isGiftTierVisible(tier) {
    return Boolean(
      tier &&
        tier.enabled &&
        tier.inStock !== false &&
        tier.hasSellableVariant !== false,
    );
  }

  function isGiftTierAvailable(tier) {
    return Boolean(
      isGiftTierVisible(tier) &&
        normalizeLegacyId(tier.giftVariantLegacyId),
    );
  }

  function getAvailableGiftTiers(giftTiers) {
    return (Array.isArray(giftTiers) ? giftTiers : []).filter((tier) => isGiftTierVisible(tier));
  }

  function predictGiftItems(input) {
    if (window.__QK_PREDICTIVE_GIFT_PACK__ !== true) {
      return [];
    }

    const payload = input && typeof input === "object" ? input : {};
    const config = getConfig();
    // B2B carts never receive gifts, and paused rules must not add lines.
    if (
      isB2bCheckoutContext() ||
      !config.flags.managedRulesEnabled ||
      config.flags.shadowMode ||
      config.flags.killSwitch
    ) {
      return [];
    }

    // The drawer seed is rendered with the page, so a first add on a fresh
    // page can still be predicted. The post-add sync corrects any drift.
    const cart = normalizeCartPayload(payload.cart || state.lastCart || readCartDrawerSeed());
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    // Conservative rollout: predict only for empty-cart ATC.
    if (cart.items.length > 0) {
      return [];
    }

    const giftTiers = Array.isArray(config && config.gift && config.gift.tiers)
      ? config.gift.tiers
      : [];
    if (!giftTiers.length) {
      return [];
    }

    const addedPriceCents = Math.max(0, parseInteger(payload.addedPriceCents));
    const addedQuantity = Math.max(1, parseInteger(payload.addedQuantity, 1));
    const cartTotalDeltaCents = Math.max(0, addedPriceCents * addedQuantity);
    if (!cartTotalDeltaCents) {
      return [];
    }

    const currentBasisCents = computeThresholdBasisCents(
      cart.items,
      parseInteger(cart && cart.total_price),
      giftTiers,
    );
    const predictedBasisCents = Math.max(0, currentBasisCents + cartTotalDeltaCents);
    const availableGiftTiers = getAvailableGiftTiers(giftTiers);
    if (!availableGiftTiers.length) {
      return [];
    }

    const unlockedNow = availableGiftTiers
      .filter((tier) => currentBasisCents >= tier.thresholdCents)
      .map((tier) => tier.index);
    const unlockedAfterAdd = availableGiftTiers
      .filter((tier) => predictedBasisCents >= tier.thresholdCents)
      .map((tier) => tier.index);

    const targetTierIndexes = config.gift.mode === "cumulative"
      ? unlockedAfterAdd
      : unlockedAfterAdd.length
        ? [unlockedAfterAdd[unlockedAfterAdd.length - 1]]
        : [];

    const currentTargetTierIndexes = config.gift.mode === "cumulative"
      ? unlockedNow
      : unlockedNow.length
        ? [unlockedNow[unlockedNow.length - 1]]
        : [];
    const currentTargetLookup = {};
    currentTargetTierIndexes.forEach((tierIndex) => {
      currentTargetLookup[String(tierIndex)] = true;
    });

    const managedGiftLineByTier = buildManagedGiftLineMap(cart.items, availableGiftTiers);
    const predictedItems = [];
    targetTierIndexes.forEach((targetTierIndex) => {
      if (currentTargetLookup[String(targetTierIndex)]) {
        return;
      }

      if (Math.max(0, parseInteger(managedGiftLineByTier[targetTierIndex])) > 0) {
        return;
      }

      const tier = availableGiftTiers.find((candidateTier) => candidateTier.index === targetTierIndex);
      if (!isGiftTierAvailable(tier)) {
        return;
      }

      const variantLegacyId = normalizeLegacyId(tier.giftVariantLegacyId);
      if (!variantLegacyId) {
        return;
      }

      predictedItems.push({
        id: Number(variantLegacyId),
        quantity: 1,
        properties: {
          [ATTR_GWP_MANAGED]: "1",
          [ATTR_GWP_TIER]: String(targetTierIndex),
          [ATTR_GWP_SOURCE]: SOURCE_STOREFRONT,
        },
      });
    });

    if (predictedItems.length) {
      debugLog("[qk-cart-rules] predictive gift items", {
        count: predictedItems.length,
        currentBasisCents,
        predictedBasisCents,
        targetTierIndexes,
      });
    }

    return predictedItems;
  }

  function renderProgressUI(cart, config) {
    const mounts = Array.from(document.querySelectorAll(".qk-cart-progress-mount"));
    if (!mounts.length) {
      return;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const thresholdBasisCents = items.length
      ? computeThresholdBasisCents(
          items,
          parseInteger(cart && cart.total_price),
          config.gift.tiers,
        )
      : 0;

    const enabledTiers = getAvailableGiftTiers(config.gift.tiers);

    if (!enabledTiers.length) {
      mounts.forEach((mount) => {
        if (mount.__qkProgressHtml !== "") {
          mount.innerHTML = "";
          mount.__qkProgressHtml = "";
        }
        writeProgressCache(getProgressMountContext(mount), "");
      });
      return;
    }

    // Piecewise scale: equal-width segments between consecutive tier thresholds.
    const boundaries = [0].concat(enabledTiers.map((tier) => Math.max(0, parseInteger(tier.thresholdCents))));
    const segmentCount = Math.max(1, boundaries.length - 1);
    const maxBoundary = boundaries[boundaries.length - 1];

    const positionPercent = (valueCents) => {
      const value = Math.max(0, parseInteger(valueCents));
      if (!maxBoundary || value >= maxBoundary) {
        return 100;
      }
      for (let i = 0; i < segmentCount; i += 1) {
        if (value < boundaries[i + 1]) {
          const span = Math.max(1, boundaries[i + 1] - boundaries[i]);
          const fraction = Math.min(1, Math.max(0, (value - boundaries[i]) / span));
          return Math.round(((i + fraction) / segmentCount) * 1000) / 10;
        }
      }
      return 100;
    };

    const managedGiftLinesByTier = buildManagedGiftLineMap(items, enabledTiers);
    const managedGiftMetaByTier = buildManagedGiftMetaMap(items, enabledTiers);

    const tiersMarkup = enabledTiers
      .map((tier, tierPosition) => {
        const unlocked = thresholdBasisCents >= tier.thresholdCents;
        const applied = unlocked && managedGiftLinesByTier[tier.index] > 0;
        const stateClass = applied ? " is-applied" : unlocked ? " is-unlocked" : " is-locked";
        const statusLabel = applied ? config.ui.unlockedLabel : unlocked ? config.ui.eligibleLabel : config.ui.lockedLabel;
        const giftMeta = managedGiftMetaByTier[tier.index];
        const fallbackTitle = String(tier.giftTitle || `Cadou ${tier.index}`).trim();
        const title = String((giftMeta && giftMeta.title) || fallbackTitle || `Cadou ${tier.index}`);
        const imageUrl = resizeShopifyImageUrl(String((giftMeta && giftMeta.image) || tier.giftImageUrl || "").trim(), 96);
        const metaPriceCents = Math.max(0, parseInteger(giftMeta && giftMeta.priceCents));
        const priceCents = Math.max(0, parseInteger(tier.giftPriceCents) || metaPriceCents);
        const cardTitle = `${title} • ${formatThresholdLabel(tier.thresholdCents)} • ${statusLabel}`;
        const imageMarkup = !unlocked
          ? GIFT_LOCK_ICON_SVG
          : imageUrl
            ? `<img src="${escapeHtml(imageUrl)}" alt="" width="64" height="64" loading="eager" decoding="async" fetchpriority="high">`
            : "🎁";
        const priceMarkup = priceCents > 0
          ? `<span class="qk-progress__tier-price">${escapeHtml(formatLei(priceCents))}</span>`
          : "";

        return `<span class="qk-progress__tier${stateClass}" title="${escapeHtml(cardTitle)}"><span class="qk-progress__tier-thumb" aria-hidden="true">${imageMarkup}</span><span class="qk-progress__tier-info"><span class="qk-progress__tier-name">Cadou ${tierPosition + 1}</span>${priceMarkup}</span></span>`;
      })
      .join("");

    const segmentsMarkup = Array.from({ length: segmentCount }, (unused, index) => {
      const span = Math.max(1, boundaries[index + 1] - boundaries[index]);
      const fillPercent = Math.round(Math.min(1, Math.max(0, (thresholdBasisCents - boundaries[index]) / span)) * 100);
      return `<span class="qk-progress__segment"><span class="qk-progress__segment-fill" style="--qk-fill:${fillPercent}%;"></span></span>`;
    }).join("");

    const freeShippingCents = resolveProgressFreeShippingCents(mounts, enabledTiers);
    const showTruck = freeShippingCents > 0 && freeShippingCents <= maxBoundary;
    const freeShippingReached = showTruck && thresholdBasisCents >= freeShippingCents;
    const truckMarkup = showTruck
      ? `<button type="button" class="qk-progress__truck${freeShippingReached ? " is-reached" : ""}" style="--qk-pos:${positionPercent(freeShippingCents)}%;" aria-label="Livrare gratuita la ${Math.round(freeShippingCents / 100)} RON">${PROGRESS_TRUCK_ICON_SVG}<span class="qk-progress__tooltip" role="tooltip">Livrare gratuita</span></button>`
      : "";

    const scaleMarkup = boundaries
      .map((boundaryCents, index) => {
        const isFirst = index === 0;
        const isLast = index === boundaries.length - 1;
        const percent = Math.round((index / segmentCount) * 1000) / 10;
        const passedClass = thresholdBasisCents >= boundaryCents ? " is-passed" : "";
        const edgeClass = isFirst ? " is-first" : isLast ? " is-last" : "";
        const label = `${Math.round(boundaryCents / 100)} RON`;

        return `<span class="qk-progress__scale-label${edgeClass}${passedClass}" style="--qk-pos:${percent}%;">${escapeHtml(label)}</span>`;
      })
      .join("");

    const html = `
      <div class="qk-progress">
        <div class="qk-progress__tiers" style="--qk-tier-count:${enabledTiers.length};">${tiersMarkup}</div>
        <div class="qk-progress__slider">
          <div class="qk-progress__segments">${segmentsMarkup}</div>
          <span class="qk-progress__knob" style="--qk-pos:${positionPercent(thresholdBasisCents)}%;" aria-hidden="true"></span>
          ${truckMarkup}
        </div>
        <div class="qk-progress__scale">${scaleMarkup}</div>
      </div>
    `;

    mounts.forEach((mount) => {
      if (mount.__qkProgressHtml !== html) {
        mount.innerHTML = html;
        mount.__qkProgressHtml = html;
      }
      writeProgressCache(getProgressMountContext(mount), html);
    });
  }

  function renderCartTotalValues(cart) {
    const totalCents = Math.max(0, parseInteger(cart && cart.total_price));
    document.querySelectorAll("[data-qk-cart-total-value]").forEach((element) => {
      updateCartMoneyElement(element, totalCents);
    });
  }

  function renderCartSummaryRows(cart, config, domSnapshot) {
    const mounts = Array.from(document.querySelectorAll("[data-qk-cart-summary]"));
    if (!mounts.length) {
      return;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const giftTiers = Array.isArray(config && config.gift && config.gift.tiers) ? config.gift.tiers : [];
    const thresholdBasisCents = computeThresholdBasisCents(items, cart && cart.total_price, giftTiers);
    const freeShippingCents = resolveProgressFreeShippingCents(mounts, giftTiers);
    const hasShipping = cartRequiresShipping(cart, items);
    const hasFreeShipping = hasShipping && freeShippingCents > 0 && thresholdBasisCents >= freeShippingCents;
    const benefitsCents = computeCartSummaryBenefitsCents(cart, domSnapshot);
    const discountCodes = resolveCartDiscountCodes(cart).filter((entry) => entry.applicable);
    const hasDiscountCodes = discountCodes.length > 0;

    mounts.forEach((mount) => {
      renderCartDiscountCodes(mount, discountCodes);

      const shippingRow = mount.querySelector("[data-qk-cart-summary-shipping-row]");
      if (shippingRow instanceof HTMLElement) {
        shippingRow.hidden = !hasShipping;
        shippingRow.classList.toggle("is-free", hasFreeShipping);
      }

      const shippingLabel = mount.querySelector("[data-qk-cart-summary-shipping-label]");
      if (shippingLabel) {
        setCartUiText(shippingLabel, hasFreeShipping
          ? String(mount.getAttribute("data-qk-shipping-free-label") || "Transport Gratuit")
          : String(mount.getAttribute("data-qk-shipping-label") || "Transport"));
      }

      const shippingValue = mount.querySelector("[data-qk-cart-summary-shipping-value]");
      if (shippingValue) {
        setCartUiText(shippingValue, hasFreeShipping
          ? ""
          : String(mount.getAttribute("data-qk-shipping-price-label") || "De la 14 Lei"));
      }

      const benefitsValue = mount.querySelector("[data-qk-cart-summary-benefits-value]");
      const previousBenefitsCents = benefitsValue ? getCartMoneyPreviousCents(benefitsValue) : null;
      const keepBenefitsVisibleForAnimation =
        benefitsCents <= 0 && previousBenefitsCents > 0 && shouldAnimateCartMoney();
      const benefitsRow = mount.querySelector("[data-qk-cart-summary-benefits-row]");
      if (benefitsRow instanceof HTMLElement) {
        benefitsRow.hidden = benefitsCents <= 0 && !keepBenefitsVisibleForAnimation && !hasDiscountCodes;
      }

      const benefitsLabel = mount.querySelector("[data-qk-cart-summary-benefits-label]");
      if (benefitsLabel) {
        setCartUiText(benefitsLabel, String(mount.getAttribute("data-qk-benefits-label") || "Reducere & Cadouri"));
      }

      if (benefitsValue) {
        if (benefitsValue.hasAttribute("data-qk-cart-money-value")) {
          updateCartMoneyElement(benefitsValue, benefitsCents, {
            blankWhenZero: !keepBenefitsVisibleForAnimation,
            onComplete: () => {
              if (benefitsCents <= 0 && !hasDiscountCodes && benefitsRow instanceof HTMLElement) {
                benefitsRow.hidden = true;
                setCartUiText(benefitsValue, "");
              }
            },
          });
        } else {
          setCartUiText(benefitsValue, benefitsCents > 0 ? `-${formatCartSummaryLei(benefitsCents)}` : "");
        }
      }
    });
  }

  function resolveCartDiscountCodes(cart) {
    const rawCodes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
    const seen = new Set();
    const codes = [];

    rawCodes.forEach((entry) => {
      const source = entry && typeof entry === "object" ? entry : { code: entry };
      const code = String(source.code == null ? "" : source.code).trim().slice(0, 255);
      const key = code.toLowerCase();
      if (!code || seen.has(key)) {
        return;
      }

      seen.add(key);
      codes.push({
        code,
        key,
        applicable: source.applicable === true,
      });
    });

    return codes;
  }

  function readCookieValue(cookieString, cookieName) {
    const requestedName = String(cookieName || "").trim();
    if (!requestedName) {
      return "";
    }

    const prefix = `${encodeURIComponent(requestedName)}=`;
    const entry = String(cookieString || "")
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(prefix));
    if (!entry) {
      return "";
    }

    const rawValue = entry.slice(prefix.length);
    try {
      return decodeURIComponent(rawValue);
    } catch {
      return rawValue;
    }
  }

  function getNavigationRedirectCount() {
    try {
      const entries = window.performance && typeof window.performance.getEntriesByType === "function"
        ? window.performance.getEntriesByType("navigation")
        : [];
      const navigationEntry = Array.isArray(entries) && entries.length ? entries[0] : null;
      const redirectCount = Number(navigationEntry && navigationEntry.redirectCount);
      if (Number.isFinite(redirectCount)) {
        return Math.max(0, redirectCount);
      }

      const legacyRedirectCount = Number(window.performance && window.performance.navigation
        ? window.performance.navigation.redirectCount
        : 0);
      return Number.isFinite(legacyRedirectCount) ? Math.max(0, legacyRedirectCount) : 0;
    } catch {
      return 0;
    }
  }

  function resolveDiscountLinkCodeFromNavigation() {
    if (window.Shopify && window.Shopify.designMode) {
      return "";
    }

    if (getNavigationRedirectCount() <= 0) {
      return "";
    }

    return readCookieValue(document.cookie, DISCOUNT_LINK_COOKIE_NAME).trim().slice(0, 255);
  }

  function showDiscountLinkToastFromNavigation() {
    const code = resolveDiscountLinkCodeFromNavigation();
    if (!code || !(document.body instanceof HTMLElement)) {
      return;
    }

    const previousToast = document.querySelector("[data-qk-discount-link-toast]");
    if (previousToast) {
      previousToast.remove();
    }
    if (state.discountLinkToastTimer) {
      window.clearTimeout(state.discountLinkToastTimer);
    }
    if (state.discountLinkToastRemoveTimer) {
      window.clearTimeout(state.discountLinkToastRemoveTimer);
    }

    const toast = document.createElement("div");
    const message = document.createElement("span");
    const codeElement = document.createElement("strong");
    toast.className = "qk-discount-link-toast";
    toast.setAttribute("data-qk-discount-link-toast", "");
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    toast.setAttribute("aria-atomic", "true");
    message.className = "qk-discount-link-toast__message";
    codeElement.className = "qk-discount-link-toast__code";
    codeElement.textContent = code;
    message.append("Codul ", codeElement, " se aplică automat");
    toast.appendChild(message);
    document.body.appendChild(toast);

    const reveal = () => toast.classList.add("is-visible");
    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(reveal);
    } else {
      window.setTimeout(reveal, 0);
    }

    state.discountLinkToastTimer = window.setTimeout(() => {
      toast.classList.remove("is-visible");
      state.discountLinkToastRemoveTimer = window.setTimeout(() => {
        toast.remove();
        state.discountLinkToastRemoveTimer = null;
      }, DISCOUNT_LINK_TOAST_REMOVE_DELAY_MS);
      state.discountLinkToastTimer = null;
    }, DISCOUNT_LINK_TOAST_DURATION_MS);
  }

  function renderCartDiscountCodes(mount, discountCodes) {
    if (!(mount instanceof HTMLElement)) {
      return;
    }

    const list = mount.querySelector("[data-qk-cart-discount-codes]");
    if (!(list instanceof HTMLElement)) {
      return;
    }

    const codes = Array.isArray(discountCodes) ? discountCodes : [];
    const removingKey = String(state.discountCodeRemoving || "").toLowerCase();
    const mutationActive = Boolean(removingKey);
    const signature = `${removingKey}|${codes
      .map((entry) => `${entry.key}:${entry.applicable ? "1" : "0"}:${entry.key === removingKey ? "1" : "0"}`)
      .join("|")}`;

    if (list.getAttribute("data-qk-discount-signature") !== signature) {
      list.innerHTML = codes
        .map((entry) => {
          const isRemoving = entry.key === removingKey;
          const stateClass = entry.applicable ? " is-applied" : " is-pending";
          const pendingClass = isRemoving ? " is-removing" : "";
          const statusText = entry.applicable
            ? "aplicat"
            : "se aplică automat când coșul este eligibil";
          const escapedCode = escapeHtml(entry.code);

          return `<span class="qk-cart-discount-code${stateClass}${pendingClass}"><span class="qk-cart-discount-code__text" title="Cod ${escapedCode}: ${statusText}">${escapedCode}</span><button type="button" class="qk-cart-discount-code__remove" data-qk-discount-remove data-qk-discount-code="${escapedCode}" aria-label="Elimină codul ${escapedCode}"${isRemoving ? ' aria-busy="true"' : ""}${mutationActive ? " disabled" : ""}><span aria-hidden="true">×</span></button></span>`;
        })
        .join("");
      list.setAttribute("data-qk-discount-signature", signature);
    }

    list.hidden = codes.length === 0;

    const errorElement = mount.querySelector("[data-qk-cart-discount-error]");
    if (errorElement instanceof HTMLElement) {
      const message = String(state.discountCodeErrorMessage || "").trim();
      setCartUiText(errorElement, message);
      errorElement.hidden = !message;
    }
  }

  function onDiscountCodeRemoveClick(event) {
    const target = event && event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const button = target.closest("[data-qk-discount-remove]");
    if (!(button instanceof HTMLButtonElement) || button.disabled) {
      return;
    }

    const code = String(button.getAttribute("data-qk-discount-code") || "").trim();
    if (!code) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    void removeCartDiscountCode(code);
  }

  function removeCartDiscountCode(code) {
    if (state.discountMutationPromise) {
      return state.discountMutationPromise;
    }

    const requestedCode = String(code || "").trim();
    const requestedKey = requestedCode.toLowerCase();
    if (!requestedKey) {
      return Promise.resolve(state.lastCart);
    }

    state.discountCodeRemoving = requestedKey;
    state.discountCodeErrorMessage = "";
    scheduleUiRefresh("discount-code-remove-start");
    refreshCheckoutButtonsBusy();

    let discountUpdateCompleted = false;
    const run = async () => {
      let baseCart = normalizeCartPayload(state.lastCart);
      if (!baseCart || hasPendingCheckoutWork()) {
        const synchronizedCart = await syncNow("discount-code-remove-preflight", { forceEmit: false });
        baseCart = normalizeCartPayload(synchronizedCart) || normalizeCartPayload(state.lastCart);
      }
      if (!baseCart) {
        throw new Error("Cart unavailable before discount removal");
      }

      const cartCodes = resolveCartDiscountCodes(baseCart);
      if (!cartCodes.some((entry) => entry.key === requestedKey)) {
        return baseCart;
      }

      const remainingCodes = cartCodes
        .filter((entry) => entry.applicable && entry.key !== requestedKey)
        .map((entry) => entry.code);
      const sectionIds = collectBundledSectionIds();
      const payload = {
        discount: remainingCodes.join(","),
      };
      if (sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      const updatedCart = normalizeCartPayload(await requestCartJson("cart/update.js", payload));
      if (!updatedCart) {
        throw new Error("Invalid cart response after discount removal");
      }

      discountUpdateCompleted = true;
      state.lastCart = updatedCart;
      return syncNow("discount-code-remove", {
        seedCart: updatedCart,
        forceEmit: true,
        skipMutationFlush: true,
      });
    };

    state.discountMutationPromise = run()
      .catch((error) => {
        if (discountUpdateCompleted) {
          debugLog("[qk-cart-rules] discount removed; follow-up reconciliation failed", error);
          return state.lastCart;
        }

        const mounts = Array.from(document.querySelectorAll("[data-qk-cart-summary]"));
        const fallbackMessage = mounts.reduce((message, mount) => {
          return message || String(mount.getAttribute("data-qk-discount-remove-error") || "").trim();
        }, "");
        state.discountCodeErrorMessage = fallbackMessage || "Codul nu a putut fi eliminat. Încearcă din nou.";
        reportError(error, "Nu am putut elimina codul de reducere.");
        return state.lastCart;
      })
      .finally(() => {
        state.discountMutationPromise = null;
        state.discountCodeRemoving = "";
        scheduleUiRefresh("discount-code-remove-end");
        refreshCheckoutButtonsBusy();
      });

    return state.discountMutationPromise;
  }

  function computeCartSummaryBenefitsCents(cart, domSnapshot) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    let discountCents = 0;
    let giftValueCents = 0;
    let hasAuthoritativeLinePrices = false;

    items.forEach((line) => {
      const quantity = Math.max(1, parseInteger(line && line.quantity));
      const originalLinePrice = Math.max(0, parseCentsCandidate(line && line.original_line_price) || 0);
      const finalLinePrice = Math.max(0, parseCentsCandidate(line && line.final_line_price) || 0);
      const linePrice = parseCentsCandidate(line && line.line_price);
      const effectiveLinePrice = linePrice == null ? finalLinePrice : Math.max(0, linePrice);
      const compareAtLinePrice = resolveLineCompareAtPriceCents(line, domSnapshot) * quantity;
      const regularLinePrice = Math.max(originalLinePrice, compareAtLinePrice);
      const lineSavingsCents = Math.max(0, regularLinePrice - effectiveLinePrice);

      if (isManagedGiftLine(line)) {
        const displayUnitPrice = Math.max(0, resolveGiftLineDisplayPriceCents(line));
        giftValueCents += Math.max(regularLinePrice, displayUnitPrice * quantity);
        return;
      }

      if (linePrice != null) {
        hasAuthoritativeLinePrices = true;
      }
      discountCents += lineSavingsCents;
    });

    // Shopify's Ajax cart `line_price` already contains code allocations, while
    // `final_line_price` can remain unchanged. Only use the cart-level total as
    // a fallback for partial/legacy payloads that do not expose line prices.
    if (!hasAuthoritativeLinePrices) {
      const cartLevelDiscounts = Array.isArray(cart && cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : [];
      cartLevelDiscounts.forEach((discount) => {
        discountCents += Math.max(0, parseCentsCandidate(discount && discount.total_allocated_amount) || 0);
      });
    }

    return Math.max(0, Math.round(discountCents + giftValueCents));
  }

  function resolveLineCompareAtPriceCents(line, domSnapshot) {
    const lineKey = String(line && line.key ? line.key : "");
    const lineElementsByKey = safeObject(domSnapshot && domSnapshot.lineElementsByKey);
    const lineElements = Array.isArray(lineElementsByKey[lineKey]) ? lineElementsByKey[lineKey] : [];

    for (const lineElement of lineElements) {
      const candidate = parseCentsCandidate(lineElement && lineElement.getAttribute("data-qk-compare-at-price"));
      if (candidate != null && candidate > 0) {
        return candidate;
      }
    }

    const variant = safeObject(line && line.variant);
    const candidates = [
      line && line.compare_at_price,
      line && line.compare_at_price_max,
      variant.compare_at_price,
    ];

    for (const candidate of candidates) {
      const cents = parseCentsCandidate(candidate);
      if (cents != null && cents > 0) {
        return cents;
      }
    }

    return 0;
  }

  function cartRequiresShipping(cart, items) {
    if (typeof (cart && cart.requires_shipping) === "boolean") {
      return cart.requires_shipping;
    }

    return (Array.isArray(items) ? items : []).some((line) => line && line.requires_shipping !== false);
  }

  // Tap support for the free-shipping tooltip: hover/focus alone doesn't
  // trigger on iOS Safari, so a click toggles it and any outside click closes it.
  function onProgressTruckClick(event) {
    const truck = event.target && event.target.closest ? event.target.closest(".qk-progress__truck") : null;
    document.querySelectorAll(".qk-progress__truck.is-open").forEach((element) => {
      if (element !== truck) {
        element.classList.remove("is-open");
      }
    });
    if (truck) {
      truck.classList.toggle("is-open");
    }
  }

  function resolveProgressFreeShippingCents(mounts, giftTiers) {
    const defaultThresholdCents = DEFAULT_FREE_SHIPPING_THRESHOLD_RON * 100;
    const mountWithThreshold = (Array.isArray(mounts) ? mounts : []).find((mount) =>
      mount.hasAttribute("data-qk-free-shipping-ron"),
    );
    const configuredRon = mountWithThreshold
      ? Math.max(0, parseInteger(mountWithThreshold.getAttribute("data-qk-free-shipping-ron")))
      : 0;
    let thresholdCents = configuredRon > 0 ? configuredRon * 100 : defaultThresholdCents;

    const hasDefaultThresholdGiftTier = (Array.isArray(giftTiers) ? giftTiers : []).some((tier) => {
      return Math.round(Math.max(0, parseInteger(tier && tier.thresholdCents)) / 100) === DEFAULT_FREE_SHIPPING_THRESHOLD_RON;
    });

    if (hasDefaultThresholdGiftTier && thresholdCents < defaultThresholdCents) {
      thresholdCents = defaultThresholdCents;
    }

    return thresholdCents;
  }

  function buildManagedGiftLineMap(items, giftTiers) {
    const byTier = {
      1: 0,
      2: 0,
      3: 0,
    };
    const tierByProductLegacyId = buildGiftTierIndexByProductLegacyId(giftTiers);

    items.forEach((line) => {
      if (!isManagedGiftLine(line)) {
        return;
      }

      const explicitTier = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
      const inferredTier = parseInteger(tierByProductLegacyId[normalizeLegacyId(line && line.product_id)]);
      const tier = explicitTier >= 1 && explicitTier <= 3 ? explicitTier : inferredTier;
      if (tier >= 1 && tier <= 3) {
        byTier[tier] += Math.max(0, parseInteger(line.quantity));
      }
    });

    return byTier;
  }

  function buildManagedGiftMetaMap(items, giftTiers) {
    const byTier = {
      1: null,
      2: null,
      3: null,
    };
    const tierByProductLegacyId = buildGiftTierIndexByProductLegacyId(giftTiers);

    items.forEach((line) => {
      if (!isManagedGiftLine(line)) {
        return;
      }

      const explicitTier = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
      const inferredTier = parseInteger(tierByProductLegacyId[normalizeLegacyId(line && line.product_id)]);
      const tier = explicitTier >= 1 && explicitTier <= 3 ? explicitTier : inferredTier;
      if (!(tier >= 1 && tier <= 3)) {
        return;
      }

      if (byTier[tier]) {
        return;
      }

      byTier[tier] = {
        title: String(line.product_title || line.title || "").trim(),
        image: resolveLineImageUrl(line),
        quantity: Math.max(0, parseInteger(line.quantity)),
        priceCents: resolveGiftLineDisplayPriceCents(line),
      };
    });

    return byTier;
  }

  function resolveGiftLineDisplayPriceCents(line) {
    const unitCandidates = [
      line && line.original_price,
      line && line.price,
      line && line.final_price,
      line && line.discounted_price,
    ];

    for (const candidate of unitCandidates) {
      const cents = parseCentsCandidate(candidate);
      if (cents != null && cents > 0) {
        return cents;
      }
    }

    const quantity = Math.max(1, parseInteger(line && line.quantity));
    const totalCandidates = [
      line && line.original_line_price,
      line && line.line_price,
      line && line.final_line_price,
    ];

    for (const candidate of totalCandidates) {
      const cents = parseCentsCandidate(candidate);
      if (cents != null && cents > 0) {
        return Math.round(cents / quantity);
      }
    }

    return 0;
  }

  function buildGiftTierIndexByProductLegacyId(giftTiers) {
    const map = {};
    (Array.isArray(giftTiers) ? giftTiers : []).forEach((tier) => {
      const index = parseInteger(tier && tier.index);
      const productLegacyId = normalizeLegacyId(tier && tier.giftProductLegacyId);
      if (!(index >= 1 && index <= 3) || !productLegacyId) {
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(map, productLegacyId)) {
        map[productLegacyId] = index;
      }
    });
    return map;
  }

  function resolveLineImageUrl(line) {
    const featuredImage = safeObject(line && line.featured_image);
    const imageObject = safeObject(line && line.image);
    const rawLineImage = line && typeof line.image === "string" ? line.image : "";
    const candidates = [
      featuredImage.url,
      featuredImage.src,
      rawLineImage,
      imageObject.url,
      imageObject.src,
    ];

    for (const candidate of candidates) {
      const raw = String(candidate == null ? "" : candidate).trim();
      if (!raw) {
        continue;
      }

      if (raw.startsWith("//")) {
        return `https:${raw}`;
      }

      if (raw.startsWith("/")) {
        return `${window.location.origin}${raw}`;
      }

      return raw;
    }

    return "";
  }

  function renderCompactGiftLines(cart, domSnapshot) {
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    if (!lineElements.length) {
      return;
    }

    const hasCompactGiftUI = Boolean(document.querySelector(".qk-progress__tiers"));

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const managedGiftLineKeys = new Set();
    items.forEach((item) => {
      const lineKey = String(item && item.key ? item.key : "");
      if (lineKey && isManagedGiftLine(item)) {
        managedGiftLineKeys.add(lineKey);
      }
    });

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      const container = getLineContainer(lineElement);
      const shouldHide = hasCompactGiftUI && managedGiftLineKeys.has(lineKey);
      container.classList.toggle("qk-gift-line--hidden", shouldHide);
    });
  }

  function markManagedLinesPendingRemoval(cart, operations) {
    const nextPending = Object.assign({}, state.pendingManagedRemovalKeys || {});
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "");
      if (lineKey) {
        itemByKey[lineKey] = line;
      }
    });

    (Array.isArray(operations) ? operations : []).forEach((operation) => {
      if (!operation || operation.type !== "change") {
        return;
      }

      if (Math.max(0, parseInteger(operation.quantity)) !== 0) {
        return;
      }

      const lineKey = String(operation.lineKey || "").trim();
      if (!lineKey) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line || (!isManagedFeeLine(line) && !isManagedGiftLine(line) && !isManagedLubricationLine(line))) {
        return;
      }

      nextPending[lineKey] = true;
    });

    state.pendingManagedRemovalKeys = nextPending;
    applyPendingManagedHiddenState();
  }

  function applyPendingManagedHiddenState(domSnapshot) {
    const pending = safeObject(state.pendingManagedRemovalKeys);
    const pendingKeys = Object.keys(pending);
    if (!pendingKeys.length) {
      return;
    }

    const pendingSet = new Set(pendingKeys);
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!pendingSet.has(lineKey)) {
        return;
      }

      const container = getLineContainer(lineElement);
      container.classList.add("qk-line--optimistic-hidden");
    });
  }

  function clearPendingManagedRemovalKeys() {
    state.pendingManagedRemovalKeys = {};
    document.querySelectorAll(".qk-line--optimistic-hidden").forEach((element) => {
      element.classList.remove("qk-line--optimistic-hidden");
    });
  }

  function deriveProcessingParentLineKeys(cart, operations) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((line) => {
      const key = String(line && line.key ? line.key : "").trim();
      if (key) {
        itemByKey[key] = line;
      }
    });

    const parentLineKeys = new Set();
    (Array.isArray(operations) ? operations : []).forEach((operation) => {
      if (!operation || typeof operation !== "object") {
        return;
      }

      const operationProperties = safeObject(operation.properties);

      if (operation.type === "add") {
        const lubeSourceLineKey = normalizeManagedSourceLineKey(operationProperties[ATTR_LUBE_SOURCE]);
        if (lubeSourceLineKey) {
          parentLineKeys.add(lubeSourceLineKey);
        }

        const feeSourceLineKey = normalizeManagedSourceLineKey(operationProperties[ATTR_FEE_SOURCE]);
        if (feeSourceLineKey) {
          parentLineKeys.add(feeSourceLineKey);
        }
        return;
      }

      if (operation.type !== "change") {
        return;
      }

      const lineKey = String(operation.lineKey || "").trim();
      if (!lineKey) {
        return;
      }

      if (
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_SELECTED) ||
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_SCOPE) ||
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_RULE) ||
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_LAYOUT)
      ) {
        parentLineKeys.add(lineKey);
      }

      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }

      if (isManagedLubricationLine(line)) {
        let sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
        if (!sourceLineKey || !itemByKey[sourceLineKey]) {
          const sourceVariantLegacyId =
            normalizeLegacyId(getLineProperty(line, ATTR_LUBE_SOURCE_VARIANT)) ||
            extractVariantLegacyIdFromLineKey(sourceLineKey);
          if (sourceVariantLegacyId) {
            const candidate = items.find((candidateLine) => {
              return (
                isEligibleLubricationParentLine(candidateLine) &&
                normalizeLegacyId(candidateLine && candidateLine.variant_id) === sourceVariantLegacyId
              );
            });
            sourceLineKey = String((candidate && candidate.key) || "").trim();
          }
        }
        if (sourceLineKey) {
          parentLineKeys.add(sourceLineKey);
        }
        return;
      }

      if (isManagedFeeLine(line)) {
        let sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(line, ATTR_FEE_SOURCE));
        if (!sourceLineKey || !itemByKey[sourceLineKey]) {
          const sourceVariantLegacyId =
            normalizeLegacyId(getLineProperty(line, ATTR_FEE_SOURCE_VARIANT)) ||
            extractVariantLegacyIdFromLineKey(sourceLineKey);
          if (sourceVariantLegacyId) {
            const candidate = items.find((candidateLine) => {
              return (
                isEligibleFeeParentLine(candidateLine) &&
                normalizeLegacyId(candidateLine && candidateLine.variant_id) === sourceVariantLegacyId
              );
            });
            sourceLineKey = String((candidate && candidate.key) || "").trim();
          }
        }
        if (sourceLineKey) {
          parentLineKeys.add(sourceLineKey);
        }
      }
    });

    return Array.from(parentLineKeys);
  }

  function normalizeManagedSourceLineKey(value) {
    const key = String(value || "").trim();
    if (!key || key === SOURCE_STOREFRONT) {
      return "";
    }
    return key;
  }

  function extractVariantLegacyIdFromLineKey(lineKey) {
    const normalizedLineKey = String(lineKey || "").trim();
    if (!normalizedLineKey) {
      return "";
    }

    const prefix = normalizedLineKey.split(":")[0];
    return normalizeLegacyId(prefix);
  }

  function isEligibleFeeParentLine(line) {
    if (
      !line ||
      isManagedFeeLine(line) ||
      isManagedGiftLine(line) ||
      isManagedLubricationLine(line) ||
      isManagedGiftWrapLine(line) ||
      isManagedPackageInsuranceLine(line)
    ) {
      return false;
    }

    const lineKey = String(line && line.key ? line.key : "").trim();
    if (!lineKey) {
      return false;
    }

    return Math.max(0, parseInteger(line && line.quantity)) > 0;
  }

  function resolveFeeTagsForLine(line, tagLookup) {
    const lineKey = String(line && line.key ? line.key : "").trim();
    const productLegacyId = normalizeLegacyId(line && line.product_id);
    const byLineKey = safeObject(tagLookup && tagLookup.byLineKey);
    const byProductId = safeObject(tagLookup && tagLookup.byProductId);

    if (lineKey && Object.prototype.hasOwnProperty.call(byLineKey, lineKey)) {
      return normalizeTagList(byLineKey[lineKey]);
    }

    if (productLegacyId && Object.prototype.hasOwnProperty.call(byProductId, productLegacyId)) {
      return normalizeTagList(byProductId[productLegacyId]);
    }

    return [];
  }

  function resolveFeeRuleKeyForManagedLine(line, feeRules) {
    const explicitRuleKey = String(getLineProperty(line, ATTR_FEE_RULE) || "").trim();
    if (explicitRuleKey) {
      return explicitRuleKey;
    }

    const feeRuleByProductLegacyId = {};
    (Array.isArray(feeRules) ? feeRules : []).forEach((rule) => {
      const key = String(rule && rule.key ? rule.key : "").trim();
      const productLegacyId = normalizeLegacyId(rule && rule.feeProductLegacyId);
      if (!key || !productLegacyId) {
        return;
      }
      feeRuleByProductLegacyId[productLegacyId] = key;
    });

    return String(feeRuleByProductLegacyId[normalizeLegacyId(line && line.product_id)] || "").trim();
  }

  function resolveFeeManagedSourceLineKey(items, managedLine, feeRules, tagLookup) {
    const candidates = (Array.isArray(items) ? items : []).filter((line) => isEligibleFeeParentLine(line));
    if (!managedLine || !candidates.length) {
      return "";
    }

    const explicitSourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_FEE_SOURCE));
    if (
      explicitSourceLineKey &&
      candidates.some((candidate) => String(candidate && candidate.key ? candidate.key : "").trim() === explicitSourceLineKey)
    ) {
      return explicitSourceLineKey;
    }

    const sourceVariantLegacyId =
      normalizeLegacyId(getLineProperty(managedLine, ATTR_FEE_SOURCE_VARIANT)) ||
      extractVariantLegacyIdFromLineKey(explicitSourceLineKey);
    const managedRuleKey = resolveFeeRuleKeyForManagedLine(managedLine, feeRules);

    const matchedByRule = managedRuleKey
      ? candidates.filter((candidate) => {
          const tags = resolveFeeTagsForLine(candidate, tagLookup);
          if (!tags.length) {
            return false;
          }
          return resolveMatchedFeeRules(tags, feeRules).includes(managedRuleKey);
        })
      : candidates.slice();

    const variantMatchedByRule = sourceVariantLegacyId
      ? matchedByRule.filter((candidate) => normalizeLegacyId(candidate && candidate.variant_id) === sourceVariantLegacyId)
      : [];
    if (variantMatchedByRule.length) {
      return String(variantMatchedByRule[0].key || "").trim();
    }

    if (matchedByRule.length === 1) {
      return String(matchedByRule[0].key || "").trim();
    }

    if (sourceVariantLegacyId) {
      const variantMatchedAny = candidates.filter((candidate) => {
        return normalizeLegacyId(candidate && candidate.variant_id) === sourceVariantLegacyId;
      });
      if (variantMatchedAny.length) {
        return String(variantMatchedAny[0].key || "").trim();
      }
    }

    if (matchedByRule.length > 1) {
      return String(matchedByRule[0].key || "").trim();
    }

    if (candidates.length === 1) {
      return String(candidates[0].key || "").trim();
    }

    return "";
  }

  function resolveLubricationManagedSourceLineKey(items, managedLine, ruleMaps, options) {
    const payload = options && typeof options === "object" ? options : {};
    const candidates = (Array.isArray(items) ? items : []).filter((line) => isEligibleLubricationParentLine(line));
    if (!managedLine || !candidates.length) {
      return "";
    }

    const explicitSourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_LUBE_SOURCE));
    if (
      explicitSourceLineKey &&
      candidates.some((candidate) => String(candidate && candidate.key ? candidate.key : "").trim() === explicitSourceLineKey)
    ) {
      return explicitSourceLineKey;
    }

    const preferredParentLineKey = normalizeManagedSourceLineKey(payload.preferredParentLineKey);
    if (
      preferredParentLineKey &&
      candidates.some((candidate) => String(candidate && candidate.key ? candidate.key : "").trim() === preferredParentLineKey)
    ) {
      return preferredParentLineKey;
    }

    const sourceVariantLegacyId =
      normalizeLegacyId(getLineProperty(managedLine, ATTR_LUBE_SOURCE_VARIANT)) ||
      extractVariantLegacyIdFromLineKey(explicitSourceLineKey);
    const managedRule = resolveLubricationRuleForManagedLine(managedLine, ruleMaps);
    const managedRuleKey = String((managedRule && managedRule.key) || getLineProperty(managedLine, ATTR_LUBE_RULE) || "").trim();
    const managedScope = normalizeLubricationScope(getLineProperty(managedLine, ATTR_LUBE_SCOPE));
    const managedQuantity = Math.max(1, parseInteger(managedLine && managedLine.quantity));

    let bestCandidate = null;
    let bestScore = -1;
    candidates.forEach((candidate) => {
      if (!candidate) {
        return;
      }

      let score = 0;
      if (sourceVariantLegacyId && normalizeLegacyId(candidate.variant_id) === sourceVariantLegacyId) {
        score += 8;
      }

      const candidateRule = resolveLubricationRuleForLine(candidate, ruleMaps);
      const candidateRuleKey = String((candidateRule && candidateRule.key) || getLineProperty(candidate, ATTR_LUBE_RULE) || "").trim();
      if (managedRuleKey && candidateRuleKey && candidateRuleKey === managedRuleKey) {
        score += 6;
      }

      const candidateScope = normalizeLubricationScope(getLineProperty(candidate, ATTR_LUBE_SCOPE));
      if (managedScope) {
        if (candidateScope === managedScope) {
          score += 3;
        } else if (!candidateScope) {
          score += 1;
        }
      }

      if (isTruthyLineProperty(candidate, ATTR_LUBE_SELECTED)) {
        score += 2;
      }

      if (Math.max(1, parseInteger(candidate && candidate.quantity)) === managedQuantity) {
        score += 1;
      }

      if (score > bestScore) {
        bestScore = score;
        bestCandidate = candidate;
      }
    });

    if (bestCandidate && bestScore > 0) {
      return String(bestCandidate.key || "").trim();
    }

    if (candidates.length === 1) {
      return String(candidates[0].key || "").trim();
    }

    return "";
  }

  function setProcessingLineKeys(lineKeys) {
    const normalizedKeys = uniqueStrings(Array.isArray(lineKeys) ? lineKeys : []);
    const nextLookup = {};
    normalizedKeys.forEach((lineKey) => {
      nextLookup[lineKey] = true;
    });
    state.processingLineKeys = nextLookup;
    applyProcessingLineState();
  }

  function clearProcessingLineKeys() {
    if (!Object.keys(safeObject(state.processingLineKeys)).length) {
      return;
    }

    state.processingLineKeys = {};
    applyProcessingLineState();
  }

  function applyProcessingLineState(domSnapshot) {
    const processingLookup = safeObject(state.processingLineKeys);
    const processingKeys = new Set(Object.keys(processingLookup));
    const shouldShowPendingLubricationProcessing = Boolean(state.inFlight || state.lineMutationInFlight);
    const pendingLubricationParentLineKeys = shouldShowPendingLubricationProcessing
      ? derivePendingLubricationParentLineKeys(
          state.lastCart,
          getLubricationConfig(),
        )
      : [];
    pendingLubricationParentLineKeys.forEach((lineKey) => {
      processingKeys.add(lineKey);
    });
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
      const shouldShowProcessing = Boolean(lineKey && processingKeys.has(lineKey));

      lineElement.classList.toggle("qk-line--processing", shouldShowProcessing);

      const container = getLineContainer(lineElement);
      if (container instanceof Element && container !== lineElement) {
        container.classList.toggle("qk-line--processing", shouldShowProcessing);
      }
    });
  }

  function derivePendingLubricationParentLineKeys(cart, lubricationConfig) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    if (!items.length) {
      return [];
    }

    const ruleMaps = buildLubricationRuleMaps(lubricationConfig);
    const managedBySourceLineKey = {};
    const managedCountByScopeAndRule = {};

    items.forEach((line) => {
      if (!line || !isManagedLubricationLine(line)) {
        return;
      }

      const sourceLineKey =
        resolveLubricationManagedSourceLineKey(items, line, ruleMaps) ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      if (sourceLineKey) {
        managedBySourceLineKey[sourceLineKey] = true;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      const ruleKey = getLubricationRuleKeyForLine(line, ruleMaps);
      if (!scope || !ruleKey) {
        return;
      }

      const bucketKey = `${scope}::${ruleKey}`;
      managedCountByScopeAndRule[bucketKey] = Math.max(0, parseInteger(managedCountByScopeAndRule[bucketKey])) + 1;
    });

    const pendingParentLineKeys = [];
    items.forEach((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (!scope) {
        return;
      }

      const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
      const ruleKey = String(resolvedRule && resolvedRule.key ? resolvedRule.key : "").trim();
      if (!ruleKey) {
        return;
      }

      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      if (managedBySourceLineKey[lineKey]) {
        return;
      }

      const bucketKey = `${scope}::${ruleKey}`;
      const matchedManagedCount = Math.max(0, parseInteger(managedCountByScopeAndRule[bucketKey]));
      if (matchedManagedCount > 0) {
        managedCountByScopeAndRule[bucketKey] = matchedManagedCount - 1;
        return;
      }

      pendingParentLineKeys.push(lineKey);
    });

    return uniqueStrings(pendingParentLineKeys);
  }

  // Attachments (lube/fee rows under a parent line) are rendered server-side by
  // line-item.liquid and reconciled here by signature, so refreshes that change
  // nothing leave the DOM untouched. Recreating them on every refresh re-triggers
  // the cart MutationObserver and loops remove/re-add jank every frame.
  function reconcileLineItemAttachments(options) {
    const className = String(options && options.className ? options.className : "").trim();
    if (!className) {
      return;
    }

    const desiredByParentLineKey = safeObject(options.desiredByParentLineKey);
    const lineElementsByKey = safeObject(options.lineElementsByKey);

    document.querySelectorAll(`.${className}`).forEach((element) => {
      const host = element.closest("line-item[data-line-key]");
      const parentLineKey = host instanceof Element ? String(host.getAttribute("data-line-key") || "") : "";
      const desiredEntries = Array.isArray(desiredByParentLineKey[parentLineKey])
        ? desiredByParentLineKey[parentLineKey]
        : [];
      const signature = element.getAttribute("data-qk-sig") || "";
      if (!desiredEntries.some((entry) => entry.signature === signature)) {
        element.remove();
      }
    });

    Object.keys(desiredByParentLineKey).forEach((parentLineKey) => {
      const parentElements = Array.isArray(lineElementsByKey[parentLineKey]) ? lineElementsByKey[parentLineKey] : [];
      if (!parentElements.length) {
        return;
      }

      desiredByParentLineKey[parentLineKey].forEach((entry) => {
        parentElements.forEach((parentElement) => {
          if (!(parentElement instanceof Element)) {
            return;
          }

          const info = parentElement.querySelector(".line-item__info");
          if (!(info instanceof Element)) {
            return;
          }

          const alreadyPresent = Array.from(info.children).some(
            (child) =>
              child.classList &&
              child.classList.contains(className) &&
              child.getAttribute("data-qk-sig") === entry.signature,
          );
          if (alreadyPresent) {
            return;
          }

          const attachment = entry.build();
          if (!(attachment instanceof Element)) {
            return;
          }
          attachment.setAttribute("data-qk-sig", entry.signature);

          const priceAndQuantity = info.querySelector(".price-quantity");
          if (priceAndQuantity instanceof Element) {
            info.insertBefore(attachment, priceAndQuantity);
          } else {
            info.appendChild(attachment);
          }
        });
      });
    });
  }

  // Must stay in sync with the data-qk-sig emitted by snippets/line-item.liquid.
  function buildFeeAttachmentSignature(parentLineKey, payloadKey, payload) {
    return [
      "fee",
      String(parentLineKey || ""),
      String(payloadKey || ""),
      String(Math.max(1, parseInteger(payload && payload.quantity))),
    ].join("|");
  }

  function buildFeeAttachmentElement(payload) {
    const quantity = Math.max(1, parseInteger(payload && payload.quantity));
    const quantityMarkup = quantity > 1
      ? `<span class=\"qk-fee-attachment__qty\">x${quantity}</span>`
      : "";
    const attachment = document.createElement("div");
    attachment.className = "qk-fee-attachment";
    attachment.innerHTML = `<span class=\"qk-fee-attachment__dot\" aria-hidden=\"true\"></span><span>${escapeHtml(payload && payload.label ? payload.label : "Taxa Verde Inclusa")}</span>${quantityMarkup}`;
    return attachment;
  }

  function renderFeeAttachments(cart, config, domSnapshot) {
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    if (!lineElements.length) {
      return;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((item) => {
      const key = String(item && item.key ? item.key : "");
      if (key) {
        itemByKey[key] = item;
      }
    });

    const feeRuleByProductLegacyId = {};
    (Array.isArray(config && config.fees && config.fees.rules) ? config.fees.rules : []).forEach((rule) => {
      const productId = normalizeLegacyId(rule && rule.feeProductLegacyId);
      const key = String(rule && rule.key ? rule.key : "");
      if (productId && key) {
        feeRuleByProductLegacyId[productId] = key;
      }
    });

    const lineElementsByKey = (() => {
      if (domSnapshot && typeof domSnapshot === "object" && domSnapshot.lineElementsByKey) {
        return safeObject(domSnapshot.lineElementsByKey);
      }

      const fallback = {};
      lineElements.forEach((lineElement) => {
        const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
        if (!lineKey) {
          return;
        }
        fallback[lineKey] = fallback[lineKey] || [];
        fallback[lineKey].push(lineElement);
      });
      return fallback;
    })();

    lineElements.forEach((lineElement) => {
      if (lineElement.hasAttribute("data-qk-fee-rule")) {
        lineElement.removeAttribute("data-qk-fee-rule");
      }
    });

    const feeTagLookupFromDom = { byLineKey: {}, byProductId: {} };
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
      if (!lineKey) {
        return;
      }
      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }
      const rawTags = String(lineElement.getAttribute("data-product-tags") || "");
      const tags = normalizeTagList(rawTags.split("||"));
      feeTagLookupFromDom.byLineKey[lineKey] = tags;
      const productLegacyId = normalizeLegacyId(line && line.product_id);
      if (productLegacyId && (!feeTagLookupFromDom.byProductId[productLegacyId] || tags.length)) {
        feeTagLookupFromDom.byProductId[productLegacyId] = tags;
      }
    });

    const parentLineKeyByRule = {};
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }

      if (!isEligibleFeeParentLine(line)) {
        return;
      }

      const tags = resolveFeeTagsForLine(line, feeTagLookupFromDom);
      const matchedRules = resolveMatchedFeeRules(tags, config.fees.rules);
      matchedRules.forEach((ruleKey) => {
        if (!parentLineKeyByRule[ruleKey]) {
          parentLineKeyByRule[ruleKey] = lineKey;
        }
      });
    });

    const attachmentPayloadByParent = {};
    const hiddenManagedFeeLineKeys = new Set();
    const processedManagedFeeLineKeys = new Set();

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey) {
        return;
      }

      if (processedManagedFeeLineKeys.has(lineKey)) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line || !isManagedFeeLine(line)) {
        return;
      }
      processedManagedFeeLineKeys.add(lineKey);

      const fallbackRule = feeRuleByProductLegacyId[normalizeLegacyId(line.product_id)] || "";
      const ruleKey = String(getLineProperty(line, ATTR_FEE_RULE) || fallbackRule || "").trim();
      if (!ruleKey) {
        return;
      }

      lineElement.setAttribute("data-qk-fee-rule", ruleKey);

      const explicitSourceLineKey = resolveFeeManagedSourceLineKey(items, line, config.fees.rules, feeTagLookupFromDom);
      const parentKey =
        (explicitSourceLineKey && Array.isArray(lineElementsByKey[explicitSourceLineKey]) ? explicitSourceLineKey : "") ||
        parentLineKeyByRule[ruleKey];
      if (!parentKey || !Array.isArray(lineElementsByKey[parentKey])) {
        return;
      }

      hiddenManagedFeeLineKeys.add(lineKey);

      const label = "Taxa Verde Inclusa";
      const payloadKey = String(ruleKey || normalizeLegacyId(line && line.variant_id) || lineKey).trim() || lineKey;
      const nextQuantity = Math.max(1, parseInteger(line && line.quantity));
      attachmentPayloadByParent[parentKey] = attachmentPayloadByParent[parentKey] || {};
      const existingPayload = attachmentPayloadByParent[parentKey][payloadKey] || {
        label,
        quantity: 0,
      };
      existingPayload.quantity += nextQuantity;
      attachmentPayloadByParent[parentKey][payloadKey] = existingPayload;
    });

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      const container = getLineContainer(lineElement);
      const line = itemByKey[lineKey];
      container.classList.toggle(
        "qk-fee-line--hidden",
        hiddenManagedFeeLineKeys.has(lineKey) || isManagedCodFeeLine(line),
      );
    });

    const desiredFeeAttachmentsByParent = {};
    Object.keys(attachmentPayloadByParent).forEach((parentKey) => {
      const payloadsByKey = attachmentPayloadByParent[parentKey] || {};
      const entries = Object.keys(payloadsByKey).map((payloadKey) => {
        const payload = payloadsByKey[payloadKey];
        return {
          signature: buildFeeAttachmentSignature(parentKey, payloadKey, payload),
          build: () => buildFeeAttachmentElement(payload),
        };
      });
      if (entries.length) {
        desiredFeeAttachmentsByParent[parentKey] = entries;
      }
    });

    reconcileLineItemAttachments({
      className: "qk-fee-attachment",
      desiredByParentLineKey: desiredFeeAttachmentsByParent,
      lineElementsByKey,
    });
  }

  // Must stay in sync with the data-qk-sig emitted by snippets/line-item.liquid.
  function buildLubricationAttachmentSignature(parentLineKey, payload) {
    return [
      "lube",
      String(parentLineKey || ""),
      String(payload && payload.managedLineKey ? payload.managedLineKey : ""),
      String(Math.max(1, parseInteger(payload && payload.quantity))),
      String(Math.max(0, parseInteger(payload && payload.priceCents))),
      String(payload && payload.ruleKey ? payload.ruleKey : ""),
      String(payload && payload.title ? payload.title : ""),
    ].join("|");
  }

  function buildLubricationAttachmentElement(parentLineKey, payload, attachmentLabel, removeLabel) {
    const attachment = document.createElement("div");
    attachment.className = "qk-lube-attachment";
    attachment.setAttribute("data-qk-lube-attachment", "1");
    attachment.setAttribute("data-qk-parent-line-key", parentLineKey);
    attachment.setAttribute("data-qk-managed-line-key", String(payload.managedLineKey || ""));
    attachment.setAttribute("data-qk-lube-rule", String(payload.ruleKey || ""));

    const quantityMarkup = payload.quantity > 1
      ? `<span class=\"qk-lube-attachment__qty\">x${Math.max(1, parseInteger(payload.quantity))}</span>`
      : "";
    const priceMarkup = payload.priceCents > 0
      ? `<span class=\"qk-lube-attachment__price\">+${escapeHtml(formatLei(payload.priceCents))}</span>`
      : "";

    attachment.innerHTML = `
      <span class=\"qk-lube-attachment__meta\">
        <span class=\"qk-lube-attachment__dot\" aria-hidden=\"true\"></span>
        <span class=\"qk-lube-attachment__title\">${escapeHtml(payload.title || attachmentLabel)}</span>
        ${quantityMarkup}
      </span>
      ${priceMarkup}
      <button type=\"button\" class=\"qk-lube-attachment__remove\" data-qk-lube-remove>${escapeHtml(removeLabel)}</button>
    `;

    return attachment;
  }

  function renderLubricationAttachments(cart, lubricationConfig, domSnapshot) {
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    if (!lineElements.length) {
      return;
    }

    const config = safeObject(lubricationConfig);
    const ui = safeObject(config.ui);
    const attachmentLabel = String(ui.attachment_ro || "Lubrifiere switch-uri").trim();
    const removeLabel = "Elimina";

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((item) => {
      const key = String(item && item.key ? item.key : "");
      if (key) {
        itemByKey[key] = item;
      }
    });

    const lineElementsByKey = (() => {
      if (domSnapshot && typeof domSnapshot === "object" && domSnapshot.lineElementsByKey) {
        return safeObject(domSnapshot.lineElementsByKey);
      }

      const fallback = {};
      lineElements.forEach((lineElement) => {
        const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
        if (!lineKey) {
          return;
        }
        fallback[lineKey] = fallback[lineKey] || [];
        fallback[lineKey].push(lineElement);
      });
      return fallback;
    })();

    const fallbackParentLineKeysByRuleAndScope = {};
    const parentCandidates = [];
    const processedParentLineKeys = new Set();
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey) {
        return;
      }

      if (processedParentLineKeys.has(lineKey)) {
        return;
      }
      processedParentLineKeys.add(lineKey);

      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }

      if (!isEligibleLubricationParentLine(line)) {
        return;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        parentCandidates.push({
          lineKey,
          selected: false,
          scope: "",
          ruleKey: "",
          quantity: Math.max(0, parseInteger(line && line.quantity)),
        });
        return;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      const isSelectedLubeLine = Boolean(scope);
      const ruleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();

      parentCandidates.push({
        lineKey,
        selected: isSelectedLubeLine,
        scope,
        ruleKey,
        quantity: Math.max(0, parseInteger(line && line.quantity)),
      });

      if (isSelectedLubeLine && ruleKey) {
        const scopedRuleKey = `${scope}::${ruleKey}`;
        const wildcardRuleKey = `*::${ruleKey}`;

        fallbackParentLineKeysByRuleAndScope[scopedRuleKey] = fallbackParentLineKeysByRuleAndScope[scopedRuleKey] || [];
        if (!fallbackParentLineKeysByRuleAndScope[scopedRuleKey].includes(lineKey)) {
          fallbackParentLineKeysByRuleAndScope[scopedRuleKey].push(lineKey);
        }

        fallbackParentLineKeysByRuleAndScope[wildcardRuleKey] = fallbackParentLineKeysByRuleAndScope[wildcardRuleKey] || [];
        if (!fallbackParentLineKeysByRuleAndScope[wildcardRuleKey].includes(lineKey)) {
          fallbackParentLineKeysByRuleAndScope[wildcardRuleKey].push(lineKey);
        }
      }
    });

    const parentLineKeysWithAttachment = new Set();
    const hiddenManagedLineKeys = new Set();
    const attachmentPayloadByParent = {};
    const processedManagedLineKeys = new Set();
    const lubricationRuleMaps = buildLubricationRuleMaps(config);

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey || processedManagedLineKeys.has(lineKey)) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line || !isManagedLubricationLine(line)) {
        return;
      }
      processedManagedLineKeys.add(lineKey);

      const sourceLineKey =
        resolveLubricationManagedSourceLineKey(items, line, lubricationRuleMaps) ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      let parentLineKey = "";
      if (sourceLineKey && Array.isArray(lineElementsByKey[sourceLineKey])) {
        parentLineKey = sourceLineKey;
      } else {
        const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
        const resolvedManagedRule = resolveLubricationRuleForManagedLine(line, lubricationRuleMaps);
        const ruleKey = String((resolvedManagedRule && resolvedManagedRule.key) || getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
        const scopedRuleKey = `${managedScope || ""}::${ruleKey}`;
        const wildcardRuleKey = `*::${ruleKey}`;
        const matchedByRule = ruleKey
          ? (
              fallbackParentLineKeysByRuleAndScope[scopedRuleKey] ||
              fallbackParentLineKeysByRuleAndScope[wildcardRuleKey] ||
              []
            )
          : [];
        if (matchedByRule.length) {
          parentLineKey =
            matchedByRule.find((candidateLineKey) => !parentLineKeysWithAttachment.has(candidateLineKey)) || matchedByRule[0];
        }
      }

      if (!parentLineKey) {
        const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
        const managedQuantity = Math.max(0, parseInteger(line && line.quantity));
        const selectedCandidates = parentCandidates.filter((candidate) => {
          if (!candidate || !candidate.selected) {
            return false;
          }

          if (!managedScope || !candidate.scope) {
            return true;
          }

          return candidate.scope === managedScope;
        });
        if (selectedCandidates.length === 1) {
          parentLineKey = selectedCandidates[0].lineKey;
        } else if (selectedCandidates.length > 1) {
          const exactQuantityMatch = selectedCandidates.find((candidate) => candidate.quantity === managedQuantity);
          if (exactQuantityMatch) {
            parentLineKey = exactQuantityMatch.lineKey;
          }
        }
      }

      if (!parentLineKey) {
        const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
        const firstSelected = parentCandidates.find((candidate) => {
          if (!candidate || !candidate.selected) {
            return false;
          }

          if (!managedScope || !candidate.scope) {
            return true;
          }

          return candidate.scope === managedScope;
        });
        if (firstSelected) {
          parentLineKey = firstSelected.lineKey;
        }
      }

      if (!parentLineKey) {
        const selectedParentCandidates = parentCandidates.filter((candidate) => candidate && candidate.selected);
        if (selectedParentCandidates.length === 1) {
          parentLineKey = selectedParentCandidates[0].lineKey;
        }
      }

      if (!parentLineKey || !Array.isArray(lineElementsByKey[parentLineKey])) {
        return;
      }

      if (lineKey) {
        hiddenManagedLineKeys.add(lineKey);
      }

      parentLineKeysWithAttachment.add(parentLineKey);

      const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      const managedRuleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
      const payloadKey = `${managedScope || ""}::${managedRuleKey || normalizeLegacyId(line && line.variant_id) || lineKey}`;

      attachmentPayloadByParent[parentLineKey] = attachmentPayloadByParent[parentLineKey] || {};
      const existingPayload = attachmentPayloadByParent[parentLineKey][payloadKey];
      const nextPayload = existingPayload || {
        managedLineKey: lineKey,
        ruleKey: managedRuleKey,
        title: String(line.product_title || line.title || attachmentLabel).trim() || attachmentLabel,
        quantity: 0,
        priceCents: 0,
      };
      if (!nextPayload.ruleKey && managedRuleKey) {
        nextPayload.ruleKey = managedRuleKey;
      }
      nextPayload.quantity += Math.max(1, parseInteger(line.quantity));
      nextPayload.priceCents += resolveLineTotalPriceCents(line);
      attachmentPayloadByParent[parentLineKey][payloadKey] = nextPayload;
    });

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      const container = getLineContainer(lineElement);
      container.classList.toggle("qk-lube-line--hidden", hiddenManagedLineKeys.has(lineKey));
    });

    const desiredLubeAttachmentsByParent = {};
    Object.keys(attachmentPayloadByParent).forEach((parentLineKey) => {
      const payloadEntries = Object.values(attachmentPayloadByParent[parentLineKey] || {});
      if (!payloadEntries.length) {
        return;
      }

      desiredLubeAttachmentsByParent[parentLineKey] = payloadEntries.map((payload) => ({
        signature: buildLubricationAttachmentSignature(parentLineKey, payload),
        build: () => buildLubricationAttachmentElement(parentLineKey, payload, attachmentLabel, removeLabel),
      }));
    });

    reconcileLineItemAttachments({
      className: "qk-lube-attachment",
      desiredByParentLineKey: desiredLubeAttachmentsByParent,
      lineElementsByKey,
    });
  }

  function renderGiftWrapUi(cart) {
    const mounts = Array.from(document.querySelectorAll("[data-qk-gift-wrap-mount]"));
    if (!mounts.length) {
      closeGiftWrapModal({ restoreFocus: false });
      return;
    }

    const uiState = resolveGiftWrapUiState(cart);
    const isBusy = isGiftWrapControlBusy();
    const canToggleOn = uiState.available;
    const canToggleOff = uiState.selected;
    const controlDisabled = isBusy || (!canToggleOn && !canToggleOff);

    mounts.forEach((mount) => {
      const shell = ensureGiftWrapMountShell(mount);
      if (!shell) {
        return;
      }
      const toggleWrap = shell.toggleWrap;
      const toggleButton = shell.toggleButton;

      mount.setAttribute("data-qk-gift-wrap-hydrated", "1");
      toggleWrap.classList.toggle("is-selected", uiState.selected);
      toggleWrap.classList.toggle("is-disabled", controlDisabled);
      toggleWrap.removeAttribute("aria-hidden");

      toggleButton.setAttribute("data-selected", uiState.selected ? "1" : "0");
      toggleButton.setAttribute("aria-pressed", uiState.selected ? "true" : "false");
      if (controlDisabled) {
        toggleButton.setAttribute("disabled", "disabled");
        toggleButton.setAttribute("aria-disabled", "true");
      } else {
        toggleButton.removeAttribute("disabled");
        toggleButton.removeAttribute("aria-disabled");
      }

      mount.querySelectorAll(".qk-gift-wrap-toggle__helper").forEach((helper) => {
        helper.remove();
      });
    });

    if (state.giftWrapAddPerfPending && uiState.selected && uiState.hasManagedLine) {
      markPerf("gift-wrap-add-line-visible");
      measurePerf("gift-wrap-add-click-to-line-visible", "gift-wrap-add-click-line", "gift-wrap-add-line-visible");
      state.giftWrapAddPerfPending = false;
    }

    renderGiftWrapModal(uiState, isBusy);
  }

  function ensureGiftWrapMountShell(mount) {
    if (!(mount instanceof HTMLElement)) {
      return null;
    }

    let toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
    let toggleButton = mount.querySelector("[data-qk-gift-wrap-toggle]");

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      mount.innerHTML = `
        <div class="qk-gift-wrap-toggle-wrap is-disabled" aria-hidden="true">
          <button
            type="button"
            class="qk-gift-wrap-toggle"
            data-qk-gift-wrap-toggle
            aria-pressed="false"
            aria-disabled="true"
            disabled
          >
            <span class="qk-gift-wrap-toggle__left">
              <span class="qk-gift-wrap-toggle__label">Impachetare Cadou</span>
            </span>
            <span class="qk-gift-wrap-toggle__checkbox" aria-hidden="true"></span>
          </button>
        </div>
      `;
      toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
      toggleButton = mount.querySelector("[data-qk-gift-wrap-toggle]");
    }

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      return null;
    }

    return {
      toggleWrap,
      toggleButton,
    };
  }

  function renderGiftWrapModal(uiState, isBusy) {
    const modal = ensureGiftWrapModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    const imageElement = modal.querySelector("[data-qk-gift-wrap-modal-image]");
    const titleElement = modal.querySelector("[data-qk-gift-wrap-modal-title]");
    const priceElement = modal.querySelector("[data-qk-gift-wrap-modal-price]");
    const descriptionElement = modal.querySelector("[data-qk-gift-wrap-modal-description]");
    const confirmButton = modal.querySelector("[data-qk-gift-wrap-modal-confirm]");

    if (titleElement instanceof HTMLElement) {
      setCartUiText(titleElement, uiState.productTitle);
    }

    if (priceElement instanceof HTMLElement) {
      setCartUiText(priceElement, uiState.priceCents > 0 ? formatLei(uiState.priceCents) : "");
      priceElement.hidden = !priceElement.textContent;
    }

    if (descriptionElement instanceof HTMLElement) {
      setCartUiText(descriptionElement, uiState.descriptionText);
      descriptionElement.hidden = !uiState.descriptionText;
    }

    if (imageElement instanceof HTMLImageElement) {
      if (uiState.imageUrl) {
        imageElement.hidden = false;
        imageElement.src = uiState.imageUrl;
        imageElement.alt = uiState.productTitle;
      } else {
        imageElement.hidden = true;
        imageElement.removeAttribute("src");
        imageElement.alt = "";
      }
    }

    if (confirmButton instanceof HTMLButtonElement) {
      const shouldDisable = isBusy || !uiState.available || uiState.selected;
      confirmButton.disabled = shouldDisable;
      confirmButton.setAttribute("aria-disabled", shouldDisable ? "true" : "false");
      const isConfirmBusy = Boolean(state.giftWrapConfirmBusy);
      confirmButton.classList.toggle("is-loading", isConfirmBusy);
      confirmButton.setAttribute("aria-busy", isConfirmBusy ? "true" : "false");
    }

    if (state.giftWrapModalOpen && uiState.selected && !state.giftWrapUiBusy) {
      closeGiftWrapModal({ restoreFocus: false });
    }
  }

  function resolveGiftWrapUiState(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const managedLine = items.find((line) => isManagedGiftWrapLine(line)) || null;
    const hasManagedLine = Boolean(managedLine);
    const selected = readGiftWrapSelected(cart, items);
    const hasBaseLine = hasEligibleGiftWrapBaseLine(items);
    const available = Boolean(state.giftWrapInStock && normalizeLegacyId(state.giftWrapVariantLegacyId) && hasBaseLine);
    const product = state.giftWrapProduct;

    const productTitle = String(
      (managedLine && (managedLine.product_title || managedLine.title)) ||
        (product && product.title) ||
        "Impachetare Cadou",
    ).trim();
    const priceCents = resolveGiftWrapPriceCents(product, state.giftWrapVariantLegacyId, managedLine);
    const descriptionText = resolveGiftWrapDescriptionText(product);
    const imageUrl = resolveGiftWrapProductImageUrl(product, managedLine);

    return {
      selected,
      available,
      hasBaseLine,
      hasManagedLine,
      productTitle,
      priceCents,
      descriptionText,
      imageUrl,
    };
  }

  function renderPackageInsuranceUi(cart) {
    const mounts = Array.from(document.querySelectorAll("[data-qk-package-insurance-mount]"));
    if (!mounts.length) {
      closePackageInsuranceModal({ restoreFocus: false });
      return;
    }

    const uiState = resolvePackageInsuranceUiState(cart);
    const isBusy = isPackageInsuranceControlBusy();
    const canToggleOn = uiState.available;
    const canToggleOff = uiState.selected;
    const controlDisabled = isBusy || (!canToggleOn && !canToggleOff);

    mounts.forEach((mount) => {
      const shell = ensurePackageInsuranceMountShell(mount);
      if (!shell) {
        return;
      }
      const toggleWrap = shell.toggleWrap;
      const toggleButton = shell.toggleButton;

      mount.setAttribute("data-qk-package-insurance-hydrated", "1");
      toggleWrap.classList.toggle("is-selected", uiState.selected);
      toggleWrap.classList.toggle("is-disabled", controlDisabled);
      toggleWrap.removeAttribute("aria-hidden");

      toggleButton.setAttribute("data-selected", uiState.selected ? "1" : "0");
      toggleButton.setAttribute("aria-pressed", uiState.selected ? "true" : "false");
      if (controlDisabled) {
        toggleButton.setAttribute("disabled", "disabled");
        toggleButton.setAttribute("aria-disabled", "true");
      } else {
        toggleButton.removeAttribute("disabled");
        toggleButton.removeAttribute("aria-disabled");
      }

      mount.querySelectorAll(".qk-gift-wrap-toggle__helper").forEach((helper) => {
        helper.remove();
      });
    });

    if (state.packageInsuranceAddPerfPending && uiState.selected && uiState.hasManagedLine) {
      markPerf("package-insurance-add-line-visible");
      measurePerf(
        "package-insurance-add-click-to-line-visible",
        "package-insurance-add-click-line",
        "package-insurance-add-line-visible",
      );
      state.packageInsuranceAddPerfPending = false;
    }

    renderPackageInsuranceModal(uiState, isBusy);
  }

  function ensurePackageInsuranceMountShell(mount) {
    if (!(mount instanceof HTMLElement)) {
      return null;
    }

    let toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
    let toggleButton = mount.querySelector("[data-qk-package-insurance-toggle]");

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      mount.innerHTML = `
        <div class="qk-gift-wrap-toggle-wrap is-disabled" aria-hidden="true">
          <button
            type="button"
            class="qk-gift-wrap-toggle"
            data-qk-package-insurance-toggle
            aria-pressed="false"
            aria-disabled="true"
            disabled
          >
            <span class="qk-gift-wrap-toggle__left">
              <span class="qk-gift-wrap-toggle__label">Asigurare Colet</span>
            </span>
            <span class="qk-gift-wrap-toggle__checkbox" aria-hidden="true"></span>
          </button>
        </div>
      `;
      toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
      toggleButton = mount.querySelector("[data-qk-package-insurance-toggle]");
    }

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      return null;
    }

    return {
      toggleWrap,
      toggleButton,
    };
  }

  function renderPackageInsuranceModal(uiState, isBusy) {
    const modal = ensurePackageInsuranceModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    const imageElement = modal.querySelector("[data-qk-package-insurance-modal-image]");
    const titleElement = modal.querySelector("[data-qk-package-insurance-modal-title]");
    const priceElement = modal.querySelector("[data-qk-package-insurance-modal-price]");
    const descriptionElement = modal.querySelector("[data-qk-package-insurance-modal-description]");
    const confirmButton = modal.querySelector("[data-qk-package-insurance-modal-confirm]");

    if (titleElement instanceof HTMLElement) {
      setCartUiText(titleElement, uiState.productTitle);
    }

    if (priceElement instanceof HTMLElement) {
      setCartUiText(priceElement, uiState.priceCents > 0 ? formatLei(uiState.priceCents) : "");
      priceElement.hidden = !priceElement.textContent;
    }

    if (descriptionElement instanceof HTMLElement) {
      setCartUiText(descriptionElement, uiState.descriptionText);
      descriptionElement.hidden = !uiState.descriptionText;
    }

    if (imageElement instanceof HTMLImageElement) {
      if (uiState.imageUrl) {
        imageElement.hidden = false;
        imageElement.src = uiState.imageUrl;
        imageElement.alt = uiState.productTitle;
      } else {
        imageElement.hidden = true;
        imageElement.removeAttribute("src");
        imageElement.alt = "";
      }
    }

    if (confirmButton instanceof HTMLButtonElement) {
      const shouldDisable = isBusy || !uiState.available || uiState.selected;
      confirmButton.disabled = shouldDisable;
      confirmButton.setAttribute("aria-disabled", shouldDisable ? "true" : "false");
      const isConfirmBusy = Boolean(state.packageInsuranceConfirmBusy);
      confirmButton.classList.toggle("is-loading", isConfirmBusy);
      confirmButton.setAttribute("aria-busy", isConfirmBusy ? "true" : "false");
    }

    if (state.packageInsuranceModalOpen && uiState.selected && !state.packageInsuranceUiBusy) {
      closePackageInsuranceModal({ restoreFocus: false });
    }
  }

  function resolvePackageInsuranceUiState(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const managedLine = items.find((line) => isManagedPackageInsuranceLine(line)) || null;
    const hasManagedLine = Boolean(managedLine);
    const selected = readPackageInsuranceSelected(cart, items);
    const hasBaseLine = hasEligibleGiftWrapBaseLine(items);
    const available = Boolean(
      state.packageInsuranceInStock &&
        normalizeLegacyId(state.packageInsuranceVariantLegacyId) &&
        hasBaseLine,
    );
    const product = state.packageInsuranceProduct;

    const productTitle = String(
      (managedLine && (managedLine.product_title || managedLine.title)) ||
        (product && product.title) ||
        "Asigurare Colet",
    ).trim();
    const priceCents = resolveGiftWrapPriceCents(product, state.packageInsuranceVariantLegacyId, managedLine);
    const descriptionText = resolvePackageInsuranceDescriptionText(product);
    const imageUrl = resolveGiftWrapProductImageUrl(product, managedLine);

    return {
      selected,
      available,
      hasBaseLine,
      hasManagedLine,
      productTitle,
      priceCents,
      descriptionText,
      imageUrl,
    };
  }

  function resolveGiftWrapProductImageUrl(product, fallbackLine) {
    const fallbackFeaturedImage = safeObject(fallbackLine && fallbackLine.featured_image);
    const fallbackImageObject = safeObject(fallbackLine && fallbackLine.image);
    const fallbackLineImage = fallbackLine && typeof fallbackLine.image === "string" ? fallbackLine.image : "";

    const imageCandidates = [];
    if (product && Array.isArray(product.images) && product.images.length) {
      const firstImage = product.images[0];
      if (typeof firstImage === "string") {
        imageCandidates.push(firstImage);
      } else {
        imageCandidates.push(firstImage && firstImage.src, firstImage && firstImage.url);
      }
    }

    imageCandidates.push(
      product && product.featured_image && product.featured_image.src,
      fallbackFeaturedImage.url,
      fallbackFeaturedImage.src,
      fallbackLineImage,
      fallbackImageObject.url,
      fallbackImageObject.src,
    );

    for (const candidate of imageCandidates) {
      const raw = String(candidate == null ? "" : candidate).trim();
      if (!raw) {
        continue;
      }

      if (raw.startsWith("//")) {
        return `https:${raw}`;
      }

      if (raw.startsWith("/")) {
        return `${window.location.origin}${raw}`;
      }

      return raw;
    }

    return "";
  }

  function resolveGiftWrapDescriptionText(product) {
    const rawHtml = String(product && (product.body_html || product.description || "")).trim();
    if (!rawHtml) {
      return "Imbunatatiti experienta de unboxing cu serviciul nostru de impachetare cadou.";
    }

    const container = document.createElement("div");
    container.innerHTML = rawHtml;
    const text = String(container.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) {
      return "Imbunatatiti experienta de unboxing cu serviciul nostru de impachetare cadou.";
    }

    const maxLength = 340;
    if (text.length <= maxLength) {
      return text;
    }

    return `${text.slice(0, maxLength).trim()}…`;
  }

  function resolvePackageInsuranceDescriptionText(product) {
    const rawHtml = String(product && (product.body_html || product.description || "")).trim();
    if (!rawHtml) {
      return "";
    }

    const container = document.createElement("div");
    container.innerHTML = rawHtml;
    const text = String(container.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) {
      return "";
    }

    const maxLength = 340;
    if (text.length <= maxLength) {
      return text;
    }

    return `${text.slice(0, maxLength).trim()}…`;
  }

  function resolveGiftWrapPriceCents(product, variantLegacyId, fallbackLine) {
    const normalizedVariantId = normalizeLegacyId(variantLegacyId);
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (normalizedVariantId && variants.length) {
      const matchedVariant = variants.find((variant) => normalizeLegacyId(variant && variant.id) === normalizedVariantId);
      if (matchedVariant) {
        const centsFromVariant = parsePriceStringToCents(matchedVariant.price);
        if (centsFromVariant > 0) {
          return centsFromVariant;
        }
      }
    }

    const fallbackCents = parseCentsCandidate(
      fallbackLine && (fallbackLine.final_price || fallbackLine.price || fallbackLine.original_price),
    );
    if (fallbackCents != null && fallbackCents > 0) {
      return fallbackCents;
    }

    const firstVariant = variants[0];
    const centsFromFirstVariant = parsePriceStringToCents(firstVariant && firstVariant.price);
    return Math.max(0, centsFromFirstVariant);
  }

  function readGiftWrapSelected(cart, items) {
    if (state.giftWrapPendingDeselection) {
      if (state.giftWrapUiBusy) {
        return false;
      }
      state.giftWrapPendingDeselection = false;
    }
    if (state.giftWrapPendingSelection) {
      return true;
    }

    const currentAttributes = safeObject(cart && cart.attributes);
    const rawValue = String(currentAttributes[ATTR_GIFT_WRAP_SELECTED] == null ? "" : currentAttributes[ATTR_GIFT_WRAP_SELECTED]).trim();
    const normalizedRawValue = rawValue.toLowerCase();
    if (rawValue === "1" || normalizedRawValue === "true") {
      return true;
    }
    if (rawValue === "0" || normalizedRawValue === "false") {
      return false;
    }

    return (Array.isArray(items) ? items : []).some((line) => isManagedGiftWrapLine(line));
  }

  function isGiftWrapControlBusy() {
    return Boolean(
      state.giftWrapUiBusy ||
        state.giftWrapConfirmBusy ||
        state.mutationPhaseActive ||
        state.lineMutationInFlight ||
        state.lineMutationDrainTimer ||
        state.lineMutationQueue.length
    );
  }

  function readPackageInsuranceSelected(cart, items) {
    if (state.packageInsurancePendingDeselection) {
      if (state.packageInsuranceUiBusy) {
        return false;
      }
      state.packageInsurancePendingDeselection = false;
    }
    if (state.packageInsurancePendingSelection) {
      return true;
    }

    const currentAttributes = safeObject(cart && cart.attributes);
    const rawValue = String(
      currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED] == null
        ? ""
        : currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED],
    ).trim();
    const normalizedRawValue = rawValue.toLowerCase();
    if (rawValue === "1" || normalizedRawValue === "true") {
      return true;
    }
    if (rawValue === "0" || normalizedRawValue === "false") {
      return false;
    }

    return (Array.isArray(items) ? items : []).some((line) => isManagedPackageInsuranceLine(line));
  }

  function isPackageInsuranceControlBusy() {
    return Boolean(
      state.packageInsuranceUiBusy ||
        state.packageInsuranceConfirmBusy ||
        state.mutationPhaseActive ||
        state.lineMutationInFlight ||
        state.lineMutationDrainTimer ||
        state.lineMutationQueue.length
    );
  }

  async function setGiftWrapSelection(selected, options) {
    const normalizedOptions = options || {};
    const reason = normalizedOptions.reason || "gift-wrap-selection";
    const shouldSkipSync = Boolean(normalizedOptions.skipSync);
    const requestedSelected = Boolean(selected);
    const modalContext = normalizeGiftWrapModalContext(normalizedOptions.context || state.giftWrapModalContext);
    const drawerElement = modalContext === "drawer" ? resolveCartDrawerElement() : null;
    const drawerWasOpen = Boolean(drawerElement && drawerElement.hasAttribute("open"));
    const baseCart = normalizeCartPayload(state.lastCart) || state.lastCart;
    if (!baseCart) {
      clearOptimisticAddonSelection("gift-wrap", { restoreTotal: true });
      state.giftWrapConfirmBusy = false;
      state.giftWrapPendingSelection = false;
      if (!shouldSkipSync) {
        activateCartSync(reason, null, 30);
      }
      return;
    }

    if (requestedSelected && (!state.giftWrapInStock || !normalizeLegacyId(state.giftWrapVariantLegacyId))) {
      try {
        await ensureGiftWrapVariantId(baseCart);
      } catch (error) {
        debugLog("[qk-cart-rules] gift-wrap variant ensure on selection failed", error);
      }
    }

    const hasBaseLine = hasEligibleGiftWrapBaseLine(baseCart.items);
    const canSelect = Boolean(state.giftWrapInStock && normalizeLegacyId(state.giftWrapVariantLegacyId) && hasBaseLine);
    const nextSelected = requestedSelected && canSelect;
    if (!requestedSelected) {
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      state.giftWrapPendingSelection = false;
    }

    if (requestedSelected && !canSelect) {
      clearOptimisticAddonSelection("gift-wrap", { restoreTotal: true });
      state.giftWrapPendingDeselection = false;
      state.giftWrapPendingSelection = false;
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      scheduleUiRefresh("gift-wrap-selection-unavailable");
      return;
    }

    state.giftWrapPendingDeselection = !nextSelected;
    state.giftWrapPendingSelection = nextSelected;

    const currentAttributes = safeObject(baseCart.attributes);
    const currentValue = String(currentAttributes[ATTR_GIFT_WRAP_SELECTED] == null ? "" : currentAttributes[ATTR_GIFT_WRAP_SELECTED]).trim();
    const desiredValue = nextSelected ? "1" : "0";
    const immediateVariantUpdates = buildGiftWrapImmediateVariantUpdates(baseCart, nextSelected);
    const hasImmediateVariantUpdates = Object.keys(immediateVariantUpdates).length > 0;

    if (currentValue === desiredValue && !hasImmediateVariantUpdates) {
      clearOptimisticAddonSelection("gift-wrap", { restoreTotal: true });
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      state.giftWrapPendingSelection = false;
      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldScheduleGiftWrapFollowUpSync(baseCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, baseCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
      return;
    }

    state.giftWrapUiBusy = true;
    refreshCheckoutButtonsBusy();
    scheduleUiRefresh("gift-wrap-selection-start");

    try {
      if (
        nextSelected &&
        !shouldSkipSync &&
        canUseManagedAddonAddPath(baseCart, GIFT_WRAP_PRODUCT_LEGACY_ID)
      ) {
        await syncNow(reason, { seedCart: baseCart });
        restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
        return;
      }

      const sectionIds = collectBundledSectionIds();
      const payload = {
        attributes: Object.assign({}, currentAttributes, {
          [ATTR_GIFT_WRAP_SELECTED]: desiredValue,
        }),
      };
      if (hasImmediateVariantUpdates) {
        payload.updates = immediateVariantUpdates;
      }

      if (Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      const updatedCart = normalizeCartPayload(await requestCartJson("cart/update.js", payload)) || baseCart;
      state.lastCart = updatedCart;
      const drawerUpdatedImmediately = updateCartDrawerSectionImmediately(updatedCart);
      updateMainCartSection(updatedCart);
      refreshUiFromState();
      dispatchCartChanged("qk:gift-wrap-selection", updatedCart, {
        preserveDrawerInner: drawerUpdatedImmediately,
      });

      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldScheduleGiftWrapFollowUpSync(updatedCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, updatedCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } catch (error) {
      clearOptimisticAddonSelection("gift-wrap", { restoreTotal: true });
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      reportError(error, "Nu am putut actualiza optiunea de impachetare cadou.");
      if (!shouldSkipSync) {
        scheduleSync("gift-wrap-selection-fallback", baseCart, 60);
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } finally {
      state.giftWrapUiBusy = false;
      state.giftWrapConfirmBusy = false;
      state.giftWrapPendingSelection = false;
      refreshCheckoutButtonsBusy();
      scheduleUiRefresh("gift-wrap-selection-end");
      if (drawerWasOpen) {
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 0);
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 180);
      }
    }
  }

  function shouldScheduleGiftWrapFollowUpSync(cart, selected) {
    const normalizedCart = normalizeCartPayload(cart) || safeObject(cart);
    const items = Array.isArray(normalizedCart && normalizedCart.items) ? normalizedCart.items : [];
    const giftWrapProductLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedGiftWrapLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === giftWrapProductLegacyId;
    });

    if (!selected) {
      return relatedLines.length > 0;
    }

    if (relatedLines.length !== 1) {
      return true;
    }

    const line = relatedLines[0];
    const lineQuantity = Math.max(0, parseInteger(line && line.quantity));
    if (lineQuantity !== 1) {
      return true;
    }

    const lineVariantLegacyId = normalizeLegacyId(line && line.variant_id);
    if (targetVariantLegacyId && lineVariantLegacyId && lineVariantLegacyId !== targetVariantLegacyId) {
      return true;
    }

    const desiredManagedProperties = {
      [ATTR_GIFT_WRAP_MANAGED]: "1",
      [ATTR_GIFT_WRAP_SOURCE]: SOURCE_STOREFRONT,
    };

    return !lineHasProperties(line, desiredManagedProperties);
  }

  async function setPackageInsuranceSelection(selected, options) {
    const normalizedOptions = options || {};
    const reason = normalizedOptions.reason || "package-insurance-selection";
    const shouldSkipSync = Boolean(normalizedOptions.skipSync);
    const requestedSelected = Boolean(selected);
    const modalContext = normalizePackageInsuranceModalContext(
      normalizedOptions.context || state.packageInsuranceModalContext,
    );
    const drawerElement = modalContext === "drawer" ? resolveCartDrawerElement() : null;
    const drawerWasOpen = Boolean(drawerElement && drawerElement.hasAttribute("open"));
    const baseCart = normalizeCartPayload(state.lastCart) || state.lastCart;
    if (!baseCart) {
      clearOptimisticAddonSelection("package-insurance", { restoreTotal: true });
      state.packageInsuranceConfirmBusy = false;
      state.packageInsurancePendingSelection = false;
      if (!shouldSkipSync) {
        activateCartSync(reason, null, 30);
      }
      return;
    }

    if (requestedSelected && (!state.packageInsuranceInStock || !normalizeLegacyId(state.packageInsuranceVariantLegacyId))) {
      try {
        await ensurePackageInsuranceVariantId(baseCart);
      } catch (error) {
        debugLog("[qk-cart-rules] package insurance variant ensure on selection failed", error);
      }
    }

    const hasBaseLine = hasEligibleGiftWrapBaseLine(baseCart.items);
    const canSelect = Boolean(
      state.packageInsuranceInStock &&
        normalizeLegacyId(state.packageInsuranceVariantLegacyId) &&
        hasBaseLine,
    );
    const nextSelected = requestedSelected && canSelect;
    if (!requestedSelected) {
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      state.packageInsurancePendingSelection = false;
    }

    if (requestedSelected && !canSelect) {
      clearOptimisticAddonSelection("package-insurance", { restoreTotal: true });
      state.packageInsurancePendingDeselection = false;
      state.packageInsurancePendingSelection = false;
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      scheduleUiRefresh("package-insurance-selection-unavailable");
      return;
    }

    state.packageInsurancePendingDeselection = !nextSelected;
    state.packageInsurancePendingSelection = nextSelected;

    const currentAttributes = safeObject(baseCart.attributes);
    const currentValue = String(
      currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED] == null
        ? ""
        : currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED],
    ).trim();
    const desiredValue = nextSelected ? "1" : "0";
    const immediateVariantUpdates = buildPackageInsuranceImmediateVariantUpdates(baseCart, nextSelected);
    const hasImmediateVariantUpdates = Object.keys(immediateVariantUpdates).length > 0;

    if (currentValue === desiredValue && !hasImmediateVariantUpdates) {
      clearOptimisticAddonSelection("package-insurance", { restoreTotal: true });
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      state.packageInsurancePendingSelection = false;
      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldSchedulePackageInsuranceFollowUpSync(baseCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, baseCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
      return;
    }

    state.packageInsuranceUiBusy = true;
    refreshCheckoutButtonsBusy();
    scheduleUiRefresh("package-insurance-selection-start");

    try {
      if (
        nextSelected &&
        !shouldSkipSync &&
        canUseManagedAddonAddPath(baseCart, PACKAGE_INSURANCE_PRODUCT_LEGACY_ID)
      ) {
        await syncNow(reason, { seedCart: baseCart });
        restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
        return;
      }

      const sectionIds = collectBundledSectionIds();
      const payload = {
        attributes: Object.assign({}, currentAttributes, {
          [ATTR_PACKAGE_INSURANCE_SELECTED]: desiredValue,
        }),
      };
      if (hasImmediateVariantUpdates) {
        payload.updates = immediateVariantUpdates;
      }

      if (Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      const updatedCart = normalizeCartPayload(await requestCartJson("cart/update.js", payload)) || baseCart;
      state.lastCart = updatedCart;
      const drawerUpdatedImmediately = updateCartDrawerSectionImmediately(updatedCart);
      updateMainCartSection(updatedCart);
      refreshUiFromState();
      dispatchCartChanged("qk:package-insurance-selection", updatedCart, {
        preserveDrawerInner: drawerUpdatedImmediately,
      });

      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldSchedulePackageInsuranceFollowUpSync(updatedCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, updatedCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } catch (error) {
      clearOptimisticAddonSelection("package-insurance", { restoreTotal: true });
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      reportError(error, "Nu am putut actualiza optiunea de asigurare colet.");
      if (!shouldSkipSync) {
        scheduleSync("package-insurance-selection-fallback", baseCart, 60);
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } finally {
      state.packageInsuranceUiBusy = false;
      state.packageInsuranceConfirmBusy = false;
      state.packageInsurancePendingSelection = false;
      refreshCheckoutButtonsBusy();
      scheduleUiRefresh("package-insurance-selection-end");
      if (drawerWasOpen) {
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 0);
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 180);
      }
    }
  }

  function shouldSchedulePackageInsuranceFollowUpSync(cart, selected) {
    const normalizedCart = normalizeCartPayload(cart) || safeObject(cart);
    const items = Array.isArray(normalizedCart && normalizedCart.items) ? normalizedCart.items : [];
    const packageInsuranceProductLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedPackageInsuranceLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === packageInsuranceProductLegacyId;
    });

    if (!selected) {
      return relatedLines.length > 0;
    }

    if (relatedLines.length !== 1) {
      return true;
    }

    const line = relatedLines[0];
    const lineQuantity = Math.max(0, parseInteger(line && line.quantity));
    if (lineQuantity !== 1) {
      return true;
    }

    const lineVariantLegacyId = normalizeLegacyId(line && line.variant_id);
    if (targetVariantLegacyId && lineVariantLegacyId && lineVariantLegacyId !== targetVariantLegacyId) {
      return true;
    }

    const desiredManagedProperties = {
      [ATTR_PACKAGE_INSURANCE_MANAGED]: "1",
      [ATTR_PACKAGE_INSURANCE_SOURCE]: SOURCE_STOREFRONT,
    };

    return !lineHasProperties(line, desiredManagedProperties);
  }

  function canUseManagedAddonAddPath(cart, productLegacyId) {
    if (state.inFlight) {
      return false;
    }

    const normalizedProductLegacyId = normalizeLegacyId(productLegacyId);
    if (!normalizedProductLegacyId) {
      return false;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return !items.some(
      (line) => normalizeLegacyId(line && line.product_id) === normalizedProductLegacyId,
    );
  }

  function buildPackageInsuranceImmediateVariantUpdates(cart, selected) {
    const updates = {};
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const cartVariantLegacyId = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));

    if (selected) {
      if (cartVariantLegacyId && targetVariantLegacyId && cartVariantLegacyId !== targetVariantLegacyId) {
        updates[cartVariantLegacyId] = 0;
      }
      if (targetVariantLegacyId) {
        updates[targetVariantLegacyId] = 1;
      }
      return updates;
    }

    if (cartVariantLegacyId) {
      updates[cartVariantLegacyId] = 0;
    } else if (targetVariantLegacyId) {
      updates[targetVariantLegacyId] = 0;
    }

    return updates;
  }

  function resolveLineTotalPriceCents(line) {
    const totalCandidates = [
      line && line.final_line_price,
      line && line.line_price,
      line && line.original_line_price,
    ];

    for (const candidate of totalCandidates) {
      const resolvedCandidate = parseCentsCandidate(candidate);
      if (resolvedCandidate != null) {
        return resolvedCandidate;
      }
    }

    const quantity = Math.max(1, parseInteger(line && line.quantity));
    const unitCandidates = [
      line && line.final_price,
      line && line.price,
      line && line.original_price,
    ];

    for (const candidate of unitCandidates) {
      const resolvedCandidate = parseCentsCandidate(candidate);
      if (resolvedCandidate != null) {
        return resolvedCandidate * quantity;
      }
    }

    return 0;
  }

  function parseCentsCandidate(value) {
    if (value == null) {
      return null;
    }

    const normalized = String(value).trim();
    if (!normalized || !/^-?\d+$/.test(normalized)) {
      return null;
    }

    return Math.max(0, parseInteger(normalized));
  }

  function parsePriceStringToCents(value) {
    if (value == null) {
      return 0;
    }

    if (typeof value === "number" && Number.isFinite(value)) {
      return Math.max(0, Math.round(value * 100));
    }

    const raw = String(value).trim();
    if (!raw) {
      return 0;
    }

    const numeric = raw.replace(/[^\d,.\-]/g, "");
    if (!numeric) {
      return 0;
    }

    const hasComma = numeric.includes(",");
    const hasDot = numeric.includes(".");
    let decimalSeparator = "";

    if (hasComma && hasDot) {
      decimalSeparator = numeric.lastIndexOf(",") > numeric.lastIndexOf(".") ? "," : ".";
    } else if (hasComma) {
      decimalSeparator = ",";
    } else if (hasDot) {
      decimalSeparator = ".";
    }

    if (!decimalSeparator) {
      const units = Number.parseInt(numeric.replace(/[^\d\-]/g, ""), 10);
      return Number.isFinite(units) ? Math.max(0, units * 100) : 0;
    }

    const separatorIndex = numeric.lastIndexOf(decimalSeparator);
    const unitsRaw = numeric.slice(0, separatorIndex).replace(/[^\d\-]/g, "");
    const decimalsRaw = numeric.slice(separatorIndex + 1).replace(/[^\d]/g, "");

    const units = Number.parseInt(unitsRaw || "0", 10);
    if (!Number.isFinite(units)) {
      return 0;
    }

    const decimals = Number.parseInt(`${decimalsRaw}00`.slice(0, 2), 10);
    if (!Number.isFinite(decimals)) {
      return 0;
    }

    return Math.max(0, units * 100 + decimals);
  }

  function getLineContainer(lineElement) {
    if (!(lineElement instanceof Element)) {
      return lineElement;
    }

    const tableRow = lineElement.closest(".order-summary__body tr");
    return tableRow || lineElement;
  }

  function updateMainCartSection(cart) {
    const sectionHost = document.querySelector("[data-main-cart-section-id]");
    if (!(sectionHost instanceof Element)) {
      return;
    }

    const sectionId = sectionHost.getAttribute("data-main-cart-section-id");
    if (!sectionId) {
      return;
    }

    const sections = safeObject(cart && cart.sections);
    const sectionHtml = sections[sectionId];
    if (typeof sectionHtml !== "string" || !sectionHtml.trim()) {
      return;
    }

    const currentSection = document.getElementById(`shopify-section-${sectionId}`);
    if (!currentSection) {
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, "text/html");
    const replacement =
      doc.getElementById(`shopify-section-${sectionId}`) ||
      doc.querySelector(".shopify-section") ||
      null;

    if (replacement) {
      currentSection.replaceWith(replacement);
      ensureKlarnaPlacementsLocale(replacement);
      refreshCartUiObserverTargets();
      return;
    }

    currentSection.innerHTML = sectionHtml;
    ensureKlarnaPlacementsLocale(currentSection);
    refreshCartUiObserverTargets();
  }

  function updateCartDrawerSectionImmediately(cart) {
    if (!hasOptimisticAddonSelection()) {
      return false;
    }

    const drawerElement = resolveCartDrawerElement();
    if (!(drawerElement instanceof HTMLElement)) {
      return false;
    }

    const sections = safeObject(cart && cart.sections);
    const sectionContainer = drawerElement.closest(".shopify-section");
    const currentSectionId = String(sectionContainer && sectionContainer.id ? sectionContainer.id : "")
      .replace(/^shopify-section-/, "")
      .trim();
    let sectionHtml = currentSectionId ? sections[currentSectionId] : "";
    if (typeof sectionHtml !== "string" || !sectionHtml.trim()) {
      const fallbackSectionId = Object.keys(sections).find((sectionId) => {
        const candidate = sections[sectionId];
        return typeof candidate === "string" && candidate.includes('id="cart-drawer"');
      });
      sectionHtml = fallbackSectionId ? sections[fallbackSectionId] : "";
    }

    if (typeof sectionHtml !== "string" || !sectionHtml.trim()) {
      return false;
    }

    const parser = new DOMParser();
    const sectionDocument = parser.parseFromString(sectionHtml, "text/html");
    const updatedDrawer =
      sectionDocument.querySelector("cart-drawer#cart-drawer") ||
      sectionDocument.querySelector("cart-drawer");
    if (!(updatedDrawer instanceof HTMLElement)) {
      return false;
    }

    const currentInner = drawerElement.querySelector(".cart-drawer__inner");
    const updatedInner = updatedDrawer.querySelector(".cart-drawer__inner");
    const currentFooter = drawerElement.querySelector('[slot="footer"]');
    const updatedFooter = updatedDrawer.querySelector('[slot="footer"]');
    if (!(currentInner instanceof HTMLElement) || !(updatedInner instanceof HTMLElement)) {
      return false;
    }

    currentInner.innerHTML = updatedInner.innerHTML;
    if (currentFooter instanceof HTMLElement && updatedFooter instanceof HTMLElement) {
      currentFooter.replaceChildren(...updatedFooter.childNodes);
    }

    const currentSeed = drawerElement.querySelector("script[data-qk-cart-seed]");
    const updatedSeed = updatedDrawer.querySelector("script[data-qk-cart-seed]");
    if (currentSeed instanceof HTMLScriptElement && updatedSeed instanceof HTMLScriptElement) {
      currentSeed.textContent = updatedSeed.textContent;
    }

    ensureKlarnaPlacementsLocale(drawerElement);
    refreshCartUiObserverTargets();
    refreshCheckoutButtonsBusy();
    return true;
  }

  function dispatchCartChanged(baseEvent, cart, options) {
    const normalizedOptions = options || {};
    const normalizedCart = normalizeCartPayload(cart) || state.lastCart || { items: [], item_count: 0 };
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent,
          cart: normalizedCart,
          preserveDrawerInner: Boolean(normalizedOptions.preserveDrawerInner),
        },
      }),
    );
  }

  function dispatchSyncEvent(name, detail) {
    document.documentElement.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: detail || {},
      }),
    );
  }

  function setCheckoutButtonsBusy(isBusy) {
    document.querySelectorAll("[data-qk-standard-checkout-form] [name='checkout']").forEach((button) => {
      if (!(button instanceof HTMLElement)) {
        return;
      }

      if (isBusy) {
        button.setAttribute("aria-busy", "true");
        button.setAttribute("disabled", "disabled");
      } else {
        button.removeAttribute("aria-busy");
        button.removeAttribute("disabled");
      }
    });
  }

  async function ensureCartSections(cart, providedSectionIds, context) {
    const sectionIds = Array.isArray(providedSectionIds) ? providedSectionIds : collectBundledSectionIds();
    if (!sectionIds.length) {
      return cart;
    }

    const currentSections = safeObject(cart && cart.sections);
    const missingIds = sectionIds.filter((sectionId) => typeof currentSections[sectionId] !== "string");
    if (!missingIds.length) {
      return cart;
    }

    const missingSections = await fetchSectionsById(missingIds, context);
    return Object.assign({}, cart || {}, {
      sections: Object.assign({}, currentSections, missingSections),
    });
  }

  function collectBundledSectionIds() {
    const sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: {
          sections,
        },
      }),
    );

    const mainCartHost = document.querySelector("[data-main-cart-section-id]");
    if (mainCartHost instanceof Element) {
      const mainCartSectionId = mainCartHost.getAttribute("data-main-cart-section-id");
      if (mainCartSectionId) {
        sections.push(mainCartSectionId);
      }
    }

    return uniqueStrings(sections);
  }

  function readGiftWrapSessionCache(options) {
    const normalizedOptions = options || {};
    const allowStale = Boolean(normalizedOptions.allowStale);
    let rawValue = "";
    try {
      rawValue = String(window.sessionStorage.getItem(GIFT_WRAP_SESSION_CACHE_KEY) || "").trim();
    } catch {
      return null;
    }

    if (!rawValue) {
      return null;
    }

    let parsed = null;
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      return null;
    }

    const source = safeObject(parsed);
    const cachedAt = Number(source.cachedAt || 0);
    const isFresh = Number.isFinite(cachedAt) && cachedAt > 0 && Date.now() - cachedAt <= GIFT_WRAP_CACHE_TTL_MS;
    if (!isFresh && !allowStale) {
      return null;
    }

    const product = source.product && typeof source.product === "object" ? source.product : null;
    const stockEntry = safeObject(source.stockEntry);
    const variantLegacyId = normalizeLegacyId(source.variantLegacyId);
    const inStock = Boolean(source.inStock);
    const hasStockEntry = Object.keys(stockEntry).length > 0;
    if (!product && !hasStockEntry && !variantLegacyId) {
      return null;
    }

    return {
      cachedAt,
      isFresh,
      product,
      stockEntry,
      variantLegacyId,
      inStock,
    };
  }

  function hydrateGiftWrapStateFromSessionCache(options) {
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return false;
    }

    const cached = readGiftWrapSessionCache(options);
    if (!cached) {
      return false;
    }

    if (cached.product) {
      state.giftWrapProduct = cached.product;
      if (!productLookupFetchedAtByLegacyId[productLegacyId]) {
        productLookupCacheByLegacyId[productLegacyId] = cached.product;
      }
    }

    if (Object.keys(cached.stockEntry).length > 0) {
      state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
        [productLegacyId]: cached.stockEntry,
      });
      state.giftWrapStockFetchedAt = Math.max(0, cached.cachedAt);
    }

    if (cached.variantLegacyId) {
      state.giftWrapVariantLegacyId = cached.variantLegacyId;
    }

    if (cached.variantLegacyId) {
      state.giftWrapInStock = Boolean(cached.inStock);
    }

    return true;
  }

  function persistGiftWrapStateToSessionCache() {
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return;
    }

    const product = state.giftWrapProduct && typeof state.giftWrapProduct === "object" ? state.giftWrapProduct : null;
    const stockEntry = safeObject(state.giftWrapStockByProductId[productLegacyId]);
    const variantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const payload = {
      cachedAt: Date.now(),
      product,
      stockEntry,
      variantLegacyId,
      inStock: Boolean(state.giftWrapInStock && variantLegacyId),
    };

    try {
      window.sessionStorage.setItem(GIFT_WRAP_SESSION_CACHE_KEY, JSON.stringify(payload));
    } catch {
      // ignore storage failures
    }
  }

  function readPackageInsuranceSessionCache(options) {
    const normalizedOptions = options || {};
    const allowStale = Boolean(normalizedOptions.allowStale);
    let rawValue = "";
    try {
      rawValue = String(window.sessionStorage.getItem(PACKAGE_INSURANCE_SESSION_CACHE_KEY) || "").trim();
    } catch {
      return null;
    }

    if (!rawValue) {
      return null;
    }

    let parsed = null;
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      return null;
    }

    const source = safeObject(parsed);
    const cachedAt = Number(source.cachedAt || 0);
    const isFresh = Number.isFinite(cachedAt) && cachedAt > 0 && Date.now() - cachedAt <= GIFT_WRAP_CACHE_TTL_MS;
    if (!isFresh && !allowStale) {
      return null;
    }

    const product = source.product && typeof source.product === "object" ? source.product : null;
    const stockEntry = safeObject(source.stockEntry);
    const variantLegacyId = normalizeLegacyId(source.variantLegacyId);
    const inStock = Boolean(source.inStock);
    const hasStockEntry = Object.keys(stockEntry).length > 0;
    if (!product && !hasStockEntry && !variantLegacyId) {
      return null;
    }

    return {
      cachedAt,
      isFresh,
      product,
      stockEntry,
      variantLegacyId,
      inStock,
    };
  }

  function hydratePackageInsuranceStateFromSessionCache(options) {
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return false;
    }

    const cached = readPackageInsuranceSessionCache(options);
    if (!cached) {
      return false;
    }

    if (cached.product) {
      state.packageInsuranceProduct = cached.product;
      if (!productLookupFetchedAtByLegacyId[productLegacyId]) {
        productLookupCacheByLegacyId[productLegacyId] = cached.product;
      }
    }

    if (Object.keys(cached.stockEntry).length > 0) {
      state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
        [productLegacyId]: cached.stockEntry,
      });
      state.packageInsuranceStockFetchedAt = Math.max(0, cached.cachedAt);
    }

    if (cached.variantLegacyId) {
      state.packageInsuranceVariantLegacyId = cached.variantLegacyId;
      state.packageInsuranceInStock = Boolean(cached.inStock);
    }

    return true;
  }

  function persistPackageInsuranceStateToSessionCache() {
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return;
    }

    const product =
      state.packageInsuranceProduct && typeof state.packageInsuranceProduct === "object"
        ? state.packageInsuranceProduct
        : null;
    const stockEntry = safeObject(state.packageInsuranceStockByProductId[productLegacyId]);
    const variantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const payload = {
      cachedAt: Date.now(),
      product,
      stockEntry,
      variantLegacyId,
      inStock: Boolean(state.packageInsuranceInStock && variantLegacyId),
    };

    try {
      window.sessionStorage.setItem(PACKAGE_INSURANCE_SESSION_CACHE_KEY, JSON.stringify(payload));
    } catch {
      // ignore storage failures
    }
  }

  // Stock/meta/tag lookups are slow (a network round trip per page) and rarely
  // change, so they persist in sessionStorage across navigations. Combined with
  // the fire-and-forget refreshes below, a sync never blocks on them.
  function hydrateManagedLookupSessionCache() {
    try {
      const raw = String(window.sessionStorage.getItem(MANAGED_LOOKUP_SESSION_CACHE_KEY) || "").trim();
      if (!raw) {
        return;
      }

      const payload = JSON.parse(raw);
      if (!payload || typeof payload !== "object") {
        return;
      }
      if (Date.now() - Number(payload.savedAt || 0) > MANAGED_LOOKUP_SESSION_TTL_MS) {
        return;
      }

      state.giftStockByProductId = Object.assign({}, safeObject(payload.giftStock), state.giftStockByProductId);
      state.giftStockFetchedAt = Math.max(Number(state.giftStockFetchedAt || 0), Number(payload.giftStockFetchedAt || 0));
      state.lubricationStockByProductId = Object.assign(
        {},
        safeObject(payload.lubricationStock),
        state.lubricationStockByProductId,
      );
      state.lubricationStockFetchedAt = Math.max(
        Number(state.lubricationStockFetchedAt || 0),
        Number(payload.lubricationStockFetchedAt || 0),
      );
      state.giftMetaByProductId = Object.assign({}, safeObject(payload.giftMeta), state.giftMetaByProductId);
      state.feeTagsByProductId = Object.assign({}, safeObject(payload.feeTags), state.feeTagsByProductId);
      state.resolvedGiftVariantsByProductId = Object.assign(
        {},
        safeObject(payload.resolvedGiftVariants),
        state.resolvedGiftVariantsByProductId,
      );
      state.resolvedLubricationVariantsByProductId = Object.assign(
        {},
        safeObject(payload.resolvedLubricationVariants),
        state.resolvedLubricationVariantsByProductId,
      );
    } catch {
      // Session cache is best-effort only.
    }
  }

  function persistManagedLookupSessionCache() {
    try {
      window.sessionStorage.setItem(
        MANAGED_LOOKUP_SESSION_CACHE_KEY,
        JSON.stringify({
          savedAt: Date.now(),
          giftStock: state.giftStockByProductId,
          giftStockFetchedAt: state.giftStockFetchedAt,
          lubricationStock: state.lubricationStockByProductId,
          lubricationStockFetchedAt: state.lubricationStockFetchedAt,
          giftMeta: state.giftMetaByProductId,
          feeTags: state.feeTagsByProductId,
          resolvedGiftVariants: state.resolvedGiftVariantsByProductId,
          resolvedLubricationVariants: state.resolvedLubricationVariantsByProductId,
        }),
      );
    } catch {
      // Session cache is best-effort only.
    }
  }

  async function ensureGiftVariantIds(cart, config) {
    const giftTiers = Array.isArray(config && config.gift && config.gift.tiers) ? config.gift.tiers : [];
    if (!giftTiers.length) {
      return;
    }

    const giftProductLegacyIds = uniqueStrings(
      giftTiers.map((tier) => normalizeLegacyId(tier && tier.giftProductLegacyId)).filter(Boolean),
    );
    const now = Date.now();
    const shouldRefreshStock =
      now - Number(state.giftStockFetchedAt || 0) > GIFT_STOCK_CACHE_TTL_MS ||
      giftProductLegacyIds.some((productLegacyId) => !state.giftStockByProductId[productLegacyId]);

    // Fire-and-forget: the tier loop below resolves from config/cache (fail-open),
    // so the sync never blocks on the stock probe. Only changed stock results
    // trigger another reconciliation; unchanged probes leave the cart alone.
    if (giftProductLegacyIds.length && shouldRefreshStock && !state.giftStockRefreshPromise) {
      state.giftStockRefreshPromise = fetchGiftVariantStockByProductLegacyIds(giftProductLegacyIds)
        .then((fetchedStock) => {
          const stockChanged = didVariantStockChange(state.giftStockByProductId, fetchedStock);
          state.giftStockByProductId = Object.assign({}, state.giftStockByProductId, fetchedStock);
          state.giftStockFetchedAt = Date.now();
          persistManagedLookupSessionCache();
          // Only re-sync when cart logic already ran on this page; idle pages
          // pick the fresh data up on their first natural sync instead.
          if (state.lastCart && stockChanged) {
            scheduleSync("gift-stock-refresh");
          }
        })
        .catch(() => {})
        .finally(() => {
          state.giftStockRefreshPromise = null;
        });
    }

    giftTiers.forEach((tier) => {
      const productLegacyId = normalizeLegacyId(tier && tier.giftProductLegacyId);
      if (!productLegacyId) {
        tier.giftVariantLegacyId = "";
        tier.inStock = false;
        tier.hasSellableVariant = false;
        return;
      }

      const stockEntry = safeObject(state.giftStockByProductId[productLegacyId]);
      const hasStockEntry = Object.keys(stockEntry).length > 0;
      const stockLookupUnknown = stockEntry.lookupKnown === false;
      const sellableVariantLegacyIds = uniqueStrings(
        Array.isArray(stockEntry.sellableVariantLegacyIds)
          ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
          : [],
      );
      const hasSellableVariant = sellableVariantLegacyIds.length > 0;
      const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

      const directVariantId = normalizeLegacyId(tier.giftVariantLegacyId);
      const fromCache = normalizeLegacyId(state.resolvedGiftVariantsByProductId[productLegacyId]);
      const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
      const staticFallbackVariantId = normalizeLegacyId(FALLBACK_GIFT_VARIANT_BY_PRODUCT_ID[productLegacyId]);
      const fallbackVariants = [directVariantId, fromCache, fromCart, staticFallbackVariantId, preferredSellableVariantId];

      let resolvedVariantId = "";
      if (!hasStockEntry || stockLookupUnknown) {
        resolvedVariantId = normalizeLegacyId(directVariantId || fromCache || fromCart || staticFallbackVariantId);
        tier.giftVariantLegacyId = resolvedVariantId;
        tier.inStock = true;
        tier.hasSellableVariant = resolvedVariantId ? true : undefined;
        if (resolvedVariantId) {
          state.resolvedGiftVariantsByProductId[productLegacyId] = resolvedVariantId;
        }
        return;
      }

      fallbackVariants.forEach((candidate) => {
        if (resolvedVariantId || !candidate) {
          return;
        }

        if (hasSellableVariant && sellableVariantLegacyIds.includes(candidate)) {
          resolvedVariantId = candidate;
        }
      });

      if (!resolvedVariantId && hasSellableVariant) {
        resolvedVariantId = sellableVariantLegacyIds[0];
      }

      if (!hasSellableVariant) {
        tier.giftVariantLegacyId = "";
        tier.inStock = false;
        tier.hasSellableVariant = false;
        delete state.resolvedGiftVariantsByProductId[productLegacyId];
        return;
      }

      tier.giftVariantLegacyId = normalizeLegacyId(resolvedVariantId);
      tier.inStock = Boolean(tier.giftVariantLegacyId);
      tier.hasSellableVariant = hasSellableVariant;

      if (tier.giftVariantLegacyId) {
        state.resolvedGiftVariantsByProductId[productLegacyId] = tier.giftVariantLegacyId;
      }
    });

    giftTiers.forEach((tier) => {
      applyGiftTierMeta(tier);
    });
    warmGiftTierMeta(giftProductLegacyIds, config);
  }

  async function ensureGiftWrapVariantId(cart) {
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      state.giftWrapVariantLegacyId = "";
      state.giftWrapInStock = false;
      state.giftWrapProduct = null;
      return;
    }

    hydrateGiftWrapStateFromSessionCache({ allowStale: true });
    let shouldRefreshStock =
      Date.now() - Number(state.giftWrapStockFetchedAt || 0) > GIFT_WRAP_CACHE_TTL_MS ||
      !Object.prototype.hasOwnProperty.call(state.giftWrapStockByProductId, productLegacyId);

    if (shouldRefreshStock && state.giftWrapWarmPromise) {
      await state.giftWrapWarmPromise;
      shouldRefreshStock =
        Date.now() - Number(state.giftWrapStockFetchedAt || 0) > GIFT_WRAP_CACHE_TTL_MS ||
        !Object.prototype.hasOwnProperty.call(state.giftWrapStockByProductId, productLegacyId);
    }

    if (shouldRefreshStock) {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (product) {
          productLookupCacheByLegacyId[productLegacyId] = product;
        }
        state.giftWrapProduct = product;
        state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
          [productLegacyId]: buildVariantStockEntry(product),
        });
        state.giftWrapStockFetchedAt = Date.now();
        persistGiftWrapStateToSessionCache();
      } catch (error) {
        debugLog("[qk-cart-rules] Gift-wrap stock lookup failed", error);
        const cachedStockEntry = safeObject(state.giftWrapStockByProductId[productLegacyId]);
        if (!Object.keys(cachedStockEntry).length) {
          state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
            [productLegacyId]: buildVariantStockEntry(null),
          });
          state.giftWrapStockFetchedAt = Date.now();
        }
      }
    }

    if (!state.giftWrapProduct && Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId)) {
      state.giftWrapProduct = productLookupCacheByLegacyId[productLegacyId] || null;
    }

    const stockEntry = safeObject(state.giftWrapStockByProductId[productLegacyId]);
    const sellableVariantLegacyIds = uniqueStrings(
      Array.isArray(stockEntry.sellableVariantLegacyIds)
        ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
        : [],
    );
    const hasSellableVariant = sellableVariantLegacyIds.length > 0;
    const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

    const fromCache = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
    const fallbackCandidates = [fromCache, fromCart, preferredSellableVariantId];

    let resolvedVariantId = "";
    fallbackCandidates.forEach((candidate) => {
      if (resolvedVariantId || !candidate) {
        return;
      }

      if (sellableVariantLegacyIds.includes(candidate)) {
        resolvedVariantId = candidate;
      }
    });

    if (!resolvedVariantId && hasSellableVariant) {
      resolvedVariantId = sellableVariantLegacyIds[0];
    }

    state.giftWrapVariantLegacyId = normalizeLegacyId(resolvedVariantId);
    state.giftWrapInStock = Boolean(hasSellableVariant && state.giftWrapVariantLegacyId);
    persistGiftWrapStateToSessionCache();
  }

  async function ensurePackageInsuranceVariantId(cart) {
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      state.packageInsuranceVariantLegacyId = "";
      state.packageInsuranceInStock = false;
      state.packageInsuranceProduct = null;
      return;
    }

    hydratePackageInsuranceStateFromSessionCache({ allowStale: true });
    let shouldRefreshStock =
      Date.now() - Number(state.packageInsuranceStockFetchedAt || 0) > GIFT_WRAP_CACHE_TTL_MS ||
      !Object.prototype.hasOwnProperty.call(state.packageInsuranceStockByProductId, productLegacyId);

    if (shouldRefreshStock && state.packageInsuranceWarmPromise) {
      await state.packageInsuranceWarmPromise;
      shouldRefreshStock =
        Date.now() - Number(state.packageInsuranceStockFetchedAt || 0) > GIFT_WRAP_CACHE_TTL_MS ||
        !Object.prototype.hasOwnProperty.call(state.packageInsuranceStockByProductId, productLegacyId);
    }

    if (shouldRefreshStock) {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (product) {
          productLookupCacheByLegacyId[productLegacyId] = product;
        }
        state.packageInsuranceProduct = product;
        state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
          [productLegacyId]: buildVariantStockEntry(product),
        });
        state.packageInsuranceStockFetchedAt = Date.now();
        persistPackageInsuranceStateToSessionCache();
      } catch (error) {
        debugLog("[qk-cart-rules] Package insurance stock lookup failed", error);
        const cachedStockEntry = safeObject(state.packageInsuranceStockByProductId[productLegacyId]);
        if (!Object.keys(cachedStockEntry).length) {
          state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
            [productLegacyId]: buildVariantStockEntry(null),
          });
          state.packageInsuranceStockFetchedAt = Date.now();
        }
      }
    }

    if (
      !state.packageInsuranceProduct &&
      Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId)
    ) {
      state.packageInsuranceProduct = productLookupCacheByLegacyId[productLegacyId] || null;
    }

    const stockEntry = safeObject(state.packageInsuranceStockByProductId[productLegacyId]);
    const sellableVariantLegacyIds = uniqueStrings(
      Array.isArray(stockEntry.sellableVariantLegacyIds)
        ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
        : [],
    );
    const hasSellableVariant = sellableVariantLegacyIds.length > 0;
    const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

    const fromCache = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
    const fallbackCandidates = [fromCache, fromCart, preferredSellableVariantId];

    let resolvedVariantId = "";
    fallbackCandidates.forEach((candidate) => {
      if (resolvedVariantId || !candidate) {
        return;
      }

      if (sellableVariantLegacyIds.includes(candidate)) {
        resolvedVariantId = candidate;
      }
    });

    if (!resolvedVariantId && hasSellableVariant) {
      resolvedVariantId = sellableVariantLegacyIds[0];
    }

    state.packageInsuranceVariantLegacyId = normalizeLegacyId(resolvedVariantId);
    state.packageInsuranceInStock = Boolean(hasSellableVariant && state.packageInsuranceVariantLegacyId);
    persistPackageInsuranceStateToSessionCache();
  }

  function buildGiftWrapImmediateVariantUpdates(cart, selected) {
    const updates = {};
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const cartVariantLegacyId = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));

    if (selected) {
      if (cartVariantLegacyId && targetVariantLegacyId && cartVariantLegacyId !== targetVariantLegacyId) {
        updates[cartVariantLegacyId] = 0;
      }
      if (targetVariantLegacyId) {
        updates[targetVariantLegacyId] = 1;
      }
      return updates;
    }

    if (cartVariantLegacyId) {
      updates[cartVariantLegacyId] = 0;
    } else if (targetVariantLegacyId) {
      updates[targetVariantLegacyId] = 0;
    }

    return updates;
  }

  function warmGiftWrapProductState(options) {
    const normalizedOptions = options || {};
    const immediate = Boolean(normalizedOptions.immediate);
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return null;
    }

    hydrateGiftWrapStateFromSessionCache({ allowStale: true });
    const shouldSkip =
      Boolean(state.giftWrapProduct) &&
      Boolean(state.giftWrapVariantLegacyId) &&
      Object.prototype.hasOwnProperty.call(state.giftWrapStockByProductId, productLegacyId) &&
      Date.now() - Number(state.giftWrapStockFetchedAt || 0) <= GIFT_WRAP_CACHE_TTL_MS;
    if (shouldSkip) {
      return null;
    }

    const load = async () => {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (!product) {
          return;
        }

        productLookupCacheByLegacyId[productLegacyId] = product;
        const stockEntry = buildVariantStockEntry(product);
        state.giftWrapProduct = product;
        state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
          [productLegacyId]: stockEntry,
        });
        state.giftWrapStockFetchedAt = Date.now();

        if (!state.giftWrapVariantLegacyId) {
          state.giftWrapVariantLegacyId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);
        }
        state.giftWrapInStock = Boolean(
          stockEntry.hasSellableVariant &&
          normalizeLegacyId(state.giftWrapVariantLegacyId || stockEntry.preferredVariantLegacyId),
        );
        persistGiftWrapStateToSessionCache();
        scheduleUiRefresh("gift-wrap-prewarm");
      } catch (error) {
        debugLog("[qk-cart-rules] Gift-wrap prewarm failed", error);
      }
    };

    if (state.giftWrapWarmPromise) {
      return state.giftWrapWarmPromise;
    }

    const runLoad = () => {
      if (state.giftWrapWarmPromise) {
        return state.giftWrapWarmPromise;
      }

      state.giftWrapWarmPromise = load()
        .catch(() => {
          // load() already logs error
        })
        .finally(() => {
          state.giftWrapWarmPromise = null;
        });
      return state.giftWrapWarmPromise;
    };

    if (immediate) {
      return runLoad();
    }

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(() => {
        runLoad();
      }, { timeout: 1000 });
    } else {
      window.setTimeout(() => {
        runLoad();
      }, 80);
    }
    return null;
  }

  function warmPackageInsuranceProductState(options) {
    const normalizedOptions = options || {};
    const immediate = Boolean(normalizedOptions.immediate);
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return null;
    }

    hydratePackageInsuranceStateFromSessionCache({ allowStale: true });
    const shouldSkip =
      Boolean(state.packageInsuranceProduct) &&
      Boolean(state.packageInsuranceVariantLegacyId) &&
      Object.prototype.hasOwnProperty.call(state.packageInsuranceStockByProductId, productLegacyId) &&
      Date.now() - Number(state.packageInsuranceStockFetchedAt || 0) <= GIFT_WRAP_CACHE_TTL_MS;
    if (shouldSkip) {
      return null;
    }

    const load = async () => {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (!product) {
          return;
        }

        productLookupCacheByLegacyId[productLegacyId] = product;
        const stockEntry = buildVariantStockEntry(product);
        state.packageInsuranceProduct = product;
        state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
          [productLegacyId]: stockEntry,
        });
        state.packageInsuranceStockFetchedAt = Date.now();

        if (!state.packageInsuranceVariantLegacyId) {
          state.packageInsuranceVariantLegacyId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);
        }
        state.packageInsuranceInStock = Boolean(
          stockEntry.hasSellableVariant &&
            normalizeLegacyId(
              state.packageInsuranceVariantLegacyId || stockEntry.preferredVariantLegacyId,
            ),
        );
        persistPackageInsuranceStateToSessionCache();
        scheduleUiRefresh("package-insurance-prewarm");
      } catch (error) {
        debugLog("[qk-cart-rules] Package insurance prewarm failed", error);
      }
    };

    if (state.packageInsuranceWarmPromise) {
      return state.packageInsuranceWarmPromise;
    }

    const runLoad = () => {
      if (state.packageInsuranceWarmPromise) {
        return state.packageInsuranceWarmPromise;
      }

      state.packageInsuranceWarmPromise = load()
        .catch(() => {
          // load() already logs error
        })
        .finally(() => {
          state.packageInsuranceWarmPromise = null;
        });
      return state.packageInsuranceWarmPromise;
    };

    if (immediate) {
      return runLoad();
    }

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(() => {
        runLoad();
      }, { timeout: 1000 });
    } else {
      window.setTimeout(() => {
        runLoad();
      }, 80);
    }
    return null;
  }

  async function ensureLubricationVariantIds(cart, lubricationConfig) {
    const config = safeObject(lubricationConfig);
    const rules = collectLubricationConfigRules(config);
    if (!rules.length) {
      return;
    }

    const productLegacyIds = uniqueStrings(
      rules.map((rule) => normalizeLegacyId(rule && rule.productLegacyId)).filter(Boolean),
    );

    const now = Date.now();
    const shouldRefreshStock =
      now - Number(state.lubricationStockFetchedAt || 0) > GIFT_STOCK_CACHE_TTL_MS ||
      productLegacyIds.some((productLegacyId) => !state.lubricationStockByProductId[productLegacyId]);

    // Fire-and-forget, same rationale as the gift stock refresh above.
    if (productLegacyIds.length && shouldRefreshStock && !state.lubricationStockRefreshPromise) {
      state.lubricationStockRefreshPromise = fetchLubricationVariantStockByProductLegacyIds(productLegacyIds)
        .then((fetchedStock) => {
          const stockChanged = didVariantStockChange(state.lubricationStockByProductId, fetchedStock);
          state.lubricationStockByProductId = Object.assign({}, state.lubricationStockByProductId, fetchedStock);
          state.lubricationStockFetchedAt = Date.now();
          persistManagedLookupSessionCache();
          if (state.lastCart && stockChanged) {
            scheduleSync("lubrication-stock-refresh");
          }
        })
        .catch(() => {})
        .finally(() => {
          state.lubricationStockRefreshPromise = null;
        });
    }

    rules.forEach((rule) => {
      const productLegacyId = normalizeLegacyId(rule && rule.productLegacyId);
      if (!productLegacyId) {
        rule.variantLegacyId = "";
        rule.inStock = false;
        rule.hasSellableVariant = false;
        return;
      }

      const stockEntry = safeObject(state.lubricationStockByProductId[productLegacyId]);
      const hasStockEntry = Object.keys(stockEntry).length > 0;
      const stockLookupUnknown = stockEntry.lookupKnown === false;
      const sellableVariantLegacyIds = uniqueStrings(
        Array.isArray(stockEntry.sellableVariantLegacyIds)
          ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
          : [],
      );
      const hasSellableVariant = sellableVariantLegacyIds.length > 0;
      const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

      const directVariantId = normalizeLegacyId(rule.variantLegacyId);
      const fromCache = normalizeLegacyId(state.resolvedLubricationVariantsByProductId[productLegacyId]);
      const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
      const fallbackVariants = [directVariantId, fromCache, fromCart, preferredSellableVariantId];

      let resolvedVariantId = "";
      if (!hasStockEntry || stockLookupUnknown) {
        resolvedVariantId = normalizeLegacyId(directVariantId || fromCache || fromCart);
        rule.variantLegacyId = resolvedVariantId;
        rule.inStock = Boolean(resolvedVariantId);
        rule.hasSellableVariant = Boolean(resolvedVariantId);
        if (resolvedVariantId) {
          state.resolvedLubricationVariantsByProductId[productLegacyId] = resolvedVariantId;
        }
        return;
      }

      fallbackVariants.forEach((candidate) => {
        if (resolvedVariantId || !candidate) {
          return;
        }

        if (!hasSellableVariant || sellableVariantLegacyIds.includes(candidate)) {
          resolvedVariantId = candidate;
        }
      });

      if (!resolvedVariantId && hasSellableVariant) {
        resolvedVariantId = sellableVariantLegacyIds[0];
      }

      if (!hasSellableVariant) {
        rule.variantLegacyId = "";
        rule.inStock = false;
        rule.hasSellableVariant = false;
        delete state.resolvedLubricationVariantsByProductId[productLegacyId];
        return;
      }

      rule.variantLegacyId = normalizeLegacyId(resolvedVariantId);
      rule.inStock = Boolean(rule.variantLegacyId);
      rule.hasSellableVariant = hasSellableVariant;
      if (rule.variantLegacyId) {
        state.resolvedLubricationVariantsByProductId[productLegacyId] = rule.variantLegacyId;
      }
    });
  }

  function findVariantByProductLegacyIdInCart(cart, productLegacyId) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    for (const line of items) {
      if (normalizeLegacyId(line && line.product_id) !== productLegacyId) {
        continue;
      }

      const variantLegacyId = normalizeLegacyId(line && line.variant_id);
      if (variantLegacyId) {
        return variantLegacyId;
      }
    }

    return "";
  }

  async function fetchGiftVariantStockByProductLegacyIds(productLegacyIds) {
    const uniqueProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    if (!uniqueProductIds.length) {
      return {};
    }

    try {
      const productsById = await fetchProductsByLegacyIdsFast(uniqueProductIds);
      const resolved = {};
      let metadataChanged = false;

      uniqueProductIds.forEach((productLegacyId) => {
        const product = productsById[productLegacyId] || null;
        resolved[productLegacyId] = product ? buildVariantStockEntry(product) : buildUnknownGiftVariantStockEntry();
        const meta = buildGiftProductMeta(product);
        if (meta) {
          metadataChanged = metadataChanged || JSON.stringify(state.giftMetaByProductId[productLegacyId]) !== JSON.stringify(meta);
          state.giftMetaByProductId[productLegacyId] = meta;
        }
      });
      if (metadataChanged) {
        getConfig().gift.tiers.forEach(applyGiftTierMeta);
        scheduleUiRefresh("product-metadata-refresh");
      }

      return resolved;
    } catch (error) {
      debugLog("[qk-cart-rules] Gift stock lookup failed", error);
      return uniqueProductIds.reduce((acc, productLegacyId) => {
        acc[productLegacyId] = buildUnknownGiftVariantStockEntry();
        return acc;
      }, {});
    }
  }

  async function fetchLubricationVariantStockByProductLegacyIds(productLegacyIds) {
    return fetchGiftVariantStockByProductLegacyIds(productLegacyIds);
  }

  async function fetchProductsByLegacyIdsFast(productLegacyIds) {
    return fetchProductsByKnownHandles(productLegacyIds);
  }

  function buildUnknownGiftVariantStockEntry() {
    return {
      lookupKnown: false,
      hasSellableVariant: true,
      sellableVariantLegacyIds: [],
      preferredVariantLegacyId: "",
    };
  }

  async function ensureGiftTierMeta(productLegacyIds) {
    const uniqueProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    const missingProductIds = uniqueProductIds.filter(
      (productLegacyId) => !state.giftMetaByProductId[productLegacyId],
    );
    if (!missingProductIds.length) {
      return;
    }

    try {
      const productsById = await fetchProductsByLegacyIdsFast(missingProductIds);
      let storedAnyMeta = false;
      missingProductIds.forEach((productLegacyId) => {
        const meta = buildGiftProductMeta(productsById[productLegacyId]);
        if (meta) {
          state.giftMetaByProductId[productLegacyId] = meta;
          storedAnyMeta = true;
        }
      });
      if (storedAnyMeta) {
        persistManagedLookupSessionCache();
      }
    } catch (error) {
      debugLog("[qk-cart-rules] gift meta lookup failed", error);
    }
  }

  function warmGiftTierMeta(productLegacyIds, config) {
    const uniqueProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    const missingProductIds = uniqueProductIds.filter(
      (productLegacyId) => !state.giftMetaByProductId[productLegacyId],
    );
    if (!missingProductIds.length || state.giftMetaWarmPromise) {
      return;
    }

    const run = async () => {
      await ensureGiftTierMeta(missingProductIds);
      const activeConfig = config && config.gift ? config : state.config;
      const giftTiers = Array.isArray(activeConfig && activeConfig.gift && activeConfig.gift.tiers)
        ? activeConfig.gift.tiers
        : [];
      giftTiers.forEach((tier) => {
        applyGiftTierMeta(tier);
      });
      preloadGiftTierImages(giftTiers);
      scheduleUiRefresh("gift-meta-warm");
    };

    const start = () => {
      if (state.giftMetaWarmPromise) {
        return;
      }

      state.giftMetaWarmPromise = run()
        .catch((error) => {
          debugLog("[qk-cart-rules] gift meta warm failed", error);
        })
        .finally(() => {
          state.giftMetaWarmPromise = null;
        });
    };

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(start, { timeout: 600 });
      return;
    }

    window.setTimeout(start, 180);
  }

  function preloadGiftTierImages(giftTiers) {
    (Array.isArray(giftTiers) ? giftTiers : []).forEach((tier) => {
      const imageUrl = String(tier && tier.giftImageUrl ? tier.giftImageUrl : "").trim();
      if (!imageUrl || typeof window.Image !== "function") {
        return;
      }

      if (state.giftImagePreloadCache[imageUrl]) {
        return;
      }

      const image = new Image();
      image.decoding = "async";
      image.src = imageUrl;
      state.giftImagePreloadCache[imageUrl] = image;
    });
  }

  function buildGiftProductMeta(product) {
    if (!product || typeof product !== "object") {
      return null;
    }

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const images = Array.isArray(product.images) ? product.images : [];

    const imageSrcByImageId = {};
    const imageUrlByVariantId = {};
    images.forEach((image) => {
      if (!image || typeof image !== "object") {
        return;
      }
      const src = String(image.src || "").trim();
      if (!src) {
        return;
      }
      const imageId = normalizeLegacyId(image.id);
      if (imageId) {
        imageSrcByImageId[imageId] = src;
      }
      (Array.isArray(image.variant_ids) ? image.variant_ids : []).forEach((variantId) => {
        const variantLegacyId = normalizeLegacyId(variantId);
        if (variantLegacyId && !imageUrlByVariantId[variantLegacyId]) {
          imageUrlByVariantId[variantLegacyId] = src;
        }
      });
    });

    const priceCentsByVariantId = {};
    variants.forEach((variant) => {
      const variantLegacyId = normalizeLegacyId(variant && variant.id);
      if (!variantLegacyId) {
        return;
      }
      priceCentsByVariantId[variantLegacyId] = parsePriceToCents(variant.price);

      if (!imageUrlByVariantId[variantLegacyId]) {
        const featuredImage = variant.featured_image;
        const featuredSrc = String((featuredImage && featuredImage.src) || "").trim();
        const byImageId = imageSrcByImageId[normalizeLegacyId(variant.image_id)] || "";
        if (featuredSrc || byImageId) {
          imageUrlByVariantId[variantLegacyId] = featuredSrc || byImageId;
        }
      }
    });

    const firstImage = images.length ? images[0] : null;
    const firstImageSrc = typeof firstImage === "string" ? firstImage : (firstImage && firstImage.src) || "";
    const imageUrl = String((product.image && product.image.src) || firstImageSrc || "").trim();

    return {
      title: String(product.title || "").trim(),
      imageUrl,
      imageUrlByVariantId,
      priceCentsByVariantId,
      defaultPriceCents: variants.length ? parsePriceToCents(variants[0].price) : 0,
    };
  }

  function resizeShopifyImageUrl(url, width) {
    const raw = String(url || "").trim();
    if (!/^(https?:)?\/\//.test(raw) || !/\bcdn\.shopify\.com\b|\/cdn\/shop\//.test(raw)) {
      return raw;
    }

    try {
      const parsed = new URL(raw.startsWith("//") ? `https:${raw}` : raw);
      parsed.searchParams.set("width", String(Math.max(1, parseInteger(width) || 120)));
      return parsed.toString();
    } catch {
      return raw;
    }
  }

  function parsePriceToCents(price) {
    const parsed = Number.parseFloat(String(price == null ? "" : price).replace(",", "."));
    if (!Number.isFinite(parsed) || parsed < 0) {
      return 0;
    }
    return Math.round(parsed * 100);
  }

  function applyGiftTierMeta(tier) {
    const productLegacyId = normalizeLegacyId(tier && tier.giftProductLegacyId);
    if (!productLegacyId) {
      return;
    }

    const meta = state.giftMetaByProductId[productLegacyId];
    if (!meta) {
      return;
    }

    if (meta.title) {
      tier.giftTitle = meta.title;
    }
    const variantLegacyId = normalizeLegacyId(tier.giftVariantLegacyId);
    const variantImageUrl = variantLegacyId ? (meta.imageUrlByVariantId || {})[variantLegacyId] : "";
    tier.giftImageUrl = resizeShopifyImageUrl(String(variantImageUrl || meta.imageUrl || ""), 120);
    const variantPriceCents = variantLegacyId ? meta.priceCentsByVariantId[variantLegacyId] : undefined;
    tier.giftPriceCents = Number.isFinite(variantPriceCents) ? variantPriceCents : meta.defaultPriceCents;
  }

  function buildVariantStockEntry(product) {
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (!variants.length) {
      return {
        hasSellableVariant: false,
        sellableVariantLegacyIds: [],
        preferredVariantLegacyId: "",
      };
    }

    const sellableVariants = variants.filter((variant) => variant && variant.available !== false);
    const sellableVariantLegacyIds = sellableVariants
      .map((variant) => normalizeLegacyId(variant && variant.id))
      .filter(Boolean);
    const preferredVariantLegacyId = sellableVariantLegacyIds[0] || "";

    return {
      hasSellableVariant: Boolean(preferredVariantLegacyId),
      sellableVariantLegacyIds,
      preferredVariantLegacyId,
    };
  }

  async function fetchProductsByLegacyIds(productLegacyIds) {
    const requestedIds = uniqueStrings((Array.isArray(productLegacyIds) ? productLegacyIds : [])
      .map(normalizeLegacyId).filter(Boolean));
    const resolved = await fetchProductsByKnownHandles(requestedIds);
    // Legacy configurations may only contain IDs. Keep their existing recovery
    // path, but never scan the catalog after a known handle's failed request.
    const unknownIds = requestedIds.filter((id) => !resolved[id] && !productHandleByLegacyId[id]);
    if (unknownIds.length) {
      const legacyProducts = await fetchProductsByLegacyIdsViaCatalogScan(unknownIds);
      Object.entries(legacyProducts).forEach(([id, product]) => {
        productLookupCacheByLegacyId[id] = product;
        productLookupFetchedAtByLegacyId[id] = Date.now();
        if (product.handle) productHandleByLegacyId[id] = String(product.handle);
      });
      Object.assign(resolved, legacyProducts);
    }
    return resolved;
  }

  function normalizeAjaxLookupProduct(product) {
    if (!product || !normalizeLegacyId(product.id) || !product.handle || !Array.isArray(product.variants)) {
      return null;
    }
    // Existing cart presentation consumes /products.json decimal prices;
    // Liquid and the Ajax /products/{handle}.js API return integer cents.
    return Object.assign({}, product, {
      variants: product.variants.map((variant) => Object.assign({}, variant, {
        price: (Math.max(0, Number(variant.price) || 0) / 100).toFixed(2),
      })),
    });
  }

  function hydrateProductLookupSeeds() {
    if (productLookupSeedsHydrated) return;
    productLookupSeedsHydrated = true;
    const seeds = parseJsonScript("qk-cart-product-lookups", "Datele initiale ale produselor din cos sunt invalide.");
    (Array.isArray(seeds) ? seeds : []).forEach((seed) => {
      const product = normalizeAjaxLookupProduct(seed);
      if (!product) return;
      const id = normalizeLegacyId(product.id);
      productHandleByLegacyId[id] = String(product.handle);
      productLookupCacheByLegacyId[id] = product;
      productLookupFetchedAtByLegacyId[id] = Date.now();
    });
    for (const [scope, ids] of [
      ["gift", getConfig().gift.tiers.map((tier) => tier.giftProductLegacyId)],
      ["lubrication", collectLubricationConfigRules(getLubricationConfig()).map((rule) => rule.productLegacyId)],
    ]) {
      const productIds = uniqueStrings(ids.map(normalizeLegacyId).filter(Boolean));
      productIds.forEach((id) => {
        const product = productLookupCacheByLegacyId[id];
        if (!product || !productLookupFetchedAtByLegacyId[id]) return;
        state[`${scope}StockByProductId`][id] = buildVariantStockEntry(product);
        const meta = buildGiftProductMeta(product);
        if (meta) state.giftMetaByProductId[id] = meta;
      });
      if (productIds.length && productIds.every((id) => productLookupFetchedAtByLegacyId[id])) {
        state[`${scope}StockFetchedAt`] = Date.now();
      }
    }
  }

  function didVariantStockChange(previous, next) {
    const signature = (entry) => {
      const stock = safeObject(entry);
      return JSON.stringify([
        stock.lookupKnown !== false,
        Boolean(stock.hasSellableVariant),
        normalizeLegacyId(stock.preferredVariantLegacyId),
        uniqueStrings((Array.isArray(stock.sellableVariantLegacyIds) ? stock.sellableVariantLegacyIds : [])
          .map(normalizeLegacyId).filter(Boolean)).sort(),
      ]);
    };
    return Object.keys(next).some((id) => !previous[id] || signature(previous[id]) !== signature(next[id]));
  }

  async function fetchProductsByKnownHandles(productLegacyIds) {
    hydrateProductLookupSeeds();
    const ids = uniqueStrings((Array.isArray(productLegacyIds) ? productLegacyIds : [])
      .map(normalizeLegacyId).filter(Boolean));
    const resolved = {};
    await Promise.all(ids.map(async (id) => {
      const cached = productLookupCacheByLegacyId[id];
      if (cached && Date.now() - Number(productLookupFetchedAtByLegacyId[id] || 0) <= GIFT_STOCK_CACHE_TTL_MS) {
        resolved[id] = cached;
        return;
      }
      // Session-cached legacy products can supply their verified handle too.
      const handle = productHandleByLegacyId[id] || (cached && cached.handle);
      if (!handle) return;
      productHandleByLegacyId[id] = String(handle);
      const missAt = Number(state.fastProductLookupMissByLegacyId[id] || 0);
      if (missAt && Date.now() - missAt <= GIFT_STOCK_CACHE_TTL_MS) return;
      if (!fastProductFetchInFlightByLegacyId[id]) {
        fastProductFetchInFlightByLegacyId[id] = (async () => {
          try {
            const response = await fetch(`${getRootPath()}products/${encodeURIComponent(handle)}.js`, {
              credentials: "same-origin",
            });
            if (!response.ok) return null;
            const product = normalizeAjaxLookupProduct(await response.json());
            if (!product || normalizeLegacyId(product.id) !== id) return null;
            productLookupCacheByLegacyId[id] = product;
            productLookupFetchedAtByLegacyId[id] = Date.now();
            delete state.fastProductLookupMissByLegacyId[id];
            return product;
          } catch {
            return null;
          }
        })().then((product) => {
          if (!product) state.fastProductLookupMissByLegacyId[id] = Date.now();
          return product;
        }).finally(() => { delete fastProductFetchInFlightByLegacyId[id]; });
      }
      const product = await fastProductFetchInFlightByLegacyId[id];
      if (product) resolved[id] = product;
    }));
    return resolved;
  }

  async function fetchProductsByLegacyIdsViaCatalogScan(productLegacyIds) {
    const targetProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    if (!targetProductIds.length) {
      return {};
    }

    targetProductIds.forEach((productLegacyId) => {
      if (productCatalogByLegacyId[productLegacyId] && !productLookupCacheByLegacyId[productLegacyId]) {
        productLookupCacheByLegacyId[productLegacyId] = productCatalogByLegacyId[productLegacyId];
      }
    });

    const pendingTargets = targetProductIds.filter((productLegacyId) => !productCatalogByLegacyId[productLegacyId]);
    if (pendingTargets.length && !productCatalogExhausted) {
      await scanCatalogPagesForProducts(new Set(pendingTargets));
    }

    const resolvedById = {};
    targetProductIds.forEach((productLegacyId) => {
      if (productCatalogByLegacyId[productLegacyId]) {
        resolvedById[productLegacyId] = productCatalogByLegacyId[productLegacyId];
      }
    });

    return resolvedById;
  }

  async function scanCatalogPagesForProducts(targetProductIds) {
    const targets = targetProductIds instanceof Set ? targetProductIds : new Set();
    if (!targets.size || productCatalogExhausted) {
      return;
    }

    if (productCatalogScanPromise) {
      await productCatalogScanPromise;
      if (!productCatalogExhausted && hasMissingCatalogTargets(targets)) {
        await scanCatalogPagesForProducts(targets);
      }
      return;
    }

    productCatalogScanPromise = (async () => {
      while (!productCatalogExhausted && hasMissingCatalogTargets(targets)) {
        if (productCatalogNextPage > PRODUCT_LOOKUP_MAX_PAGES) {
          productCatalogExhausted = true;
          break;
        }

        const endpoint = `${getRootPath()}products.json?limit=${PRODUCT_LOOKUP_PAGE_LIMIT}&page=${productCatalogNextPage}`;
        let payload = null;

        try {
          const response = await fetch(endpoint, {
            credentials: "same-origin",
          });
          if (!response.ok) {
            productCatalogExhausted = true;
            break;
          }
          payload = await response.json();
        } catch {
          productCatalogExhausted = true;
          break;
        }

        const products = Array.isArray(payload && payload.products) ? payload.products : [];
        if (!products.length) {
          productCatalogExhausted = true;
          break;
        }

        products.forEach((product) => {
          const productLegacyId = normalizeLegacyId(product && product.id);
          if (productLegacyId) {
            productCatalogByLegacyId[productLegacyId] = product;
          }
        });

        if (products.length < PRODUCT_LOOKUP_PAGE_LIMIT) {
          productCatalogExhausted = true;
        }

        productCatalogNextPage += 1;
      }
    })()
      .finally(() => {
        productCatalogScanPromise = null;
      });

    await productCatalogScanPromise;
  }

  function hasMissingCatalogTargets(targetProductIds) {
    const targets = targetProductIds instanceof Set ? targetProductIds : new Set();
    for (const productLegacyId of targets) {
      if (!productCatalogByLegacyId[productLegacyId]) {
        return true;
      }
    }
    return false;
  }

  function createCartOperationContext() {
    return { controller: new AbortController(), error: null, verifiedRecoveryVersion: -1 };
  }

  function assertCartOperationActive(context) {
    if (context && context.error) throw context.error;
  }

  function cancelCartOperation(context, error) {
    if (!context || context.error) return;
    context.error = error || new Error("Cart operation cancelled");
    context.controller.abort();
  }

  async function runCartOperation(context, work, timeoutMs, onTimeout) {
    assertCartOperationActive(context);
    let timer;
    let onAbort;
    const cancelled = new Promise((_, reject) => {
      onAbort = () => reject(context.error || new Error("Cart operation cancelled"));
      context.controller.signal.addEventListener("abort", onAbort, { once: true });
      timer = window.setTimeout(() => {
        cancelCartOperation(context, new Error(`Cart operation timed out (${timeoutMs}ms)`));
        if (onTimeout) onTimeout();
      }, timeoutMs);
    });
    try {
      const result = await Promise.race([Promise.resolve().then(() => {
        assertCartOperationActive(context);
        return work();
      }), cancelled]);
      assertCartOperationActive(context);
      return result;
    } finally {
      clearTimeout(timer);
      context.controller.signal.removeEventListener("abort", onAbort);
    }
  }

  function markCartRecoveryRequired(error) {
    state.cartRecoveryRequired = true;
    state.cartRecoveryVersion += 1;
    state.rerun = false;
    state.queuedSeedCart = null;
    if (state.debounceTimer) {
      clearTimeout(state.debounceTimer);
      state.debounceTimer = null;
    }
    document.querySelectorAll("[data-qk-standard-checkout-form]").forEach((form) => {
      showCheckoutSyncError(form, "Nu am putut confirma modificarile din cos. Verifica conexiunea si incearca din nou.", true);
    });
    debugLog("[qk-cart-rules] cart requires authoritative recovery", error);
  }

  async function fetchCartResponse(url, init, options) {
    const settings = options || {};
    const context = settings.context || createCartOperationContext();
    const fetchImpl = settings.untracked && typeof window.QKUntrackedFetch === "function"
      ? window.QKUntrackedFetch
      : fetch;
    return runCartOperation(context, async () => {
      assertCartOperationActive(context);
      const response = await fetchImpl(url, Object.assign({}, init, { signal: context.controller.signal }));
      assertCartOperationActive(context);
      if (!response.ok) {
        const body = await response.text();
        assertCartOperationActive(context);
        const error = new Error(`Cart request failed (${response.status}): ${body.slice(0, 250)}`);
        error.status = response.status;
        throw error;
      }
      const payload = settings.text ? await response.text() : await response.json();
      assertCartOperationActive(context);
      return payload;
    }, CART_REQUEST_TIMEOUT_MS);
  }

  async function fetchSectionsById(sectionIds, context) {
    const root = getRootPath();
    // Shopify accepts at most five sections per request. Keep the existing
    // locale/root context and only use single-section recovery for missing HTML.
    const batches = [];
    for (let index = 0; index < sectionIds.length; index += 5) {
      batches.push(sectionIds.slice(index, index + 5));
    }
    const responses = await Promise.all(batches.map(async (batch) => {
      const sections = await fetchCartResponse(`${root}?sections=${batch.map(encodeURIComponent).join(",")}`, {
        credentials: "same-origin",
      }, { context });
      if (!sections || typeof sections !== "object" || Array.isArray(sections)) {
        throw new Error("Invalid cart sections response");
      }
      return Promise.all(batch.map(async (sectionId) => {
        if (typeof sections[sectionId] === "string") {
          return [sectionId, sections[sectionId]];
        }
        // Section Rendering can return HTTP 200 with a null section. Preserve
        // the old endpoint as a fallback without repeating successful sections.
        const html = await fetchCartResponse(`${root}?section_id=${encodeURIComponent(sectionId)}`, {
          credentials: "same-origin",
        }, { context, text: true });
        return [sectionId, html];
      }));
    }));
    return responses.flat().reduce((acc, entry) => {
      acc[entry[0]] = entry[1];
      return acc;
    }, {});
  }

  async function fetchCartJson(options) {
    const settings = options || {};
    const recoveryVersionAtRead = state.cartRecoveryVersion;
    const fetchOptions = { credentials: "same-origin" };
    if (settings.fresh === true) fetchOptions.cache = "no-store";
    const cart = await fetchCartResponse(`${getRootPath()}cart.js`, fetchOptions, settings);
    assertCartOperationActive(settings.context);
    if (!isCompleteCartPayload(cart)) throw new Error("Invalid authoritative cart response");
    if (settings.fresh && settings.context) {
      settings.context.verifiedRecoveryVersion = recoveryVersionAtRead;
    }
    return cart;
  }

  async function requestCartJson(endpoint, payload, context) {
    assertCartOperationActive(context);
    if (state.cartRecoveryRequired && (!context || context.verifiedRecoveryVersion !== state.cartRecoveryVersion)) {
      throw new Error("Cart must be revalidated before another mutation");
    }
    const fetchInit = {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
    };
    fetchInit["__qkFallbackFetch"] = true;
    // Every add issued here is a store-managed line (gift, fee, lubrication,
    // add-on). Shopify reports each /cart/add line to the ad pixels as an
    // add_to_cart, so these go through the pre-analytics fetch instead.
    const untracked = endpoint === "cart/add.js";
    try {
      return await fetchCartResponse(`${getRootPath()}${endpoint}`, fetchInit, { context, untracked });
    } catch (error) {
      markCartRecoveryRequired(error);
      throw error;
    }
  }

  function getConfig() {
    if (state.config) {
      return state.config;
    }

    const rawConfig = parseJsonScript("qk-cart-rules", "Metafield-ul qwertykey.cart_rules nu este JSON valid.");
    const rawMetaobjectConfig = parseJsonScript(
      "qk-cart-gift-tiers",
      "Metaobiectele qk_cart_gift_tier nu sunt JSON valid.",
    );
    state.config = normalizeConfig(mergeMetaobjectGiftTiers(rawConfig, rawMetaobjectConfig));
    return state.config;
  }

  function getLubricationConfig() {
    if (state.lubricationConfig) {
      return state.lubricationConfig;
    }

    const rawConfig = parseJsonScript("qk-lubrication-config", "Config-ul qk-lubrication-config nu este JSON valid.");
    state.lubricationConfig = normalizeLubricationConfig(rawConfig);
    state.lubricationManagedProductIds = buildLubricationManagedProductLookup(state.lubricationConfig);
    return state.lubricationConfig;
  }

  function buildLubricationManagedProductLookup(config) {
    const lookup = {};
    const rules = collectLubricationConfigRules(config);
    rules.forEach((rule) => {
      const productLegacyId = normalizeLegacyId(rule && rule.productLegacyId);
      if (!productLegacyId) {
        return;
      }
      lookup[productLegacyId] = true;
    });
    return lookup;
  }

  function parseJsonScript(scriptId, invalidMessage) {
    const element = document.getElementById(scriptId);
    if (!(element instanceof HTMLScriptElement)) {
      return null;
    }

    const raw = String(element.textContent || "").trim();
    if (!raw || raw === "null") {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      reportError(error, invalidMessage || `Config-ul ${scriptId} nu este JSON valid.`);
      return null;
    }
  }

  function mergeMetaobjectGiftTiers(rawConfig, rawMetaobjectConfig) {
    const config = safeObject(rawConfig);
    const metaobjectConfig = safeObject(rawMetaobjectConfig);
    const rawTiers = Array.isArray(metaobjectConfig.tiers) ? metaobjectConfig.tiers : [];

    if (!rawTiers.length) {
      return config;
    }

    const normalizedTiers = [];
    const seenIndexes = {};
    for (const rawTier of rawTiers) {
      const sourceTier = safeObject(rawTier);
      const index = parseInteger(sourceTier.index);
      if (index < 1 || index > 3 || seenIndexes[index]) {
        reportError(
          new Error("Metaobiectele cadou trebuie sa aiba exact un tier pentru fiecare index 1, 2 si 3."),
          "Config-ul metaobject pentru cadouri este invalid. Folosesc qwertykey.cart_rules.",
        );
        return config;
      }

      seenIndexes[index] = true;
      normalizedTiers.push(
        Object.assign({}, sourceTier, {
          index,
          thresholdRon: Number(sourceTier.thresholdAmount),
          metaobjectManaged: true,
        }),
      );
    }

    if (normalizedTiers.length !== 3 || !seenIndexes[1] || !seenIndexes[2] || !seenIndexes[3]) {
      reportError(
        new Error("Lipseste cel putin un metaobiect pentru tier 1, 2 sau 3."),
        "Config-ul metaobject pentru cadouri este incomplet. Folosesc qwertykey.cart_rules.",
      );
      return config;
    }

    normalizedTiers.sort((left, right) => left.index - right.index);
    const validationCandidates = normalizedTiers.map((sourceTier) => {
      const thresholdRon = Number(sourceTier.thresholdRon);
      return {
        index: sourceTier.index,
        enabled: readBoolean(sourceTier.enabled, false),
        thresholdCents: Number.isFinite(thresholdRon) ? Math.round(thresholdRon * 100) : 0,
        giftProductLegacyId: normalizeLegacyId(sourceTier.giftProductLegacyId) || "0",
        inStock: readBoolean(sourceTier.inStock, false),
        hasSellableVariant: readBoolean(sourceTier.hasSellableVariant, false),
        metaobjectManaged: true,
      };
    });
    const validationError = validateGiftTierConfig(validationCandidates);
    if (validationError) {
      reportError(
        new Error(validationError),
        "Config-ul metaobject pentru cadouri este invalid. Folosesc qwertykey.cart_rules.",
      );
      return config;
    }

    return Object.assign({}, config, {
      gift: Object.assign({}, safeObject(config.gift), {
        tiers: normalizedTiers,
      }),
    });
  }

  function normalizeConfig(rawConfig) {
    const source = safeObject(rawConfig);
    const defaults = DEFAULT_RULES;

    const sourceGift = safeObject(source.gift);
    const sourceFee = safeObject(source.fees);
    const sourceUi = safeObject(source.ui);
    const sourceFlags = safeObject(source.flags);

    const runtimeFlags = safeObject(window.qkCartRulesFlags);

    const sourceGiftTiers = normalizeGiftTierSources(sourceGift.tiers);
    const candidateGiftTiers = [1, 2, 3].map((index) => {
      const fallbackTier = defaults.gift.tiers[index - 1];
      const sourceTier = sourceGiftTiers[index - 1];
      const isMetaobjectManaged = readBoolean(sourceTier.metaobjectManaged, false);

      const thresholdRon = readPositiveNumber(sourceTier.thresholdRon, fallbackTier.thresholdRon);
      return {
        index,
        enabled: readBoolean(sourceTier.enabled, fallbackTier.enabled),
        thresholdRon,
        thresholdCents: Math.round(thresholdRon * 100),
        giftTitle: String(sourceTier.giftTitle || sourceTier.title || "").trim(),
        giftImageUrl: String(sourceTier.giftImageUrl || "").trim(),
        giftPriceCents: Math.max(0, parseInteger(sourceTier.giftPriceCents)),
        giftProductLegacyId: isMetaobjectManaged
          ? normalizeLegacyId(sourceTier.giftProductLegacyId) || "0"
          : readGiftTierProductLegacyId(sourceTier, fallbackTier),
        giftVariantLegacyId: readGiftTierVariantLegacyId(sourceTier),
        inStock: isMetaobjectManaged ? readBoolean(sourceTier.inStock, false) : true,
        hasSellableVariant: isMetaobjectManaged
          ? readBoolean(sourceTier.hasSellableVariant, false)
          : true,
        metaobjectManaged: isMetaobjectManaged,
      };
    });

    let giftTiers = candidateGiftTiers;
    let giftMode = String(sourceGift.mode || defaults.gift.mode || "cumulative") === "cumulative" ? "cumulative" : "replace";

    const validationError = validateGiftTierConfig(candidateGiftTiers);
    if (validationError) {
      reportError(new Error(validationError), "Config-ul qwertykey.cart_rules este invalid. Folosesc fallback sigur.");

      const safeThreshold1Cents = Math.max(100, parseInteger(candidateGiftTiers[0].thresholdCents));
      const safeThreshold2Cents = Math.max(safeThreshold1Cents + 100, parseInteger(candidateGiftTiers[1].thresholdCents));
      const safeThreshold3Cents = Math.max(safeThreshold2Cents + 100, parseInteger(candidateGiftTiers[2].thresholdCents));

      giftTiers = [
        {
          index: 1,
          enabled: true,
          thresholdRon: safeThreshold1Cents / 100,
          thresholdCents: safeThreshold1Cents,
          giftTitle: "",
          giftProductLegacyId:
            normalizeLegacyId(candidateGiftTiers[0].giftProductLegacyId) || defaults.gift.tiers[0].giftProductLegacyId,
          giftVariantLegacyId: normalizeLegacyId(candidateGiftTiers[0].giftVariantLegacyId) || "",
          inStock: true,
          hasSellableVariant: true,
        },
        {
          index: 2,
          enabled: true,
          thresholdRon: safeThreshold2Cents / 100,
          thresholdCents: safeThreshold2Cents,
          giftTitle: "",
          giftProductLegacyId:
            normalizeLegacyId(candidateGiftTiers[1].giftProductLegacyId) || defaults.gift.tiers[1].giftProductLegacyId,
          giftVariantLegacyId: normalizeLegacyId(candidateGiftTiers[1].giftVariantLegacyId) || "",
          inStock: true,
          hasSellableVariant: true,
        },
        {
          index: 3,
          enabled: false,
          thresholdRon: safeThreshold3Cents / 100,
          thresholdCents: safeThreshold3Cents,
          giftTitle: "",
          giftProductLegacyId:
            normalizeLegacyId(candidateGiftTiers[2].giftProductLegacyId) || defaults.gift.tiers[2].giftProductLegacyId,
          giftVariantLegacyId: normalizeLegacyId(candidateGiftTiers[2].giftVariantLegacyId) || "",
          inStock: true,
          hasSellableVariant: true,
        },
      ];
      giftMode = "replace";
    }

    const feeRuleByKey = {};
    defaults.fees.rules.forEach((rule) => {
      feeRuleByKey[rule.key] = Object.assign({}, rule);
    });

    if (Array.isArray(sourceFee.rules)) {
      sourceFee.rules.forEach((rawRule) => {
        const sourceRule = safeObject(rawRule);
        const key = String(sourceRule.key || "").trim();
        if (!KNOWN_FEE_RULE_KEYS.includes(key)) {
          return;
        }

        const fallbackRule = feeRuleByKey[key] || {};
        feeRuleByKey[key] = {
          key,
          feeProductLegacyId: normalizeLegacyId(sourceRule.feeProductLegacyId) || fallbackRule.feeProductLegacyId || "",
          feeVariantLegacyId: normalizeLegacyId(sourceRule.feeVariantLegacyId) || fallbackRule.feeVariantLegacyId || "",
          includeTags: normalizeTagList(Array.isArray(sourceRule.includeTags) ? sourceRule.includeTags : fallbackRule.includeTags || []),
          excludeTags: normalizeTagList(Array.isArray(sourceRule.excludeTags) ? sourceRule.excludeTags : fallbackRule.excludeTags || []),
          suppresses: (Array.isArray(sourceRule.suppresses) ? sourceRule.suppresses : fallbackRule.suppresses || [])
            .map((entry) => String(entry || "").trim())
            .filter((entry) => KNOWN_FEE_RULE_KEYS.includes(entry)),
        };
      });
    }

    const feesRules = KNOWN_FEE_RULE_KEYS.map((ruleKey) => feeRuleByKey[ruleKey]).filter(Boolean);

    const mergedFlags = {
      managedRulesEnabled: readBoolean(
        runtimeFlags.managedRulesEnabled,
        readBoolean(sourceFlags.managedRulesEnabled, defaults.flags.managedRulesEnabled),
      ),
      shadowMode: readBoolean(runtimeFlags.shadowMode, readBoolean(sourceFlags.shadowMode, defaults.flags.shadowMode)),
      log: readBoolean(runtimeFlags.log, readBoolean(sourceFlags.log, defaults.flags.log)),
      killSwitch: readBoolean(runtimeFlags.killSwitch, readBoolean(sourceFlags.killSwitch, defaults.flags.killSwitch)),
    };

    return {
      version: readPositiveNumber(source.version, defaults.version),
      currency: String(source.currency || defaults.currency || "RON"),
      gift: {
        mode: giftMode,
        tiers: giftTiers,
      },
      fees: {
        rules: feesRules,
      },
      ui: {
        progressTitle: String(sourceUi.progressTitle || defaults.ui.progressTitle),
        unlockedLabel: String(sourceUi.unlockedLabel || defaults.ui.unlockedLabel),
        eligibleLabel: String(sourceUi.eligibleLabel || defaults.ui.eligibleLabel),
        lockedLabel: String(sourceUi.lockedLabel || defaults.ui.lockedLabel),
      },
      flags: mergedFlags,
    };
  }

  function normalizeLubricationConfig(rawConfig) {
    const source = safeObject(rawConfig);
    const defaults = DEFAULT_LUBRICATION_CONFIG;
    const keyboard = safeObject(source.keyboard);
    const switchConfig = safeObject(source.switch);
    const ui = safeObject(source.ui);

    return {
      version: readPositiveNumber(source.version, defaults.version),
      enabled: readBoolean(source.enabled, defaults.enabled),
      keyboard: {
        enabled: readBoolean(keyboard.enabled, defaults.keyboard.enabled),
        rules: normalizeLubricationRules(keyboard.rules),
      },
      switch: {
        enabled: readBoolean(switchConfig.enabled, defaults.switch.enabled),
        rules: normalizeLubricationRules(switchConfig.rules),
      },
      ui: {
        label_ro: String(ui.label_ro || defaults.ui.label_ro),
        attachment_ro: String(ui.attachment_ro || defaults.ui.attachment_ro),
      },
    };
  }

  function normalizeLubricationRules(rawRules) {
    const entries = Array.isArray(rawRules) ? rawRules : [];
    const byKey = {};

    entries.forEach((rawRule) => {
      const sourceRule = safeObject(rawRule);
      const key = String(sourceRule.key || "").trim();
      const productLegacyId = normalizeLegacyId(sourceRule.productLegacyId);
      if (!key || !productLegacyId) {
        return;
      }

      const configuredAliases = Array.isArray(sourceRule.aliases)
        ? sourceRule.aliases.map((alias) => normalizeLayoutAlias(alias)).filter(Boolean)
        : [];
      const fallbackAliases = [
        normalizeLayoutAlias(key),
        normalizeLayoutAlias(`${key}%`),
      ].filter(Boolean);
      const aliases = uniqueStrings(configuredAliases.concat(fallbackAliases));

      byKey[key] = {
        key,
        productLegacyId,
        variantLegacyId: normalizeLegacyId(sourceRule.variantLegacyId),
        aliases,
        inStock: true,
        hasSellableVariant: true,
      };
    });

    return Object.values(byKey);
  }

  function collectLubricationConfigRules(config) {
    const sourceConfig = safeObject(config);
    if (!sourceConfig.enabled) {
      return [];
    }

    const collected = [];
    const keyboard = safeObject(sourceConfig.keyboard);
    if (keyboard.enabled && Array.isArray(keyboard.rules)) {
      keyboard.rules.forEach((rule) => {
        if (rule && typeof rule === "object") {
          collected.push(rule);
        }
      });
    }

    const switchConfig = safeObject(sourceConfig.switch);
    if (switchConfig.enabled && Array.isArray(switchConfig.rules)) {
      switchConfig.rules.forEach((rule) => {
        if (rule && typeof rule === "object") {
          collected.push(rule);
        }
      });
    }

    return collected;
  }

  function normalizeGiftTierSources(rawTiers) {
    const tiers = Array.isArray(rawTiers) ? rawTiers : [];
    const byIndex = {};

    tiers.forEach((tier, position) => {
      const sourceTier = safeObject(tier);
      const index = parseInteger(sourceTier.index);
      if (index >= 1 && index <= 3) {
        byIndex[index] = sourceTier;
        return;
      }

      if (!byIndex[position + 1]) {
        byIndex[position + 1] = sourceTier;
      }
    });

    return [1, 2, 3].map((index) => safeObject(byIndex[index]));
  }

  function readGiftTierProductLegacyId(sourceTier, fallbackTier) {
    const tier = safeObject(sourceTier);
    const fallback = safeObject(fallbackTier);
    return (
      normalizeLegacyId(tier.giftProductLegacyId) ||
      normalizeLegacyId(tier.giftProductId) ||
      normalizeLegacyId(tier.productLegacyId) ||
      normalizeLegacyId(tier.productId) ||
      normalizeLegacyId(fallback.giftProductLegacyId)
    );
  }

  function readGiftTierVariantLegacyId(sourceTier) {
    const tier = safeObject(sourceTier);
    return (
      normalizeLegacyId(tier.giftVariantLegacyId) ||
      normalizeLegacyId(tier.giftVariantId) ||
      normalizeLegacyId(tier.variantLegacyId) ||
      normalizeLegacyId(tier.variantId)
    );
  }

  function validateGiftTierConfig(tiers) {
    const normalizedTiers = Array.isArray(tiers) ? tiers : [];
    const enabledTierIndexes = normalizedTiers
      .filter((tier) => Boolean(tier && tier.enabled))
      .map((tier) => parseInteger(tier.index));

    if (!enabledTierIndexes.length) {
      return "Cel putin un tier trebuie sa fie activ.";
    }

    if (enabledTierIndexes[0] !== 1) {
      return "Tierele active trebuie sa inceapa de la tier 1.";
    }

    for (let index = 0; index < enabledTierIndexes.length; index += 1) {
      if (enabledTierIndexes[index] !== index + 1) {
        return "Tierele active trebuie sa fie contigue (1,2,3 fara goluri).";
      }
    }

    let previousThreshold = 0;
    for (const tier of normalizedTiers) {
      if (!tier || !tier.enabled) {
        continue;
      }

      if (parseInteger(tier.thresholdCents) <= 0) {
        return `Pragul pentru tier ${parseInteger(tier.index)} trebuie sa fie pozitiv.`;
      }

      if (parseInteger(tier.thresholdCents) <= previousThreshold) {
        return "Pragurile tierelor active trebuie sa fie strict crescatoare.";
      }

      const normalizedGiftId = String(tier.giftProductLegacyId || "").trim();
      const unavailableManagedTier =
        tier.metaobjectManaged === true &&
        (tier.inStock === false || tier.hasSellableVariant === false);
      if ((!/^\d+$/.test(normalizedGiftId) || Number(normalizedGiftId) <= 0) && !unavailableManagedTier) {
        return `ID-ul produsului pentru tier ${parseInteger(tier.index)} este invalid.`;
      }

      previousThreshold = parseInteger(tier.thresholdCents);
    }

    return null;
  }

  function uniqueStrings(values) {
    return Array.from(
      new Set(
        (Array.isArray(values) ? values : [])
          .map((value) => String(value || "").trim())
          .filter(Boolean),
      ),
    );
  }

  function normalizeTagList(tags) {
    return uniqueStrings(tags).map((tag) => tag.toLowerCase());
  }

  function normalizeLayoutAlias(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "")
      .replace(/\(tkl\)/g, "tkl");
  }

  function getLineProperty(line, key) {
    const properties = safeObject(line && line.properties);
    const directValue = properties[key];
    if (directValue != null && String(directValue) !== "") {
      return String(directValue);
    }

    const normalizedKey = String(key || "").trim();
    if (!normalizedKey) {
      return "";
    }

    const aliasKey = normalizedKey.startsWith("_")
      ? normalizedKey.slice(1)
      : `_${normalizedKey}`;
    const aliasValue = properties[aliasKey];
    return aliasValue == null ? "" : String(aliasValue);
  }

  function lineHasProperties(line, expectedProperties) {
    return Object.keys(expectedProperties || {}).every(
      (key) => getLineProperty(line, key) === String(expectedProperties[key]),
    );
  }

  function lineHasPropertiesExcludingKeys(line, expectedProperties, excludedKeys) {
    const excludedLookup = {};
    (Array.isArray(excludedKeys) ? excludedKeys : []).forEach((key) => {
      const normalizedKey = String(key || "").trim();
      if (normalizedKey) {
        excludedLookup[normalizedKey] = true;
      }
    });

    return Object.keys(expectedProperties || {}).every((key) => {
      if (excludedLookup[String(key || "").trim()]) {
        return true;
      }
      return getLineProperty(line, key) === String(expectedProperties[key]);
    });
  }

  function isManagedGiftLine(line) {
    return getLineProperty(line, ATTR_GWP_MANAGED) === "1";
  }

  function isManagedGiftWrapLine(line) {
    if (getLineProperty(line, ATTR_GIFT_WRAP_MANAGED) === "1") {
      return true;
    }

    return normalizeLegacyId(line && line.product_id) === normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
  }

  function isManagedPackageInsuranceLine(line) {
    if (getLineProperty(line, ATTR_PACKAGE_INSURANCE_MANAGED) === "1") {
      return true;
    }

    return normalizeLegacyId(line && line.product_id) === normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
  }

  function isManagedFeeLine(line) {
    return getLineProperty(line, ATTR_FEE_MANAGED) === "1";
  }

  function isManagedCodFeeLine(line) {
    const isExpectedProduct =
      normalizeLegacyId(line && line.product_id) === normalizeLegacyId(COD_FEE_PRODUCT_LEGACY_ID);
    const isExpectedVariant =
      normalizeLegacyId(line && line.variant_id) === normalizeLegacyId(COD_FEE_VARIANT_LEGACY_ID);
    if (!isExpectedProduct || !isExpectedVariant) {
      return false;
    }

    const isCheckoutReassuranceLine =
      getLineProperty(line, ATTR_COD_FEE_MANAGED) === "1" &&
      getLineProperty(line, ATTR_COD_FEE_SOURCE) === "checkout_reassurance";
    const isCheckoutFallbackLine =
      getLineProperty(line, ATTR_FEE_MANAGED) === "1" &&
      getLineProperty(line, ATTR_FEE_RULE) === COD_FEE_FALLBACK_RULE_KEY;

    return isCheckoutReassuranceLine || isCheckoutFallbackLine;
  }

  function cartHasManagedCodFeeLine(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.some((line) => isManagedCodFeeLine(line));
  }

  function isManagedLubricationLine(line) {
    if (getLineProperty(line, ATTR_LUBE_MANAGED) === "1") {
      return true;
    }

    const productLegacyId = normalizeLegacyId(line && line.product_id);
    if (!productLegacyId) {
      return false;
    }

    return Boolean(safeObject(state.lubricationManagedProductIds)[productLegacyId]);
  }

  function findLineByKey(cart, lineKey) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.find((line) => String(line.key || "") === String(lineKey || "")) || null;
  }

  function findLineIndexByKey(cart, lineKey) {
    const requestedKey = String(lineKey || "").trim();
    if (!requestedKey) {
      return -1;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.findIndex((line) => String(line && line.key ? line.key : "").trim() === requestedKey);
  }

  async function requestCartLineChangeWithFallback(cart, input) {
    const payload = input && typeof input === "object" ? input : {};
    const lineKey = String(payload.lineKey || "").trim();
    const quantity = Math.max(0, parseInteger(payload.quantity));
    const properties = safeObject(payload.properties);
    const hasProperties = Object.keys(properties).length > 0;

    if (!lineKey) {
      throw new Error("Missing line key for cart change request.");
    }

    const idPayload = {
      id: lineKey,
      quantity,
    };
    if (hasProperties) {
      idPayload.properties = properties;
    }

    try {
      return await requestCartJson("cart/change.js", idPayload);
    } catch (idError) {
      const lineIndex = findLineIndexByKey(cart, lineKey);
      if (lineIndex < 0) {
        throw idError;
      }

      const linePayload = {
        line: lineIndex + 1,
        quantity,
      };
      if (hasProperties) {
        linePayload.properties = properties;
      }

      return requestCartJson("cart/change.js", linePayload);
    }
  }

  function findLineItemElementsByKey(lineKey) {
    const requested = String(lineKey || "");
    return Array.from(document.querySelectorAll("line-item[data-line-key]")).filter((element) => {
      return String(element.getAttribute("data-line-key") || "") === requested;
    });
  }

  function findQuantityInputsByLineKey(lineKey) {
    const requested = String(lineKey || "");
    return Array.from(document.querySelectorAll("input[data-line-key]")).filter((input) => {
      return String(input.getAttribute("data-line-key") || "") === requested;
    });
  }

  function findQuantityInputByLineKey(lineKey) {
    return findQuantityInputsByLineKey(lineKey)[0] || null;
  }

  function isInsideCartUI(element) {
    return Boolean(element.closest("cart-drawer, .shopify-section--main-cart, .cart, line-item"));
  }

  function resolveEventTargetElement(event) {
    if (event && event.target instanceof Element) {
      return event.target;
    }

    if (!event || typeof event.composedPath !== "function") {
      return null;
    }

    const path = event.composedPath();
    if (!Array.isArray(path)) {
      return null;
    }

    for (const node of path) {
      if (node instanceof Element) {
        return node;
      }
    }

    return null;
  }

  function getRootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function resolveKlarnaLocale() {
    const rawLang = String((document.documentElement && document.documentElement.lang) || "").trim().replace(/_/g, "-");
    const normalizedLang = rawLang.toLowerCase();
    const countryFromShopify = String(window.Shopify && window.Shopify.country ? window.Shopify.country : "")
      .trim()
      .toUpperCase();

    if (/^[a-z]{2}-[a-z]{2}$/i.test(rawLang)) {
      const [lang, country] = rawLang.split("-");
      return `${lang.toLowerCase()}-${country.toUpperCase()}`;
    }

    if (/^[a-z]{2}$/.test(normalizedLang)) {
      if (/^[A-Z]{2}$/.test(countryFromShopify)) {
        return `${normalizedLang}-${countryFromShopify}`;
      }
      if (normalizedLang === "ro") {
        return "ro-RO";
      }
      return `${normalizedLang}-${normalizedLang.toUpperCase()}`;
    }

    return "ro-RO";
  }

  function ensureKlarnaPlacementsLocale(root) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const locale = resolveKlarnaLocale();
    const placements = Array.from(scope.querySelectorAll ? scope.querySelectorAll("klarna-placement") : []);

    placements.forEach((placement) => {
      if (!(placement instanceof Element)) {
        return;
      }

      const currentLocale = String(placement.getAttribute("locale") || "").trim();
      const currentDataLocale = String(placement.getAttribute("data-locale") || "").trim();
      const hasLocale = Boolean(currentLocale && currentLocale.toLowerCase() !== "null" && currentLocale.toLowerCase() !== "undefined");
      const hasDataLocale =
        Boolean(currentDataLocale && currentDataLocale.toLowerCase() !== "null" && currentDataLocale.toLowerCase() !== "undefined");

      if (!hasLocale) {
        placement.setAttribute("locale", locale);
      }

      if (!hasDataLocale) {
        placement.setAttribute("data-locale", locale);
      }
    });
  }

  function parseInteger(value) {
    const parsed = Number.parseInt(String(value == null ? "" : value), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function readPositiveNumber(value, fallback) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return Number(fallback) || 0;
    }

    return parsed;
  }

  function readBoolean(value, fallback) {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "number") {
      return value !== 0;
    }

    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (["1", "true", "yes", "on"].includes(normalized)) {
        return true;
      }

      if (["0", "false", "no", "off"].includes(normalized)) {
        return false;
      }
    }

    return Boolean(fallback);
  }

  function normalizeLegacyId(value) {
    const normalized = String(value == null ? "" : value).trim();
    if (/^\d+$/.test(normalized)) {
      return normalized;
    }

    const gidMatch = normalized.match(/\/(\d+)\s*$/);
    return gidMatch ? gidMatch[1] : "";
  }

  function safeObject(value) {
    return value && typeof value === "object" ? value : {};
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatThresholdLabel(thresholdCents) {
    return `${Math.round(Math.max(0, Number(thresholdCents) || 0) / 100)}+ RON`;
  }

  function formatLei(cents) {
    const normalizedCents = Math.max(0, Number(cents) || 0);
    return LEI_CURRENCY_FORMATTER.format(normalizedCents / 100);
  }

  function formatCartSummaryLei(cents) {
    const normalizedCents = Math.max(0, Math.round(Number(cents) || 0));
    const hasBani = normalizedCents % 100 !== 0;
    const value = new Intl.NumberFormat("ro-RO", {
      minimumFractionDigits: hasBani ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(normalizedCents / 100);

    return `${value} Lei`;
  }

  function setCartUiText(element, value) {
    const text = String(value == null ? "" : value);
    if (element.textContent !== text) {
      element.textContent = text;
    }
  }

  function updateCartMoneyElement(element, cents, options) {
    if (!(element instanceof HTMLElement)) {
      return;
    }

    const settings = safeObject(options);
    const nextCents = Math.max(0, Math.round(Number(cents) || 0));
    const previousCents = getCartMoneyPreviousCents(element);
    const blankWhenZero = Boolean(settings.blankWhenZero);
    const shouldBlank = blankWhenZero && nextCents <= 0;

    const activeAnimation = cartMoneyAnimationStateByElement.get(element);
    if (
      activeAnimation &&
      activeAnimation.targetCents === nextCents &&
      activeAnimation.shouldBlank === shouldBlank &&
      shouldAnimateCartMoney()
    ) {
      // Keep the current timeline, but finish with the latest visibility state.
      activeAnimation.onComplete = settings.onComplete;
      return;
    }

    cancelCartMoneyAnimation(element);

    if (!Number.isFinite(previousCents) || previousCents === nextCents || !shouldAnimateCartMoney()) {
      setCartUiText(element, shouldBlank ? "" : formatCartMoneyElementText(element, nextCents));
      rememberCartMoneyCents(element, nextCents, true);

      if (typeof settings.onComplete === "function") {
        settings.onComplete();
      }
      return;
    }

    const startedAt = window.performance && typeof window.performance.now === "function"
      ? window.performance.now()
      : Date.now();
    const animationState = {
      frameId: 0,
      currentCents: previousCents,
      targetCents: nextCents,
      shouldBlank,
      onComplete: settings.onComplete,
    };

    element.classList.add("is-counting");
    cartMoneyAnimationStateByElement.set(element, animationState);

    const tick = (timestamp) => {
      const now = Number.isFinite(timestamp)
        ? timestamp
        : window.performance && typeof window.performance.now === "function"
          ? window.performance.now()
          : Date.now();
      const progress = Math.min(1, Math.max(0, (now - startedAt) / CART_MONEY_ANIMATION_MS));
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentCents =
        progress >= 1 ? nextCents : Math.round(previousCents + (nextCents - previousCents) * easedProgress);

      animationState.currentCents = currentCents;
      rememberCartMoneyCents(element, currentCents, false);
      setCartUiText(element, formatCartMoneyElementText(element, currentCents));

      if (progress < 1) {
        animationState.frameId = window.requestAnimationFrame(tick);
        return;
      }

      element.classList.remove("is-counting");
      setCartUiText(element, shouldBlank ? "" : formatCartMoneyElementText(element, nextCents));
      rememberCartMoneyCents(element, nextCents, true);
      cartMoneyAnimationStateByElement.delete(element);

      if (typeof animationState.onComplete === "function") {
        animationState.onComplete();
      }
    };

    animationState.frameId = window.requestAnimationFrame(tick);
  }

  function cancelCartMoneyAnimation(element) {
    const animationState = cartMoneyAnimationStateByElement.get(element);
    if (!animationState) {
      return;
    }

    if (animationState.frameId && typeof window.cancelAnimationFrame === "function") {
      window.cancelAnimationFrame(animationState.frameId);
    }

    if (element instanceof HTMLElement) {
      element.classList.remove("is-counting");
    }
    cartMoneyAnimationStateByElement.delete(element);
  }

  function getCartMoneyPreviousCents(element) {
    if (!(element instanceof HTMLElement)) {
      return null;
    }

    const animationState = cartMoneyAnimationStateByElement.get(element);
    if (animationState && Number.isFinite(animationState.currentCents)) {
      return animationState.currentCents;
    }

    const animationKey = getCartMoneyAnimationKey(element);
    if (animationKey && Number.isFinite(cartMoneyLastCentsByKey[animationKey])) {
      return cartMoneyLastCentsByKey[animationKey];
    }

    const attributeCents = parseCentsCandidate(element.getAttribute("data-qk-cart-money-cents"));
    if (attributeCents != null) {
      return attributeCents;
    }

    const currentText = String(element.textContent || "").trim();
    return currentText ? parsePriceStringToCents(currentText) : null;
  }

  function rememberCartMoneyCents(element, cents, writeAttribute) {
    const normalizedCents = Math.max(0, Math.round(Number(cents) || 0));
    const animationKey = getCartMoneyAnimationKey(element);
    if (animationKey) {
      cartMoneyLastCentsByKey[animationKey] = normalizedCents;
    }

    if (writeAttribute && element instanceof HTMLElement) {
      element.setAttribute("data-qk-cart-money-cents", String(normalizedCents));
    }
  }

  function getCartMoneyAnimationKey(element) {
    if (!(element instanceof HTMLElement)) {
      return "";
    }

    return String(element.getAttribute("data-qk-cart-money-key") || "").trim();
  }

  function shouldAnimateCartMoney() {
    if (typeof window.requestAnimationFrame !== "function") {
      return false;
    }

    if (document.visibilityState === "hidden") {
      return false;
    }

    return !(
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function animateCartTrustCount() {
    const element = document.querySelector("[data-qk-cart-trust-count]");
    if (!(element instanceof HTMLElement)) {
      return;
    }

    const targetValue = Math.max(0, Math.round(Number(element.getAttribute("data-qk-cart-trust-target")) || 3000));
    cancelCartTrustCountAnimation();

    if (!shouldAnimateCartMoney()) {
      element.textContent = formatCartTrustCount(targetValue);
      return;
    }

    const startedAt = window.performance && typeof window.performance.now === "function"
      ? window.performance.now()
      : Date.now();

    element.textContent = "0";

    const tick = (timestamp) => {
      const now = Number.isFinite(timestamp)
        ? timestamp
        : window.performance && typeof window.performance.now === "function"
          ? window.performance.now()
          : Date.now();
      const progress = Math.min(1, Math.max(0, (now - startedAt) / CART_TRUST_COUNT_ANIMATION_MS));
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = progress >= 1 ? targetValue : Math.round(targetValue * easedProgress);

      element.textContent = formatCartTrustCount(currentValue);

      if (progress < 1 && isCartDrawerOpen()) {
        cartTrustCountAnimationFrame = window.requestAnimationFrame(tick);
        return;
      }

      element.textContent = formatCartTrustCount(targetValue);
      cartTrustCountAnimationFrame = 0;
    };

    cartTrustCountAnimationFrame = window.requestAnimationFrame(tick);
  }

  function cancelCartTrustCountAnimation() {
    if (!cartTrustCountAnimationFrame || typeof window.cancelAnimationFrame !== "function") {
      cartTrustCountAnimationFrame = 0;
      return;
    }

    window.cancelAnimationFrame(cartTrustCountAnimationFrame);
    cartTrustCountAnimationFrame = 0;
  }

  function formatCartTrustCount(value) {
    return CART_TRUST_COUNT_FORMATTER.format(Math.max(0, Math.round(Number(value) || 0)));
  }

  function formatCartMoneyElementText(element, cents) {
    const normalizedCents = Math.max(0, Math.round(Number(cents) || 0));
    const prefix = String(element.getAttribute("data-qk-cart-money-prefix") || "");
    const suffix = String(element.getAttribute("data-qk-cart-money-suffix") || "");
    const decimalMode = String(element.getAttribute("data-qk-cart-money-decimals") || "auto");
    const forceDecimals = decimalMode === "always";
    const hasBani = normalizedCents % 100 !== 0;
    const amount = new Intl.NumberFormat("ro-RO", {
      minimumFractionDigits: forceDecimals || hasBani ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(normalizedCents / 100);

    return `${prefix}${amount}${suffix}`;
  }

  function isPerfDebugEnabled() {
    const config = state.config || DEFAULT_RULES;
    return Boolean(
      config &&
        config.flags &&
        config.flags.log &&
        window.performance &&
        typeof window.performance.mark === "function" &&
        typeof window.performance.measure === "function",
    );
  }

  function markPerf(name) {
    if (!isPerfDebugEnabled()) {
      return;
    }

    const markName = `qk-cart-rules:${String(name || "").trim()}`;
    if (!markName.endsWith(":")) {
      window.performance.mark(markName);
    }
  }

  function measurePerf(label, startMark, endMark) {
    if (!isPerfDebugEnabled()) {
      return;
    }

    const normalizedLabel = String(label || "").trim();
    const start = `qk-cart-rules:${String(startMark || "").trim()}`;
    const end = `qk-cart-rules:${String(endMark || "").trim()}`;
    const measureName = `qk-cart-rules:${normalizedLabel}`;
    if (!normalizedLabel || start.endsWith(":") || end.endsWith(":")) {
      return;
    }

    try {
      window.performance.measure(measureName, start, end);
      const entries = window.performance.getEntriesByName(measureName);
      const latest = entries.length ? entries[entries.length - 1] : null;
      if (latest && Number.isFinite(latest.duration)) {
        debugLog("[qk-cart-rules][perf]", normalizedLabel, `${Math.round(latest.duration)}ms`);
      }
      window.performance.clearMeasures(measureName);
      window.performance.clearMarks(start);
      window.performance.clearMarks(end);
    } catch {
      // ignore measurement errors
    }
  }

  function debugLog() {
    const config = state.config || DEFAULT_RULES;
    if (!config.flags || !config.flags.log) {
      return;
    }

    try {
      console.log.apply(console, arguments);
    } catch {
      // no-op
    }
  }

  function reportError(error, fallbackMessage) {
    const message = error instanceof Error ? error.message : String(error || fallbackMessage || "Unknown error");
    console.error("[qk-cart-rules]", fallbackMessage || "Error", message);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
